(function (factory) {
  typeof define === 'function' && define.amd ? define('index', factory) :
  factory();
}((function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  var Responsive = function () {
    function Responsive() {
      var _this = this;

      _classCallCheck(this, Responsive);

      this.currentBreakpoint = Responsive.getCurrentBreakpoint();

      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();

        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }

        document.dispatchEvent(new CustomEvent('breakpoint:changed', { detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          } }));

        _this.currentBreakpoint = newBreakpoint;
      });
    }

    _createClass(Responsive, null, [{
      key: 'matchesBreakpoint',
      value: function matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
          case 'phone':
            return window.matchMedia('screen and (max-width: 767px)').matches;

          case 'tablet':
            return window.matchMedia('screen and (min-width: 768px) and (max-width: 991px)').matches;

          case 'tablet-and-up':
            return window.matchMedia('screen and (min-width: 768px)').matches;

          case 'pocket':
            return window.matchMedia('screen and (max-width: 991px)').matches;

          case 'lap':
            return window.matchMedia('screen and (min-width: 992px) and (max-width: 1279px)').matches;

          case 'lap-and-up':
            return window.matchMedia('screen and (min-width: 992px)').matches;

          case 'desk':
            return window.matchMedia('screen and (min-width: 1280px)').matches;

          case 'widescreen':
            return window.matchMedia('screen and (min-width: 1600px)').matches;

          case 'supports-hover':
            return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }
      }
    }, {
      key: 'getCurrentBreakpoint',
      value: function getCurrentBreakpoint() {
        if (window.matchMedia('screen and (max-width: 767px)').matches) {
          return 'phone';
        }

        if (window.matchMedia('screen and (min-width: 768px) and (max-width: 991px)').matches) {
          return 'tablet';
        }

        if (window.matchMedia('screen and (min-width: 992px) and (max-width: 1279px)').matches) {
          return 'lap';
        }

        if (window.matchMedia('screen and (min-width: 1280px)').matches) {
          return 'desk';
        }
      }
    }]);

    return Responsive;
  }();

  var Animation = function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }

    _createClass(Animation, null, [{
      /**
       * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
       * force an animation
       */
      key: "slideUp",
      value: function slideUp(element) {
        element.removeAttribute('data-animation');
        element.style.height = "".concat(element.scrollHeight, "px"); // Force previous height to allow CSS transition

        element.offsetHeight; // Force redraw

        element.style.height = 0;
      }
    }, {
      /**
       * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
       * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
       */
      key: "slideDown",
      value: function slideDown(element) {
        if (element.style.height === 'auto') {
          return;
        }

        element.setAttribute('data-animation', 'slide-down');
        
        // To do the animation we temporarily hide it, check the height, and transition to it
        element.style.height = "".concat(element.firstElementChild.scrollHeight, "px");

        var transitionEnded = function transitionEnded(event) {
          if (event.propertyName === 'height' && element.getAttribute('data-animation') === 'slide-down') {
            element.removeAttribute('data-animation');
            element.style.height = 'auto'; // Allows the content to grow normally
            element.removeEventListener('transitionend', transitionEnded);
          }
        };

        element.addEventListener('transitionend', transitionEnded);
      }
    }]);

    return Animation;
  }();

  /**
   * Various DOM helper
   */
  var Dom = function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }

    _createClass(Dom, null, [{
      /**
       * Get all the previous and next siblings, optionally filtered by a selector
       */
      key: "getSiblings",
      value: function getSiblings(element, filter) {
        var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var siblings = [];
        var currentElement = element; // Do the previous first

        while (currentElement = currentElement.previousElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        if (includeSelf) {
          siblings.push(element);
        }
        
        // Then the next side
        currentElement = element;

        while (currentElement = currentElement.nextElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        return siblings;
      }
    }, {
      /**
       * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
       * we need to normalize it
       */
      key: "nodeListToArray",
      value: function nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
          if (!filter || nodeList[i].matches(filter)) {
            items.push(nodeList[i]);
          }
        }

        return items;
      }
    }, {
      /**
       * Calculate an element width with its margin
       */
      key: "outerWidthWithMargin",
      value: function outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);
        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
      }
    }, {
      /**
       * Calculate an element height with its margin
       */
      key: "outerHeightWithMargin",
      value: function outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
      }
    }, {
      /**
       * Disable scrolling on the document
       */
      key: "disableDocumentScroll",
      value: function disableDocumentScroll(disable, element) {
        this.noScrollActivators = this.noScrollActivators || [];
        if (disable) {
          if (this.noScrollActivators.includes(element)) return;
          this.noScrollActivators.push(element);
          document.documentElement.classList.add('no-scroll');
        }
        else {
          if (!this.noScrollActivators.includes(element)) return;
          this.noScrollActivators = this.noScrollActivators.filter(item => item !== element);
          if (this.noScrollActivators.length === 0) document.documentElement.classList.remove('no-scroll');
        }
      }
    }]);

    return Dom;
  }();

  var Collapsible = function () {
    function Collapsible() {
      _classCallCheck(this, Collapsible);

      this.domDelegate = new domDelegate.Delegate(document.body);

      this._attachListeners();
      this.keyPressedListener = this._keyPressed.bind(this);
    }

    _createClass(Collapsible, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
      }
    }, {
      /**
       * Toggle a given collapsible
       */
      key: "_toggleCollapsible",
      value: function _toggleCollapsible(event, target) {
        // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
        const parentCollapsible = target.closest('.Collapsible');

        if (parentCollapsible.classList.contains('Collapsible--autoExpand') && Responsive.matchesBreakpoint('tablet-and-up')) {
          return;
        }

        const toggleButton = target.getAttribute('data-action') === 'toggle-collapsible' ? target : target.closest('[data-action="toggle-collapsible"]'),
              collapsibleInner = parentCollapsible.querySelector(`#${toggleButton.getAttribute('aria-controls')}`);
        const isOpen = toggleButton.getAttribute('aria-expanded') === 'true';

        const setCollapsibleHeightVariable = (inner) => {
          inner.style.setProperty('--collapsible-height', inner.firstElementChild.scrollHeight + 'px');
          inner.offsetHeight; // Force reflow
          inner.addEventListener('transitionend', this._transitionEnd.bind(this));
        };

        setCollapsibleHeightVariable(collapsibleInner);
        if (isOpen) {
          this._close(parentCollapsible);
        } else {
          this._open(parentCollapsible);
        }
        
        // We make sure to close any siblings collapsible as well
        Dom.getSiblings(parentCollapsible).forEach(collapsibleToClose => {
          if (!collapsibleToClose.classList.contains('Collapsible')) return;
          const collapsibleToCloseButton = collapsibleToClose.querySelector('[data-action="toggle-collapsible"]');
          if (collapsibleToCloseButton.getAttribute('aria-expanded') !== 'true') return;
          const collapsibleToCloseInner = collapsibleToClose.querySelector(`#${collapsibleToCloseButton.getAttribute('aria-controls')}`);
          setCollapsibleHeightVariable(collapsibleToCloseInner);
          return this._close(collapsibleToClose);
        });
        event.preventDefault();
      }
    }, {
      /**
       * Actions after open/close transition
       */
      key: "_transitionEnd",
      value: function _transitionEnd(e) {
        if (e.propertyName === 'height') {
          e.target.style.removeProperty('--collapsible-height');
          e.target.removeEventListener('transitionend', this._transitionEnd);
        }
      }
    }, {
      /**
       * Keyboard controls
       */
      key: "_keyPressed",
      value: function _keyPressed(e) {
        if (e.code !== 'Escape') return;
        
        let parentCollapsible = e.target.closest('.Collapsible'),
            toggleButton = parentCollapsible.querySelector('[data-action="toggle-collapsible"]');
        while (parentCollapsible && toggleButton.getAttribute('aria-expanded') !== 'true') {
          parentCollapsible = parentCollapsible.parentNode.closest('.Collapsible');
          toggleButton = parentCollapsible.querySelector('[data-action="toggle-collapsible"]');
        }
        if (parentCollapsible && toggleButton && toggleButton.getAttribute('aria-expanded') === 'true') {
          toggleButton.focus();
          this._toggleCollapsible(e, toggleButton);
          e.stopPropagation();
        }
      }
    }, {
      /**
       * Open a given collapsible
       */
      key: "_open",
      value: function _open(collapsible) {
        const toggleButton = collapsible.querySelector('[data-action="toggle-collapsible"]'),
              collapsibleInner = collapsible.querySelector(`#${toggleButton.getAttribute('aria-controls')}`);

        if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') return;

        toggleButton.setAttribute('aria-expanded', 'true');
        collapsibleInner.setAttribute('aria-hidden', 'false');
        collapsible.addEventListener('keydown', this.keyPressedListener);
        collapsible.dispatchEvent(new CustomEvent('collapsible:opened'));
      }
    }, {
      /**
       * Close a given collapsible
       */
      key: "_close",
      value: function _close(collapsible) {
        const toggleButton = collapsible.querySelector('[data-action="toggle-collapsible"]'),
              collapsibleInner = collapsible.querySelector(`#${toggleButton.getAttribute('aria-controls')}`);

        if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') return;

        toggleButton.setAttribute('aria-expanded', 'false');
        collapsibleInner.setAttribute('aria-hidden', 'true');
        collapsible.removeEventListener('keydown', this.keyPressedListener);
        collapsible.dispatchEvent(new CustomEvent('collapsible:closed'));
      }
    }]);

    return Collapsible;
  }();

  var Accessibility = function () {
    function Accessibility() {
      _classCallCheck(this, Accessibility);
    }

    _createClass(Accessibility, null, [{
      /**
       * Traps the focus in a particular container
       */
      key: "trapFocus",
      value: function trapFocus(container, namespace) {
        this.listeners = this.listeners || {};

        const focusableSelector = Accessibility.getFocusableSelector();
        
        const initialFocusableElements = Array.from(container.querySelectorAll(focusableSelector)).filter(el => !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length ));
        if (initialFocusableElements.length) initialFocusableElements[0].focus();

        if (this.listeners[namespace]) container.removeEventListener('keydown', this.listeners[namespace]);

        this.listeners[namespace] = event => {
          if (event.code !== 'Tab') return;
          const focusableElements = Array.from(container.querySelectorAll(focusableSelector)).filter(el => !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length ));
          if (!focusableElements.length) return;
          if (document.activeElement === focusableElements[focusableElements.length - 1] && !event.shiftKey || !container.contains(document.activeElement)) {
            focusableElements[0].focus();
            event.preventDefault();
          }
          else if (document.activeElement === focusableElements[0] && event.shiftKey) {
            focusableElements[focusableElements.length - 1].focus();
            event.preventDefault();
          }
        };

        container.addEventListener('keydown', this.listeners[namespace]);
      }
    }, {
      /**
       * Removes the trap of focus in a particular container
       */
      key: "removeTrapFocus",
      value: function removeTrapFocus(container, namespace) {
        if (container && this.listeners && this.listeners[namespace]) {
          container.removeEventListener('keydown', this.listeners[namespace]);
          delete this.listeners[namespace];
        }
      }
    }, {
      /**
       * Reset any previous trap focus
       */
      key: "clearTrapFocus",
      value: function clearTrapFocus() {
        for (var key in this.listeners) {
          if (this.listeners.hasOwnProperty(key)) {
            document.removeEventListener('focusin', this.listeners[key]);
          }
        }

        this.listeners = {};
      }
    }, {
      key: "getFocusableSelector",
      value: function getFocusableSelector() {
        return 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])';
      }
    }, {
      key: "initTabbing",
      value: function initTabbing() {
        const onMouseDown = () => {
          document.body.classList.remove('is-tabbing');
          document.removeEventListener('mousedown', onMouseDown);
          window.addEventListener('keydown', onKeyDown);
        };
        const onKeyDown = (e) => {
          if (e.keyCode !== 9) return;
          document.body.classList.add('is-tabbing');
          window.removeEventListener('keydown', onKeyDown);
          document.addEventListener('mousedown', onMouseDown);
        }
        window.addEventListener('keydown', onKeyDown);
      }
    }]);

    return Accessibility;
  }();

  var Localization = function () {
    function Localization() {
      _classCallCheck(this, Localization);

      this.initLocalizationForms();
      this.initLocalizationPopover();
      Localization.localizeUrls(document);
    }

    _createClass(Localization, [{
      key: "initLocalizationPopover",
      value: async function initLocalizationPopover() {
        const switzerlandPopover = document.querySelector('#switzerland-modal');
        if (!switzerlandPopover) return;
        const locationCountry = await Localization.getIpLocation();
        const selectedCountry = localStorage.getItem('themeSelectedLocation');
        const shopCountry = window.Shopify.country;
        if ((!selectedCountry && locationCountry === 'CH' && shopCountry !== 'CH') ||(selectedCountry == 'CH' && shopCountry !== 'CH')) {
          localStorage.setItem('themeSelectedLocation', 'DE');
          switzerlandPopover.dispatchEvent(new CustomEvent('theme:modal:open'), { bubbles: true });
        }
      }
    }, {
      key: "initLocalizationForms",
      value: async function initLocalizationPopover() {
        const forms = document.querySelectorAll('form[data-form="localization"]');
        forms.forEach(form => {
          const countrySelector = form.querySelector('select[name="country_code"]');
          if (countrySelector) {
            countrySelector.addEventListener('change', () => {
              form.querySelector('button[type="submit"]').click();
            });
          }
          form.addEventListener('submit', () => {
            const countryInput = form.querySelector('[name="country_code"]');
            if (!countryInput) return;
            localStorage.setItem('themeSelectedLocation', countryInput.value);
          });
        });
      }
    }], [{
      /**
       * Localize URLs for Switzerland that could not be localized automatically. This routine should probably be removed in the future after all URLs are correctly localized by default.
       */
      key: "localizeUrls",
      value: function localizeUrls(container) {
        const rootUrl = window.Shopify.routes.root.replace(/\/$/, '');
        if (!rootUrl) return;
        const links = container.querySelectorAll('a[href]');
        links.forEach(link => {
          const href = link.getAttribute('href');
          if (href.includes(location.origin) && ! href.includes(rootUrl)) {
            link.href = href.replace(location.origin, `${location.origin}${rootUrl}`); 
          }
          else if (href.startsWith('/') && !href.startsWith(rootUrl)) {
            link.href = `${rootUrl}${href}`;
          }
        });
      }
    }, {
      /**
       * Get the current estimated location
       */
      key: "getIpLocation",
      value: async function getIpLocation() {
        const storageCountry = localStorage.getItem('themeLocation');
        return storageCountry || new Promise((resolve, reject) => {
          const getCountryCode = () => {
            const countryCode = Shopify.customerPrivacy.getRegion().substring(0, 2);
            if (countryCode) localStorage.setItem('themeLocation', countryCode);
            return countryCode || 'DE'; // Default to Germany if no country code is found
          };
          if (Shopify.customerPrivacy) {
            resolve(getCountryCode());
          }
          else {
            window.addEventListener('theme:consentapi:ready', () => {
              resolve(getCountryCode());
            });
          }
        });
      }
    }]);

    return Localization;
  }();

  var Drawer = function () {
    function Drawer(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Drawer);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateBody = new domDelegate.Delegate(document.body);

      this.onOpen = options['onOpen'] || function () {};

      this.onClose = options['onClose'] || function () {};

      this.isOpen = false;
      this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';
      this.currentActivator = null;

      this._attachListeners();
    }

    _createClass(Drawer, [{
      key: "destroy",
      value: function destroy() {
        this.delegateBody.off('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
        this.delegateBody.off('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
        window.removeEventListener('resize', this._calculateMaxHeightListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open(event) {
        if (this.isOpen) {
          return;
        }

        // Init ajax sidebars
        if (this.element.hasAttribute('data-ajax-sections') && !this.element.hasAttribute('data-ajax-initialized')) this._initAjaxSidebar();
        
        // Make sure that the search is closed whenever a drawer is opened
        this.element.dispatchEvent(new CustomEvent('search:close', {
          bubbles: true
        }));

        // Only remove body scroll if no other drawer is open
        const otherOpenDrawer = document.querySelector('.Drawer[aria-hidden="false"]');
        if (!otherOpenDrawer) {
          Dom.disableDocumentScroll(true, this.element);
        }

        this.element.addEventListener('transitionend', this._transitionEndListener);

        this.element.setAttribute('aria-hidden', 'false');
        if (event) {
          event.preventDefault();
          this.currentActivator = event.target.getAttribute('data-drawer-id') === this.element.id ? event.target : event.target.closest(`[data-drawer-id="${this.element.id}"]`);
          if (this.currentActivator) this.currentActivator.setAttribute('aria-expanded', 'true');
        }

        this._calculateMaxHeight();

        document.querySelector('#shopify-section-shop-header').style.zIndex = ''; // Ugly hack

        // We attach an event to the page overlay to close it
        window.pageOverlay.open(this.element, { onClick: this._closeListener });
        this.isOpen = true;
        this.onOpen(this); // Call the callback to allow other code to hook their logic
      }
    }, {
      key: "close",
      value: function close(event) {
        if (!this.isOpen) {
          return;
        }

        if (event) {
          event.preventDefault();
        }

        this.element.setAttribute('aria-hidden', 'true');

        // Only reapply body scroll if no other drawer is open
        const otherOpenDrawer = document.querySelector('.Drawer[aria-hidden="false"]');
        if (!otherOpenDrawer) {
          Dom.disableDocumentScroll(false, this.element);
        }

        Accessibility.removeTrapFocus(this.element, this.element.id);
        if (this.currentActivator) {
          this.currentActivator.setAttribute('aria-expanded', 'false');
          if (document.body.classList.contains('is-tabbing')) this.currentActivator.focus();
          this.currentActivator = null;
        }
        window.pageOverlay.close(this.element);
        this.isOpen = false;
        this.onClose(); // Call the callback to allow other code to hook their logic
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._openListener = this.open.bind(this);
        this._closeListener = this.close.bind(this);
        this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
        this.delegateBody.on('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._openListener);
        this.delegateBody.on('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._closeListener);
        this.element.addEventListener('keydown', this._handleKeyboard.bind(this));
        window.addEventListener('resize', this._calculateMaxHeightListener);
        this._transitionEndListener = this._transitionEnd.bind(this);
      }
    }, {
      /**
       * Make sure that we force a max-height so that the drawer always stays on screen
       */
      key: "_calculateMaxHeight",
      value: function _calculateMaxHeight() {
        this.element.style.maxHeight = window.innerHeight + 'px';
      }
    }, {
      /**
       * Handle a11y events
       */
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.code === 'Escape') {
          this.close();
        }
      }
    }, {
      /**
       * Set focus after transition
       */
      key: "_transitionEnd",
      value: function _transitionEnd(event) {
        if (event.propertyName === 'visibility') {
          if (this.isOpen) Accessibility.trapFocus(this.element, this.element.id);
          this.element.removeEventListener('transitionend', this._transitionEndListener);
        }
      }
    }, {
      /**
       * Init ajax sidebars
       */
      key: "_initAjaxSidebar",
      value: function _initAjaxSidebar() {
        const contentContainer = this.element.querySelector('[data-ajax-container]');
        if (!contentContainer) return;

        contentContainer.classList.add('loading');

        const ajaxContext = this.element.getAttribute('data-ajax-context') || window.location.pathname,
              ajaxSections = this.element.getAttribute('data-ajax-sections');
        // Keep current search params because otherwise it won't work for draft product previews
        const searchParams = new URLSearchParams(window.location.search); 
        searchParams.append('sections', ajaxSections);
        const ajaxUrl = `${ajaxContext}?${searchParams.toString()}`;

        fetch(ajaxUrl, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Error loading popup ajax content');
          }
        }).then((sectionsJson) => {
          contentContainer.innerHTML = Array.from(Object.values(sectionsJson)).join('');

          this.element.setAttribute('data-ajax-initialized', 'true');

          const newScripts = contentContainer.getElementsByTagName("script"),
                scriptsToInsert = [];
          for (let i = 0; i < newScripts.length; i++) {
            const scriptContent = newScripts[i].text || newScripts[i].textContent || newScripts[i].innerHTML;
            if (scriptContent) {
              eval(scriptContent);
            }
            else if (newScripts[i].src) {
              const externalScript = document.createElement('script');
              externalScript.src = newScripts[i].src;
              if (newScripts[i].async) {
                externalScript.async = true;
              }
              scriptsToInsert.push({new: externalScript, old: newScripts[i]});
            }
          }
          scriptsToInsert.forEach((scripts) => {
            scripts.old.parentElement.insertBefore(scripts.new, scripts.old);
            scripts.old.remove();
          });

          contentContainer.classList.remove('loading');

        }).catch((error) => {
          console.error(error);
        });
      }
    }]);

    return Drawer;
  }();


  /**
   * Handles tab switches
   */
  var TabSwitch = function () {
    function TabSwitch(tabList, settings = {}) {
      _classCallCheck(this, TabSwitch);
      tabList.classList.add('tab-switch-initialized');
      this.tabList = tabList;
      this.element = tabList.closest('section, .Collapsible__Content');
      this.onSwitch = settings.onSwitch;
      this.switchListener = this._switchTab.bind(this);
      this._attachListeners();
    }

    _createClass(TabSwitch, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        const tabButtons = this.tabList.querySelectorAll('[data-action="toggle-tab"]');
        tabButtons.forEach((button) => {
          button.addEventListener('click', this.switchListener);
        });
      }
    }, {
      key: "_switchTab",
      value: function _switchTab(event) {
        const target = event.target.tagName === 'BUTTON' ? event.target : event.target.closest('button');

        // If the tab is already active, do nothing
        if (target.classList.contains('is-active')) {
          return;
        }
        
        // First, switch the current tab
        target.classList.add('is-active');
        Dom.getSiblings(target, '.is-active').forEach(function (item) {
          item.classList.remove('is-active');
        });
        
        // Then, display the panel
        var tabPanelToShow = this.element.querySelector("#".concat(target.getAttribute('aria-controls')));
        tabPanelToShow.setAttribute('aria-hidden', 'false');
        Dom.getSiblings(tabPanelToShow, '.tab-panel[aria-hidden="false"]').forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });

        // If there is a callback call it
        if (this.onSwitch) this.onSwitch();
      }
    }]);

    return TabSwitch;
  }();

  var Metafields = function () {
    function Metafields() {
      _classCallCheck(this, Metafields);
    
      document.addEventListener('customer:metafield:save', () => {
        Metafields.processQueue();
      });
      Metafields.processQueue();
    }

    _createClass(Metafields, null, [{
      key: "save",
      value: function save(path, id, value, callback) {
        const apiUrl = 'https://api.vitamoment.de/';
        fetch(apiUrl + path, {
          method: 'POST',
          body: JSON.stringify({
            id: id,
            value: value
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-Vm-Token': window.theme.customerToken,
            'X-Vm-Id': window.theme.customerId
          }
        }).then((response) => {
          if (callback) {
            callback(true);
          }
        }).catch((err) => {
          console.warn(err);
          if (callback) {
            callback(false);
          }
        });
      }
    }, {
      key: "processQueue",
      value: function processQueue() {
        window.cmq = window.cmq || [];
        const cmq = [...window.cmq];
        for (let i = 0; i < cmq.length; i++) {
          if (!cmq[i].path || !cmq[i].id || !cmq[i].value) continue;
          Metafields.save(cmq[i].path, cmq[i].id, cmq[i].value, cmq[i].callback);
          window.cmq.shift();
        }
      }
    }]);

    return Metafields;
  }();

  /**
   * Simple plugin that handles the loading bar actions
   *
   * This plugin uses delegate events so it's independent of the sections.
   */
  var LoadingBar = function () {
    function LoadingBar() {
      _classCallCheck(this, LoadingBar);

      this.element = document.querySelector('.LoadingBar');
      document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
      document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));
      this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
    }

    _createClass(LoadingBar, [{
      key: "_onLoadingStart",
      value: function _onLoadingStart() {
        this.element.classList.add('is-visible');
        this.element.style.width = '40%';
      }
    }, {
      key: "_onLoadingEnd",
      value: function _onLoadingEnd() {
        this.element.style.width = '100%';
        this.element.classList.add('is-finished');
      }
    }, {
      key: "_onTransitionEnd",
      value: function _onTransitionEnd(event) {
        if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
          this.element.classList.remove('is-visible');
          this.element.classList.remove('is-finished');
          this.element.style.width = '0';
        }
      }
    }]);

    return LoadingBar;
  }();

  var PageOverlay = function () {
    function PageOverlay() {
      this.element = document.querySelector('.PageOverlay--primary');
      this.initiators = new Map();
      this.closeButton = this.element.querySelector('.PageOverlay__Close');
      this.closeButton.addEventListener('click', () => {
        Array.from(this.initiators.values()).filter(options => options.onCloseClick).forEach(options => options.onCloseClick());
        this.close();
      });
      this.isOpen = false;
      this.isLoading = false;
      window.pageOverlay = this;
    }

    _createClass(PageOverlay, [{
      key: "open",
      value: function open(initiator, options = {}) {
        if (this.open && this.initiators.get(initiator) !== undefined) return;
        this.initiators.set(initiator, options);
        if (!this.isOpen) {
          this.isOpen = true;
          this.element.classList.add('is-visible');
        }
        if (options.onClick) this.element.addEventListener('click', options.onClick);
        if (!this.isLoading && options.loading) {
          this.element.classList.add('loading');
          if (this.closeButton) this.closeButton.classList.remove('none');
          this.isLoading = true;
        }
      }
    }, {
      key: "close",
      value: function close(initiator) {
        if (initiator) {
          const options = this.initiators.get(initiator);
          if (!options) return;
          if (options.onClick) this.element.removeEventListener('click', options.onClick);
          this.initiators.delete(initiator);
        }
        else {
          Array.from(this.initiators.values()).forEach((options) => {
            if (options.onClick) this.element.removeEventListener('click', options.onClick);
          });
          this.initiators.clear();
        }
        if (this.initiators.size === 0) {
          this.isOpen = false;
          this.element.classList.remove('is-visible');
          if (this.isLoading) {
            this.element.classList.remove('loading');
            if (this.closeButton) {
              this.closeButton.classList.add('none');
            }
            this.isLoading = false;
          }
        }
      }
    }]);

    return PageOverlay;
  }();

  var Modal = function () {
    function Modal() {
      _classCallCheck(this, Modal);

      this.domDelegate = new domDelegate.Delegate(document.body);
      this.activeModal = null; // Keep track of the active modal
      this.currentActivator = null; // Keep track of the activator button that opened the modal

      this.wasLocked = false;

      this._attachListeners();

      this._checkOpenByHash();
    }

    _createClass(Modal, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this._closeListener = this._closeModal.bind(this);
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this.onModalOpenEvent = this._openModalEvent.bind(this);
        this.domDelegate.on('click', '[data-action="open-modal"]', this.onModalOpenEvent);
        this.domDelegate.on('theme:modal:open', '.Modal', this.onModalOpenEvent, true);
        this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
      }
    }, {
      key: "_openModalEvent",
      value: async function _openModalEvent(event, target) {
        const targetIsModal = target.classList.contains('Modal');

        event.preventDefault();

        let modalContainer;
        if (targetIsModal) {
          modalContainer = target;
          this.currentActivator = document.activeElement || null;
        }
        else {
          modalContainer = document.getElementById(target.getAttribute('aria-controls'))
          this.currentActivator = target;
        }
        this._openModal(modalContainer);

        // Ajax popups
        if (modalContainer.hasAttribute('data-ajax-sections') && !modalContainer.hasAttribute('data-ajax-initialized')) this._loadAjaxContent(modalContainer, targetIsModal ? null : target);
      }
    }, {
      key: "_loadAjaxContent",
      value: async function _loadAjaxContent(modal, activator) {
        if (!modal.hasAttribute('data-ajax-sections') || modal.hasAttribute('data-ajax-initialized')) return;

        modal.classList.add('loading');

        // Set max height for modal growth animation until ajax content is loaded
        let loadingHeight = 0;
        const popupContentElements = modal.children;
        for (let i = 0; i < popupContentElements.length; i++) {
          loadingHeight += parseFloat(getComputedStyle(popupContentElements[i]).height);
        }
        modal.style.maxHeight = loadingHeight + 'px';

        const ajaxContext = modal.getAttribute('data-ajax-context') || window.location.pathname,
              ajaxSections = modal.getAttribute('data-ajax-sections'),
              ajaxUrl = `${ajaxContext}?sections=${ajaxSections}`;
        fetch(ajaxUrl, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Error loading popup ajax content');
          }
        }).then((sectionsJson) => {
          const contentContainer = modal.querySelector('[data-ajax-container="true"]');
          if (!contentContainer) return;

          contentContainer.innerHTML = Array.from(Object.values(sectionsJson)).join('');
          if (activator) this._insertUtm(activator);

          // Wistia videos
          document.dispatchEvent(new CustomEvent('theme:popup:htmlReplaced', { detail: { modal }}));
          modal.style.maxHeight = '';
          modal.classList.remove('loading');
          modal.setAttribute('data-ajax-initialized', 'true');

          const newScripts = contentContainer.getElementsByTagName("script"),
                scriptsToInsert = [];
          for (let i = 0; i < newScripts.length; i++) {
            if (newScripts[i].type && newScripts[i].type !== 'application/javascript' && newScripts[i].type !== 'text/javascript') continue;
            const scriptContent = newScripts[i].text || newScripts[i].textContent || newScripts[i].innerHTML;
            if (scriptContent) {
              try {
                eval(scriptContent);
              }
              catch (err) {
                console.error('Error evaluating script from ajax popup content', err);
              }
            }
            else if (newScripts[i].src) {
              const externalScript = document.createElement('script');
              externalScript.src = newScripts[i].src;
              if (newScripts[i].async) {
                externalScript.async = true;
              }
              scriptsToInsert.push({new: externalScript, old: newScripts[i]});
            }
          }
          scriptsToInsert.forEach((scripts) => {
            scripts.old.parentElement.insertBefore(scripts.new, scripts.old);
            scripts.old.remove();
          });
        }).catch((error) => {
          console.error(error);
        });
      }
    }, {
      key: '_insertUtm',
      value: function _insertUtm(activatorButton) {
        if (activatorButton.hasAttribute('data-utm')) {
          const utmModal = document.querySelector('#' + activatorButton.getAttribute('aria-controls'));
          if (utmModal) {
            const insertButtons = utmModal.querySelectorAll('.insert-utm');
            insertButtons.forEach((insertButton) => {
              let newUtm = activatorButton.getAttribute('data-utm'),
                  oldHref = insertButton.href,
                  newHref;
              oldHref = oldHref.replace('&amp;', '&').split('?');
              newHref = oldHref[0] + '?';
              if (oldHref.length == 1) {
                newHref += newUtm;
              }
              else {
                oldHref = oldHref[1].split('&');
                let params = '';
                for (let i = 0; i < oldHref.length; i++) {
                  if (!oldHref[i].includes('utm_')) {
                    if (params != '') {
                      params += '&';
                    }
                    params += oldHref[i];
                  }
                }
                if (params != '' && newUtm) {
                  params += '&';
                }
                newHref += params + newUtm;
              }
              insertButton.href = newHref;
            });
          }
        }
      }
    }, {
      key: "_openModal",
      value: function _openModal(modal) {
        var _this3 = this;

        if (this.activeModal || !modal) {
          return; // If there is already an open modal, we return as we only allows one modal at a time
        }

        this.activeModal = modal;
        this.domDelegate.on('keyup', this._handleKeyboardListener);

        if (document.documentElement.classList.contains('no-scroll')) {
          this.wasLocked = true;
        }

        fastdom.mutate(function () {
          Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover

          _this3._onTransitionEndedListener = _this3._onTransitionEnded.bind(_this3);
          _this3.activeModal.addEventListener('transitionend', _this3._onTransitionEndedListener);
          _this3.activeModal.setAttribute('aria-hidden', 'false');

          Dom.disableDocumentScroll(true, _this3.activeModal);
          
          // If the modal is not a fullscreen modal, then we also display the overlay
          if (!_this3.activeModal.classList.contains('Modal--fullScreen')) {
            window.pageOverlay.open('modal', { onClick: _this3._closeListener });
          }
        });
      }
    }, {
      key: "_closeModal",
      value: function _closeModal() {
        var _this2 = this;

        if (!this.activeModal) {
          return; // If no modal are open, we return immediately
        }

        this.activeModal.removeEventListener('keyup', this._handleKeyboardListener);
        this.domDelegate.off('keyup');
        fastdom.mutate(function () {
          // If the modal is of video type, we need to remove the iframe to stop the video
          if (_this2.activeModal.classList.contains('Modal--videoContent')) {
            _this2._resetVideoListener = _this2._resetVideo.bind(_this2);

            _this2.activeModal.addEventListener('transitionend', _this2._resetVideoListener);
          }

          Accessibility.removeTrapFocus(_this2.activeModal, 'modal');

          if (!_this2.activeModal.classList.contains('Modal--fullScreen')) {
            window.pageOverlay.close('modal');
          }

          if (!_this2.wasLocked) {
            Dom.disableDocumentScroll(false, _this2.activeModal);
          }

          _this2.activeModal.setAttribute('aria-hidden', 'true');
          _this2.activeModal = null;

          if (_this2.currentActivator) {
            if (document.body.classList.contains('is-tabbing')) _this2.currentActivator.focus();
            _this2.currentActivator = null;
          }
        });
      }
    }, {
      key: "_onTransitionEnded",
      value: function _onTransitionEnded(event) {
        if (event.propertyName !== 'visibility') {
          return;
        }

        Accessibility.trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)

        this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
      }
    }, {
      key: "_resetVideo",
      value: function _resetVideo(event) {
        if (event.propertyName !== 'visibility') {
          return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
        }

        var iframe = event.target.querySelector('iframe');
        iframe.parentNode.innerHTML = "<iframe class=\"Image--lazyLoad\" data-src=".concat(iframe.getAttribute('data-src'), " frameborder=\"0\" allowfullscreen>");
        event.target.removeEventListener('transitionend', this._resetVideoListener);
      }
    }, {
      /**
       * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
       */
      key: "_checkOpenByHash",
      value: function _checkOpenByHash() {
        var hash = window.location.hash,
            modal = document.getElementById(hash.replace('#', ''));

        if (modal && modal.classList.contains('Modal')) {
          // this._openModal(modal); // Old version did not trigger AJAX content load
          const ajaxButton = document.querySelector('button[data-action="open-modal"][aria-controls="' + hash + '"]');
          if (ajaxButton) {
            ajaxButton.click();
          }
        }
      }
    }, {
      /**
       * Handle a11y events
       */
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (null !== this.activeModal && event.code === 'Escape') {
          this._closeModal();
        }
      }
    }]);

    return Modal;
  }();

  var Popover = function () {
    function Popover(element, options) {
      _classCallCheck(this, Popover);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator = options['activator'] || document.querySelector('[aria-controls="' + element.getAttribute('id') + '"]');
      this.stickyActivator = options['stickyActivator'] || document.querySelector('[data-action="sync_variant"]') || false;
      this.section = options['section'] || 'product';
      this.preferredPosition = options['preferredPosition'] || 'bottom';
      this.preferredAlignment = options['preferredAlignment'] || undefined;
      this.threshold = options['threshold'] || 20;
      this.type = options['type'];
      this.isOpen = false;

      this.onValueChanged = options['onValueChanged'] || function () {};

      this.onOpen = options['onOpen'] || function () {};

      this.onClose = options['onClose'] || function () {};

      this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
      this.cartOverlayElements = document.querySelectorAll('.PageOverlay--cart');
      this.searchOverlayElements = document.querySelectorAll('.PageOverlay--search');

      this._attachListeners();
    }

    _createClass(Popover, [{
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener('keyup', this._handleKeyboardListener);
        this.delegateElement.off('click');
        this.delegateElement.off('focusout');
        if (this.activator) this.activator.removeEventListener('click', this._toggleListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "setLoading",
      value: function setLoading() {
        const _thisL = this;
        this.element.classList.add('loading');
        document.addEventListener('theme:loading:end', () => {
          _thisL.element.classList.remove('loading');
        }, { once: true });
      }
    }, {
      key: "open",
      value: function open() {
        var _this = this;
        // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
        //       popovers and be modified dynamically in JavaScript
        if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
          return;
        }
        this.element.setAttribute('aria-hidden', 'false');
        this.activator.setAttribute('aria-expanded', 'true');

        if (this.section !== 'cart') {
          Dom.disableDocumentScroll(true, this.element);
        }

        if (this.section !== 'cart' && this.section !== 'general' && Responsive.matchesBreakpoint('lap-and-up')) {
          if (this.stickyActivator && this.stickyActivator.hasAttribute('data-status') && this.stickyActivator.getAttribute('data-status') == 'active') {
            document.body.addEventListener('click', this._clickOutsideStickyListener);
            this._position(this.stickyActivator);
          }
          else {
            document.body.addEventListener('click', this._clickOutsideListener);
            this._position(false);
          }
          this.element.setAttribute('tabindex', '-1');
          this.element.addEventListener('transitionend', function () {
            _this.element.focus();
          }, {
            once: true
          });
        } else {
          this.element.removeAttribute('style');
          if (this.showOverlay) {
            window.pageOverlay.open(this.element, { onClick: this._closeListener });
            if (this.section === 'cart') {
              this.cartOverlayElements.forEach((pageOverlayElement) => {
                pageOverlayElement.classList.add('is-visible');
                pageOverlayElement.addEventListener('click', this._closeListener);
              });
            }
            else if (this.section === 'general') {
              // Handle search overlay if popover is opened from search
              const searchWidget = document.querySelector('.Search--modal');
              if (searchWidget.getAttribute('aria-hidden') === 'false') {
                this.searchOverlayElements.forEach((pageOverlayElement) => {
                  pageOverlayElement.classList.add('is-visible');
                  pageOverlayElement.addEventListener('click', this._closeListener);
                });
              }
            }
          }
        }
        
        // This can be used for adding our own functions when a certain event happens
        // some line above the onOpen function is defined
        this.onOpen(this); // Call the callback to allow other code to hook their logic
        this.isOpen = true;
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'true');
        this.activator.setAttribute('aria-expanded', 'false');

        if (this.section !== 'cart') {
          Dom.disableDocumentScroll(false, this.element);
        }

        if (this.section !== 'cart' && this.section !== 'general' && Responsive.matchesBreakpoint('lap-and-up')) {
          if (this.stickyActivator && this.stickyActivator.hasAttribute('data-status') && this.stickyActivator.getAttribute('data-status') == 'active') {
            document.body.removeEventListener('click', this._clickOutsideStickyListener);
            this.stickyActivator.setAttribute('data-status', 'inactive');
          }
          else {
            document.body.removeEventListener('click', this._clickOutsideListener);
          }
        } else if (this.showOverlay) {
          window.pageOverlay.close(this.element);
          if (this.section === 'cart') {
            this.cartOverlayElements.forEach((pageOverlayElement) => {
              pageOverlayElement.classList.remove('is-visible');
              pageOverlayElement.removeEventListener('click', this._closeListener);
            });
          }
          else if (this.section === 'general') {
            // Handle search overlay if popover is opened from search
            this.searchOverlayElements.forEach((pageOverlayElement) => {
              if (!pageOverlayElement.classList.contains('is-visible')) return;
              pageOverlayElement.classList.remove('is-visible');
              pageOverlayElement.removeEventListener('click', this._closeListener);
            });
          }
        }

        this.element.removeAttribute('tabindex');
        this.onClose(this); // Call the callback to allow other code to hook their logic
        this.isOpen = false;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        if (this.section !== 'cart') {
          this._handleKeyboardListener = this._handleKeyboard.bind(this);
          this._clickOutsideListener = this._clickOutside.bind(this);
          this._clickOutsideStickyListener = this._clickOutsideSticky.bind(this);
          
          this.element.addEventListener('keyup', this._handleKeyboardListener);
        }
        this._closeListener = this.close.bind(this);
        this._toggleListener = this.toggle.bind(this);

        if (this.activator) this.activator.addEventListener('click', this._toggleListener);

        this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
        this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));

        if (this.element.hasAttribute('id')) {
          this.delegateElement.on('focusout', '#' + this.element.getAttribute('id'), this._onFocusOut.bind(this));
        }
      }
    }, {
      /**
       * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
       * of the value change
       */
      key: "_valueChanged",
      value: function _valueChanged(event) {
        if (this.type === 'dynamic-popover' && window.theme.pageType !== 'cart') {
          const _this4 = this;
          this.setLoading();
          document.addEventListener('theme:loading:end', () => {
            _this4.close();
          }, { once: true });
        }

        const targetParent = event.target.closest('.button-wrapper');
        if (targetParent) {
          Dom.getSiblings(targetParent, '.button-wrapper').forEach(function (item) {
            const selectElement = item.querySelector('[data-action="select-value"]');
            if (selectElement) {
              return selectElement.classList.remove('is-selected');
            } 
          });
          const targetButton = targetParent.querySelector('[data-action="select-value"]');
          if (targetButton) {
            targetButton.classList.add('is-selected');
          } 

          // If there is a callback in option we call it with the value
          this.onValueChanged(targetButton.getAttribute('data-value'), targetButton, this.activator);
        }
        else {
          Dom.getSiblings(event.target, '.is-selected').forEach(function (item) {
            return item.classList.remove('is-selected');
          });
          event.target.classList.add('is-selected');

          // If there is a callback in option we call it with the value
          this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
        }
        
        if (this.type !== 'dynamic-popover' || window.theme.pageType === 'cart') {
          this.close();
        }
      }
    }, {
      key: "_onFocusOut",
      value: function _onFocusOut(event) {
        if (!event.target.getAttribute('data-action') === 'close-popover' && !this.element.contains(event.relatedTarget) && event.relatedTarget !== this.activator) {
          this.close();
        }
      }
    }, {
      /**
       * Callback that is called to decide if we should close the popover when a click is captured outside
       */
      key: "_clickOutside",
      value: function _clickOutside(event) {
        if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== this.activator && !this.activator.contains(event.target) && (!this.stickyActivator || (event.target !== this.stickyActivator && !this.stickyActivator.contains(event.target)))) {
          this.close();
        }
      }
    }, {
      key: '_clickOutsideSticky',
      value: function _clickOutsideSticky(event) {
        if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== this.activator && !this.activator.contains(event.target) && event.target !== this.stickyActivator && !this.stickyActivator.contains(event.target)) {
          this.close();
        }
      }
    }, {
      /**
       * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
       */
      key: "_position",
      value: function _position(otherActivator) {
        var _this3 = this;

        var topPosition = 0,
            rightPosition = 0,
            position = '',
            alignment = '',
            threshold = this.threshold;

        fastdom.measure(function () {
          var windowHeight = window.innerHeight,
              activatorBoundingRect = otherActivator ? otherActivator.getBoundingClientRect() : _this3.activator.getBoundingClientRect(),
              halfHeight = windowHeight / 2;

          if (_this3.preferredPosition === 'bottom') {
            alignment = 'right';

            if (_this3.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
              position = 'bottom';
            } else {
              position = 'top';
            }
          } else if (_this3.preferredPosition === 'top' || otherActivator) {
            alignment = 'right';

            if (_this3.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
              position = 'top';
            } else {
              position = 'bottom';
            }
          } else {
            position = 'left';

            // Is there enough space to use the center alignment (which is preferred)?
            var halfElementHeight = _this3.element.clientHeight / 2;

            if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'center';
            } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'bottom';
            } else {
              alignment = 'top';
            }
          }

          if (_this3.preferredAlignment) {
            alignment = _this3.preferredAlignment;
          }

          if (position === 'top') {
            topPosition = activatorBoundingRect.top - _this3.element.clientHeight - threshold;

            if (alignment === 'center') {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this3.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else if (position === 'bottom') {
            topPosition = activatorBoundingRect.bottom + threshold;

            if (alignment === 'center') {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this3.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else {
            rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;

            if (alignment === 'center') {
              topPosition = activatorBoundingRect.top - _this3.element.clientHeight / 2 + _this3.activator.clientHeight / 2;
            } else if (alignment === 'top') {
              topPosition = activatorBoundingRect.bottom - _this3.element.clientHeight;
            } else {
              topPosition = activatorBoundingRect.top;
            }
          }
        });

        fastdom.mutate(function () {
          ['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--positionLeft', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
            return _this3.element.classList.remove(item);
          });
          _this3.element.classList.add('Popover--position' + (position.charAt(0).toUpperCase() + position.slice(1)));
          _this3.element.classList.add('Popover--align' + (alignment.charAt(0).toUpperCase() + alignment.slice(1)));

          _this3.element.setAttribute('style', 'top: ' + parseInt(topPosition) + 'px; right: ' + parseInt(rightPosition) + 'px;');
        });
      }
    }, {
      /**
       * Handle a11y events
       */
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);

    return Popover;
  }();

  var Image = function () {
    function Image() {
      _classCallCheck(this, Image);
    }

    _createClass(Image, null, [{
      /**
       * Create a CDN URL (similar to the img_url filter in Liquid)
       */
      key: "getSizedImageUrl",
      value: function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === 'master') {
          return src.replace(/http(s)?:/, '');
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];
          return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
        } else {
          return null;
        }
      }
    }, {
      /**
       * From a given set of desired sizes and a given image, filter out any unwanted sizes
       */
      key: "getSupportedSizes",
      value: function getSupportedSizes(image, desiredSizes) {
        var supportedSizes = [],
            imageWidth = image['width'];
        desiredSizes.forEach(function (width) {
          if (imageWidth >= width) {
            supportedSizes.push(width);
          }
        });
        return supportedSizes;
      }
    }]);

    return Image;
  }();

  class ImageViewer {
    /**
     * @param {string} containerSelector
     * @param {object} options
     */
    constructor(containerSelector, options = {}) {
      const defaults = {
        maxZoomLevel: 500,
        maxZoomLevelButton: 300,
        minZoomLevel: 100,
        zoomStep: 50,
        wheelZoomStep: 0.7,
      };
      this.options = Object.assign({}, defaults, options);

      this.dialog = document.querySelector(containerSelector);
      if (!this.dialog) {
        console.error(
          `ImageViewer Error: Container "${containerSelector}" not found.`,
        );
        return;
      }

      this.zoomImage = this.dialog.querySelector("#zoom-image");
      this.imageWrapper = this.dialog.querySelector("#image-wrapper");
      this.minusButton = this.dialog.querySelector("#minus-button");
      this.plusButton = this.dialog.querySelector("#plus-button");
      this.closeButton = this.dialog.querySelector("#zoom-close-button");
      this.zoomPercentageDisplay = this.dialog.querySelector("#zoom-percentage");

      this.currentZoomLevel = this.options.minZoomLevel;
      this.isDragging = false;
      this.startPosX = 0;
      this.startPosY = 0;
      this.currentTranslateX = 0;
      this.currentTranslateY = 0;
      this.initialTranslateX = 0;
      this.initialTranslateY = 0;

      this._bindEvents();
    }

    /**
     * @private
     */
    _bindEvents() {
      this.closeButton.onclick = () => this.hide();
      this.plusButton.onclick = () => this.adjustZoom(1);
      this.minusButton.onclick = () => this.adjustZoom(-1);

      this.imageWrapper.addEventListener("mousedown", this.dragStart.bind(this));
      this.imageWrapper.addEventListener(
        "touchstart",
        this.dragStart.bind(this),
        { passive: true },
      );
      this.imageWrapper.addEventListener("mousemove", this.dragMove.bind(this));
      this.imageWrapper.addEventListener("touchmove", this.dragMove.bind(this), {
        passive: true,
      });
      this.imageWrapper.addEventListener("mouseup", this.dragEnd.bind(this));
      this.imageWrapper.addEventListener("mouseleave", this.dragEnd.bind(this));
      this.imageWrapper.addEventListener("touchend", this.dragEnd.bind(this));
      this.imageWrapper.addEventListener(
        "wheel",
        this.handleWheelZoom.bind(this),
      );
    }

    /**
     * @param {MouseEvent|TouchEvent} event
     */
    dragStart(event) {
      event.preventDefault();
      if (this.currentZoomLevel <= this.options.minZoomLevel) return;

      this.isDragging = true;
      this.zoomImage.classList.add("is-dragging");
      this.zoomImage.style.cursor = "grabbing";

      const { x, y } = this._getEventPosition(event);
      this.startPosX = x;
      this.startPosY = y;
      this.initialTranslateX = this.currentTranslateX;
      this.initialTranslateY = this.currentTranslateY;
    }

    /**
     * @param {MouseEvent|TouchEvent} event
     */
    dragMove(event) {
      event.preventDefault();
      if (!this.isDragging) return;

      const { x, y } = this._getEventPosition(event);
      const deltaX = x - this.startPosX;
      const deltaY = y - this.startPosY;
      const scale = this.currentZoomLevel / 100;

      this.currentTranslateX = this.initialTranslateX + deltaX / scale;
      this.currentTranslateY = this.initialTranslateY + deltaY / scale;

      this._updateTransform();
    }

    dragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.zoomImage.classList.remove("is-dragging");
      this.zoomImage.style.cursor = "grab";

      const scale = this.currentZoomLevel / 100;
      const wrapperRect = this.imageWrapper.getBoundingClientRect();
      const imageRect = this.zoomImage.getBoundingClientRect();

      const imgNaturalWidth = this.zoomImage.naturalWidth;
      const imgNaturalHeight = this.zoomImage.naturalHeight;
      const wrapperWidth = this.imageWrapper.clientWidth;
      const wrapperHeight = this.imageWrapper.clientHeight;

      const imgAspectRatio = imgNaturalWidth / imgNaturalHeight;
      const wrapperAspectRatio = wrapperWidth / wrapperHeight;

      let visualWidth, visualHeight;
      if (imgAspectRatio > wrapperAspectRatio) {
        visualWidth = wrapperWidth;
        visualHeight = visualWidth / imgAspectRatio;
      } else {
        visualHeight = wrapperHeight;
        visualWidth = visualHeight * imgAspectRatio;
      }

      const scaledVisualWidth = visualWidth * scale;
      const scaledVisualHeight = visualHeight * scale;

      let deltaX = 0;
      let deltaY = 0;

      if (scaledVisualWidth > wrapperRect.width) {
        const offsetX = (imageRect.width - scaledVisualWidth) / 2;
        const contentLeft = imageRect.left + offsetX;
        const contentRight = imageRect.right - offsetX;
        if (contentLeft > wrapperRect.left)
          deltaX = contentLeft - wrapperRect.left;
        else if (contentRight < wrapperRect.right)
          deltaX = contentRight - wrapperRect.right;
      } else {
        deltaX =
          imageRect.left +
          imageRect.width / 2 -
          (wrapperRect.left + wrapperRect.width / 2);
      }

      if (scaledVisualHeight > wrapperRect.height) {
        const offsetY = (imageRect.height - scaledVisualHeight) / 2;
        const contentTop = imageRect.top + offsetY;
        const contentBottom = imageRect.bottom - offsetY;
        if (contentTop > wrapperRect.top) deltaY = contentTop - wrapperRect.top;
        else if (contentBottom < wrapperRect.bottom)
          deltaY = contentBottom - wrapperRect.bottom;
      } else {
        deltaY =
          imageRect.top +
          imageRect.height / 2 -
          (wrapperRect.top + wrapperRect.height / 2);
      }

      if (deltaX !== 0) this.currentTranslateX -= deltaX / scale;
      if (deltaY !== 0) this.currentTranslateY -= deltaY / scale;

      this._updateTransform();
    }

    /**
     * @param {MouseEvent|TouchEvent} event
     * @returns {{x: number, y: number}}
     * @private
     */
    _getEventPosition(event) {
      if (event.touches) {
        return { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }
      return { x: event.clientX, y: event.clientY };
    }

    /**
     * @param {WheelEvent} event
     */
    handleWheelZoom(event) {
      event.preventDefault();
      const zoomDelta = event.deltaY * -this.options.wheelZoomStep;
      const newZoomLevel = this.currentZoomLevel + zoomDelta;
      this.setZoomLevel(newZoomLevel);
    }

    /**
     * @param {number} newLevel
     */
    setZoomLevel(newLevel) {
      const oldZoomLevel = this.currentZoomLevel;
      this.currentZoomLevel = Math.max(
        this.options.minZoomLevel,
        Math.min(this.options.maxZoomLevel, newLevel),
      );

      if (oldZoomLevel !== this.currentZoomLevel) {
        const scaleRatio = this.currentZoomLevel / oldZoomLevel;
        this.currentTranslateX *= scaleRatio;
        this.currentTranslateY *= scaleRatio;
      }

      this.zoomPercentageDisplay.innerText = `${Math.round(this.currentZoomLevel)}%`;

      const isMin = this.currentZoomLevel <= this.options.minZoomLevel;
      if (isMin) {
        this.currentTranslateX = 0;
        this.currentTranslateY = 0;
      }

      this._updateTransform();

      this.minusButton.disabled = isMin;
      this.plusButton.disabled =
        this.currentZoomLevel >= this.options.maxZoomLevelButton;

      const plusAriaBase = this.plusButton.getAttribute("data-aria-label");
      const minusAriaBase = this.minusButton.getAttribute("data-aria-label");
      this.plusButton.ariaLabel = `${plusAriaBase} ${Math.round(this.currentZoomLevel)}%`;
      this.minusButton.ariaLabel = `${minusAriaBase} ${Math.round(this.currentZoomLevel)}%`;
    }

    /**
     * @param {number} direction
     */
    adjustZoom(direction) {
      let newZoom = this.currentZoomLevel + direction * this.options.zoomStep;
      newZoom = Math.min(newZoom, this.options.maxZoomLevelButton);
      newZoom = Math.max(newZoom, this.options.minZoomLevel);
      this.setZoomLevel(newZoom);
    }

    /**
     * @private
     */
    _updateTransform() {
      const scale = this.currentZoomLevel / 100;
      this.zoomImage.style.transform = `scale(${scale}) translate(${this.currentTranslateX}px, ${this.currentTranslateY}px)`;
    }

    /**
     * @param {string} imageUrl
     */
    show(imageUrl) {
      this.zoomImage.src = imageUrl;
      this.zoomImage.classList.add("img-loading");
      this.zoomImage.onload = () => {
        this.zoomImage.classList.remove("img-loading");
      };
      this.setZoomLevel(this.options.minZoomLevel);
      this.dialog.showModal();
    }

    hide() {
      this.zoomImage.src = "";
      this.dialog.close();
    }
  }

  /**
   * This implementation allows to serialize a form
   */
  var Form = function () {
    function Form() {
      _classCallCheck(this, Form);
    }

    _createClass(Form, null, [{
      key: "serialize",
      value: function serialize(form) {
        function stringKey(key, value) {
          var beginBracket = key.lastIndexOf('[');

          if (beginBracket === -1) {
            var _hash = {};
            _hash[key] = value;
            return _hash;
          }

          var newKey = key.substr(0, beginBracket);
          var newValue = {};
          newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
          return stringKey(newKey, newValue);
        }

        var hash = {};
        var checkboxValues = {};

        for (var i = 0, len = form.elements.length; i < len; i++) {
          var formElement = form.elements[i];

          if (formElement.name === '' || formElement.disabled) {
            continue;
          }

          if (formElement.type === 'checkbox' && formElement.name && formElement.checked) {
            // Collect all checked checkboxes with the same name
            if (!checkboxValues[formElement.name]) {
              checkboxValues[formElement.name] = [];
            }
            checkboxValues[formElement.name].push(formElement.value);
            continue; // Don't add to hash yet
          }

          if (formElement.name && !formElement.disabled && (/select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
            var stringKeys = stringKey(formElement.name, formElement.value);
            hash = Form.extend(hash, stringKeys);
          }
        }

        // Add checkbox arrays to hash
        for (var key in checkboxValues) {
          const checkboxValue = checkboxValues[key].length === 1 ? checkboxValues[key][0] : checkboxValues[key];
          const stringKeys = stringKey(key, checkboxValue);
          hash = Form.extend(hash, stringKeys);
        }

        return hash;
      }
    }, {
      key: "extend",
      value: function extend() {
        var extended = {};
        var i = 0;
        
        // Merge the object into the extended object
        var merge = function merge(obj) {
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              // If property is an object, merge properties
              if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                extended[prop] = Form.extend(extended[prop], obj[prop]);
              } else {
                extended[prop] = obj[prop];
              }
            }
          }
        };
        
        // Loop through each object and conduct a merge
        for (; i < arguments.length; i++) {
          merge(arguments[i]);
        }

        return extended;
      }
    }]);

    return Form;
  }();

  var Currency = function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();

  /**
   * Handle the store availability management. The parameter is the div that will hold the content. The function
   * "updateWithVariant" must be called whenever the variant is changed.
   */
  var StoreAvailability = function () {
    function StoreAvailability(element, productTitle) {
      _classCallCheck(this, StoreAvailability);

      this.element = element;
      this.productTitle = productTitle;
      this.existingDrawers = {};
    }

    _createClass(StoreAvailability, [{
      key: "updateWithVariant",
      value: function updateWithVariant(variant) {
        if (!this.element) {
          return; // If the element to inject the store availability does not exist, we return immediately
        }
        
        // If the variant is null (for instance unavailable variant), we clear the container
        if (!variant) {
          this.element.textContent = '';
          return;
        }
        
        // If we have a new variant we render the section
        this._renderAvailabilitySection(variant['id']);
      }
    }, {
      key: "_renderAvailabilitySection",
      value: function _renderAvailabilitySection(id) {
        var _this = this;

        // First we clear the previous content
        this.element.innerHTML = '';
        
        // If there is already an element with the given modal we remove it first
        var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
        if (availabilityModal) {
          availabilityModal.remove();
        }

        if (this.existingDrawers["StoreAvailabilityModal-".concat(id)]) {
          this.existingDrawers["StoreAvailabilityModal-".concat(id)].destroy();
          delete this.existingDrawers["StoreAvailabilityModal-".concat(id)];
        }

        return fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(id, "?section_id=store-availability")).then(function (response) {
          return response.text().then(function (content) {
            _this.element.innerHTML = content;
            _this.element.innerHTML = _this.element.firstElementChild.innerHTML;
            
            // The product title is not rendered so we have to render it manually
            var productTitle = _this.element.querySelector('.store-availabilities-modal__product-title');

            if (productTitle) {
              productTitle.textContent = _this.productTitle;
            }
            
            // In order for our modal system to work we have to append the modal to the body instead
            var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
            document.body.appendChild(availabilityModal);
            
            // Create the drawer
            _this.existingDrawers["StoreAvailabilityModal-".concat(id)] = new Drawer(availabilityModal);
          });
        });
      }
    }]);

    return StoreAvailability;
  }();

  var ProductVariants = function () {
    function ProductVariants(container, options) {
      var _this = this;

      _classCallCheck(this, ProductVariants);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
      this.productData = jsonData['product'];
      this.templateSuffix = jsonData['template_suffix'];
      this.metafieldData = jsonData['metafield_amount'];
      this.variantMetafields = jsonData['variant_metafields'];
      this.variantsInventories = jsonData['inventories'] || {};
      this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData['id']));
      
      // We init value with the first selected variant
      this.productData['variants'].forEach(function (variant) {
        if (variant['id'] === jsonData['selected_variant_id']) {
          _this.currentVariant = variant;
          _this.option1 = variant['option1'];
          _this.option2 = variant['option2'];
          _this.option3 = variant['option3'];
        }
      });

      // Product launch discounts
      if (jsonData['launch_discount_prices']) {
        jsonData['launch_discount_prices'].forEach(function (discountVariant) {
          _this.productData.variants.forEach(function (variant) {
            if (variant.id === discountVariant.id) {
              variant.price = discountVariant.price;
              variant.compare_at_price = discountVariant.compare_at_price;
              variant.unit_price = discountVariant.unit_price;
            }
          });
        });
      }

      // Sticky add to cart
      this.stickyAddToCartButton = document.querySelector('[data-action="sync_add"]');
      this.stickyVariantButton = document.querySelector('[data-action="sync_variant"]');
      
      this.storeAvailability = new StoreAvailability(this.element.querySelector('.ProductMeta__StoreAvailabilityContainer'), this.productData['title']);
      this.storeAvailability.updateWithVariant(this.currentVariant);

      // Selling plans
      const sellingPlanSelector = this.element.querySelector('.ProductForm__SellingPlans');
      if (sellingPlanSelector) this.sellingPlans = new SellingPlans(sellingPlanSelector, jsonData);

      this._toggleStockElements(this.currentVariant);

      this._attachListeners();
      this._createSelectors();

      // Handbooks
      this._initHandbookSelector();
    }

    _createClass(ProductVariants, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off('click');
        this.formPopovers.forEach(function (popover) {
          return popover.destroy();
        });
        this.formVariantSelectors.forEach(function (selector) {
          return selector.destroy();
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
        this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
        this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
        this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this)); // Hook when a radio button change
        this.delegateElement.on('click', '[data-external="accept"]', this._externalAddToCart.bind(this));

        this.delegateElement.on('change', '.ProductForm__Option [type="radio"]:not([name*="advantage"])', this._onOptionChanged.bind(this));
        this.delegateElement.on('change', '.ProductForm__Option [type="radio"][name*="advantage"]', this._onAdvantageSelect.bind(this));

        // Sticky addToCart
        if (this.stickyAddToCartButton) {
          this.stickyAddToCartButton.addEventListener('click', this._stickyAddToCart.bind(this));
        }
        if (this.stickyVariantButton) {
          this.stickyVariantButton.addEventListener('click', this._stickyVariantChange.bind(this));
        }

        // Listener for selling plan change to update product prices
        window.addEventListener('theme:sellingplan:change', () => {
          this._updateProductPrices(this.currentVariant, null);
          this._updateUnitPrice(this.currentVariant);
        });
      }
    }, {
      /**
       * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
       */
      key: "_createSelectors",
      value: function _createSelectors() {
        var _this2 = this;

        // Create the instances for each selector
        this.formPopovers = [];
        this.formVariantSelectors = [];
        Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (item) {
          var popover = new Popover(item, {
            preferredPosition: 'left',
            onValueChanged: _this2._onOptionChanged.bind(_this2)
          });

          _this2.formPopovers.push(popover);
        });
      }
    }, {
      /**
       * ---------------------------------------------------------------------------------------------------
       * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
       *
       * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
       * edit this code
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * This callback is called whenever the variant changes and allows to update data about the active variant
       */
      key: "_onVariantChanged",
      value: function _onVariantChanged(previousVariant, newVariant) {
        // 1st: trigger selling plan update
        if (this.sellingPlans) this.sellingPlans._onVariantChange(newVariant);

        // 2nd: the prices
        this._updateProductPrices(newVariant, previousVariant);

        // 3rd: update inventory
        this._updateInventory(newVariant, previousVariant);

        // 4th: update the price measurement
        this._updateUnitPrice(newVariant, previousVariant);

        // 5th: the add to cart button
        this._updateAddToCartButton(newVariant, previousVariant);

        // 6th: store availability
        this.storeAvailability.updateWithVariant(newVariant);

        // 7th: show stock related elements
        this._toggleStockElements(newVariant);

        // 8th: update variant info boxes
        this._updateInfoBoxes(newVariant);

        // 9th: toggle advantage packages visibility
        this._updateAdvantagePackages(newVariant);

        // Finally, we send an event so that other system could hook and do their own logic
        this.element.dispatchEvent(new CustomEvent('variant:changed', {
          bubbles: true,
          detail: {
            variant: newVariant,
            previousVariant: previousVariant
          }
        }));
      }
    }, {
      /**
       * Update the prices (optionally showing compare at price)
       */
      key: "_updateProductPrices",
      value: function _updateProductPrices(newVariant, previousVariant) {
        const productMetaPriceWrapper = this.element.querySelector('.ProductMeta__PriceWrapper'),
              productMetaPrices = this.element.querySelector('.ProductMeta__PriceList'),
              currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

        if (!productMetaPrices) {
          return;
        }

        if (!newVariant) {
          if (productMetaPriceWrapper) productMetaPriceWrapper.style.display = 'none';
        } else {
          // if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
          //   return; // The price do not have changed so let's return to avoid changing the DOM for nothing
          // }

          const unitPriceElement = productMetaPrices.querySelector('.UnitPriceMeasurement');

          if (this.templateSuffix === 'club') {
            if (productMetaPriceWrapper) productMetaPriceWrapper.style.display = '';
            return;
          }

          productMetaPrices.innerHTML = '';

          const isSellingPlan = this.sellingPlans && this.sellingPlans.currentAllocation !== null,
                isPlanAndNoDiscount = isSellingPlan && this.sellingPlans.currentAllocation.price === this.sellingPlans.currentAllocation['compare_at_price'],
                price = isSellingPlan && !isPlanAndNoDiscount ? this.sellingPlans.currentAllocation.price : newVariant.price,
                compareAtPrice = isSellingPlan && !isPlanAndNoDiscount ? this.sellingPlans.currentAllocation['compare_at_price'] : newVariant['compare_at_price'],
                portionPriceData = newVariant && this.variantMetafields[newVariant.id].portions_total ? this.variantMetafields[newVariant.id] : null;
          
          const portionPriceLabel = this.element.querySelector('.PortionPriceLabel--extended');
          if (portionPriceLabel) {
            if (portionPriceData) {
              portionPriceLabel.classList.remove('none');
              portionPriceLabel.querySelectorAll('[data-portions-price]').forEach(element => {
                element.innerText = Currency.formatMoney(price / portionPriceData.portions_total, currencyFormat);
              });
              portionPriceLabel.querySelectorAll('[data-portions-name]').forEach(element => {
                element.innerText = portionPriceData.portions_name;
              });
              portionPriceLabel.querySelectorAll('[data-portions-name-plural]').forEach(element => {
                element.innerText = portionPriceData.portions_name === window.languages.day ? window.languages.days : window.languages.portions;
              });
              portionPriceLabel.querySelectorAll('[data-portions-total]').forEach(element => {
                element.innerText = portionPriceData.portions_total;
              });
            }
            else {
              portionPriceLabel.classList.add('none');
            }
          }
          if (compareAtPrice > price) {
            productMetaPrices.innerHTML += "<span class=\"PriceList__Item Price Price--highlight u-h2\" data-money-convertible>".concat(Currency.formatMoney(price, currencyFormat), "</span>");
            productMetaPrices.innerHTML += "<span class=\"PriceList__Item Price Price--compareAt u-h2\" data-money-convertible>".concat(Currency.formatMoney(compareAtPrice, currencyFormat), "</span>");
            let discountHtml = '<span class="PriceList__Item SaleLabel">';
            if (isSellingPlan && !isPlanAndNoDiscount) {
              const biggestAdjustment = this.sellingPlans.currentAllocation['price_adjustments'].reduce((prev, curr) => prev === null ? curr : prev.price < curr.price ? prev : curr, null),
                    discount = biggestAdjustment ? this.sellingPlans._stringifyPriceAdjustment(this.sellingPlans.currentPlan['price_adjustments'][biggestAdjustment.position - 1]) : null;
              if (discount) discountHtml += `Abo <span class="SeparatorDot"></span> du sparst ${this.sellingPlans.currentPlan['price_adjustments'].length == 2 ? 'bis zu ' : ''}<span class="SaleLabel__Value">${discount}</span>`;
            }
            else {
              const discount = Math.round((compareAtPrice - price) / compareAtPrice * 100);
              discountHtml += `Du sparst <span class="SaleLabel__Value">${discount}%</span>`;
            }
            discountHtml += '</span>';
            productMetaPrices.innerHTML += discountHtml;
          } else {
            productMetaPrices.innerHTML += `<span class="PriceList__Item Price u-h2" data-money-convertible>${Currency.formatMoney(price, currencyFormat)}</span>`;
          }
          if (isSellingPlan && price !== this.sellingPlans.currentAllocation['per_delivery_price']) productMetaPrices.innerHTML += `<span class="PriceList__Item SubscriptionPerDeliveryPrice">${Currency.formatMoney(this.sellingPlans.currentAllocation['per_delivery_price'], currencyFormat)} pro Lieferung</span>`;
          if (unitPriceElement) productMetaPrices.appendChild(unitPriceElement);

          if (productMetaPriceWrapper) productMetaPriceWrapper.style.display = '';
        }
      }
    }, {
      /**
       * Update the inventory (if needed)
       */
      key: "_updateInventory",
      value: function _updateInventory(newVariant) {
        if (!this.options['showInventoryQuantity']) {
          return;
        }

        var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
            variantInventory = newVariant ? this.variantsInventories[newVariant['id']] : null;

        if (!newVariant || null === variantInventory['inventory_management'] || variantInventory['inventory_quantity'] <= 0 || this.options['inventoryQuantityThreshold'] > 0 && variantInventory['inventory_quantity'] > this.options['inventoryQuantityThreshold']) {
          productFormInventory.style.display = 'none';
        } else {
          productFormInventory.innerHTML = variantInventory['inventory_message'];
          productFormInventory.style.display = '';
        }
      }
    }, {
      /**
       * Update the unit price
       */
      key: "_updateUnitPrice",
      value: function _updateUnitPrice(newVariant) {
        if (!newVariant) {
          return;
        }

        var unitPriceMeasurement = this.element.querySelector('.ProductMeta__PriceList .UnitPriceMeasurement');

        if (!unitPriceMeasurement) {
          return;
        }

        if (!newVariant.hasOwnProperty('unit_price')) {
          unitPriceMeasurement.classList.add('none');
          return;
        }

        unitPriceMeasurement.classList.remove('none');
        const unitPrice = this.sellingPlans && this.sellingPlans.currentAllocation ? this.sellingPlans.currentAllocation['unit_price'] : newVariant['unit_price'];
        unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = Currency.formatMoney(unitPrice, window.theme.moneyFormat);
        unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_unit'];
        var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
        unitPriceReferenceValue.textContent = newVariant['unit_price_measurement']['reference_value'];
        //unitPriceReferenceValue.style.display = newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline';
      }
    }, {
      /**
       * Update the add to cart
       */
      key: "_updateAddToCartButton",
      value: function _updateAddToCartButton(newVariant) {
        // For club products the button works different
        if (this.options.templateSuffix == 'club') {
          if (!newVariant) return;
          const activeButton = this.element.querySelector('[data-club-button="active"][data-lion-seamless-product-reward]'),
                inactiveButton = this.element.querySelector('[data-club-button="inactive"]');
          if (newVariant.available && activeButton && window.loyaltylion) {
            activeButton.setAttribute('data-variant-id', newVariant.id);
            activeButton.style.display = null;
            if (inactiveButton) inactiveButton.style.display = 'none';
            window.loyaltylion.ui.refresh();
            return;
          }
          if (activeButton) activeButton.style.display = 'none';
          if (inactiveButton) inactiveButton.style.display = null;
          return;
        }

        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
            shopifyPaymentButton = this.element.querySelector('.shopify-payment-button'),
            klaviyoButton = this.element.querySelector('.klaviyo-bis-trigger');

        if (addToCartButton) {
          if (!newVariant) {
            addToCartButton.setAttribute('disabled', 'disabled');
            addToCartButton.removeAttribute('data-action');
            addToCartButton.innerHTML = window.languages.productFormUnavailable;
            if (this.stickyAddToCartButton) {
              this.stickyAddToCartButton.setAttribute('disabled', 'disabled');
            }
            if (klaviyoButton) {
              klaviyoButton.style.display = 'none';
            }
          } else {
            if (newVariant['available']) {
              addToCartButton.removeAttribute('disabled');
              addToCartButton.setAttribute('data-action', 'add-to-cart');
              if (this.stickyAddToCartButton) {
                this.stickyAddToCartButton.removeAttribute('disabled');
              }
              if (klaviyoButton) {
                klaviyoButton.style.display = 'none';
              }

              addToCartButton.innerText = window.languages.productFormAddToCart;
            } else {
              addToCartButton.setAttribute('disabled', 'disabled');
              addToCartButton.removeAttribute('data-action');
              addToCartButton.innerText = window.languages.productFormSoldOut;
              if (this.stickyAddToCartButton) {
                this.stickyAddToCartButton.setAttribute('disabled', 'disabled');
              }
              if (klaviyoButton) {
                klaviyoButton.style.display = '';
              }
            }
          }
        }

        if (this.options['showPaymentButton'] && shopifyPaymentButton) {
          if (!newVariant || !newVariant['available']) {
            shopifyPaymentButton.style.display = 'none';
          } else {
            shopifyPaymentButton.style.display = 'block';
          }
        }
      }
    }, {
      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE VARIANT CHANGES
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * Whenever an option is changed, this code fetch the corresponding active variant
       */
      key: "_onOptionChanged",
      value: function _onOptionChanged(newValue, target, activator) {
        // We change the value associated with the activator, and check if we have a color swatch
        if (activator) {
          this['option' + target.getAttribute('data-option-position')] = newValue;
          activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
          // Custom variant selection
          const activatorImage = activator.querySelector('.ProductForm__Image');
          if (activatorImage) {
            if (activatorImage.hasAttribute('data-option-image-geschmack')) {
              activatorImage.setAttribute('data-option-image-geschmack', newValue);
            }
            else if (activatorImage.hasAttribute('data-option-image-menge')) {
              activatorImage.setAttribute('data-option-image-menge', newValue);
            }
            else if (activatorImage.hasAttribute('data-option-image-groesse')) {
              activatorImage.setAttribute('data-option-image-groesse', newValue);
            }
          }
          if (activator.classList.contains('ProductForm__Item--Geschmack')) {
            const stickyActivator = document.querySelector('.StickyAddToCart [data-action="sync_variant"]');
            if (stickyActivator) {
              stickyActivator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
              const stickyActivatorImage = stickyActivator.querySelector('.ProductForm__Image');
              if (stickyActivatorImage) {
                if (stickyActivatorImage.hasAttribute('data-option-image-geschmack')) {
                  stickyActivatorImage.setAttribute('data-option-image-geschmack', newValue);
                }
                else if (stickyActivatorImage.hasAttribute('data-option-image-menge')) {
                  stickyActivatorImage.setAttribute('data-option-image-menge', newValue);
                }
                else if (stickyActivatorImage.hasAttribute('data-option-image-groesse')) {
                  stickyActivatorImage.setAttribute('data-option-image-groesse', newValue);
                }
              }
            }
          }
        } else {
          this['option' + target.getAttribute('data-option-position')] = target.value;
          var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');

          if (selectedValue) {
            selectedValue.innerHTML = target.value;
          }
        }
        
        // Finally, we get the new variant
        var previousVariant = this.currentVariant;
        this.currentVariant = this._getCurrentVariantFromOptions();

        // Defer resource intensive operations to the next frame
        requestAnimationFrame(() => {
          setTimeout(() => {
            this._onVariantChanged(previousVariant, this.currentVariant);
          }, 0);
        });

        if (this.currentVariant) {
          if (this.options['enableHistoryState']) {
            this._updateHistoryState(this.currentVariant);
          }
          
          // We need to modify the hidden select that contain the id attribute as well
          this.masterSelector.querySelector('[selected]').removeAttribute('selected');
          this.masterSelector.querySelector("[value=\"".concat(this.currentVariant['id'], "\"]")).setAttribute('selected', 'selected');
          this.masterSelector.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      }
    }, {
      key: "_onAdvantageSelect",
      value: function _onAdvantageSelect(e) {
        const advantageValue = e.target.value;
        const pseudoVariantTitle = e.target.getAttribute('data-pseudo-title');
        const [ paidQuantity, freeQuantity ] = advantageValue.split('+').map(value => parseInt(value));
        const totalQuantity = paidQuantity + freeQuantity;
        let pseudoVariant;
        if (freeQuantity === undefined) {
          this.advantageQuantityMultiplier = undefined;
          pseudoVariant = JSON.parse(JSON.stringify(this.currentVariant));
          pseudoVariant.title = pseudoVariantTitle;
        }
        else {
          this.advantageQuantityMultiplier = totalQuantity;
          pseudoVariant = {
            id: pseudoVariantTitle,
            price: this.currentVariant.price * paidQuantity,
            compare_at_price: (this.currentVariant.compare_at_price || this.currentVariant.price) * totalQuantity,
            title: pseudoVariantTitle
          }
          if (this.currentVariant.unit_price) {
            const measurement = this.currentVariant.unit_price_measurement;
            const referenceFactor = measurement.quantity_unit === 'g' && measurement.reference_unit === 'kg' || measurement.quantity_unit === 'ml' && measurement.reference_unit === 'l' ? 1000 : 1;
            pseudoVariant.unit_price = pseudoVariant.price * (measurement.reference_value * referenceFactor / (measurement.quantity_value * totalQuantity));
            pseudoVariant.unit_price_measurement = {
              quantity_value: measurement.quantity_value * totalQuantity,
              reference_unit: measurement.reference_unit,
              reference_value: measurement.reference_value
            }
          }
          // Add dynamic portion data for pseudo variant
          if (!this.variantMetafields[pseudoVariant.id]) {
            const defaultPortionData = this.variantMetafields[Array.from(Object.keys(this.variantMetafields))[0]];
            if (defaultPortionData) {
              this.variantMetafields[pseudoVariant.id] = {
                portions_total: defaultPortionData.portions_total * totalQuantity,
                portions_name: defaultPortionData.portions_name,
                advantage_packages_enabled: true
              };
            }
          }
        }
        this._updateProductPrices(pseudoVariant);

        this._updateUnitPrice(pseudoVariant);

        this.element.dispatchEvent(new CustomEvent('advantage_package:changed', {
          bubbles: true,
          detail: {
            variant: pseudoVariant
          }
        }));
      }
    }, {
      /**
       * Get the active variant based on the options
       */
      key: "_getCurrentVariantFromOptions",
      value: function _getCurrentVariantFromOptions() {
        var _this3 = this;

        var found = false;
        this.productData['variants'].forEach(function (variant) {
          if (variant['option1'] === _this3.option1 && variant['option2'] === _this3.option2 && variant['option3'] === _this3.option3) {
            found = variant;
          }
        });
        return found || null;
      }
    }, {
      /**
       * Update the history state for browsers that support it
       */
      key: "_updateHistoryState",
      value: function _updateHistoryState(variant) {
        if (!history.replaceState) return;

        const search = new URLSearchParams(window.location.search);
        search.set('variant', variant.id);
        let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${search.toString()}`;
        if (this.sellingPlans && this.sellingPlans.currentPlan) newUrl = newUrl.concat("&selling_plan=", this.sellingPlans.currentPlan.id);
        window.history.replaceState({
          path: newUrl
        }, '', newUrl);
      }
    }, {
      key: '_toggleStockElements',
      value: function _toggleStockElements(variant) {
        const stockElements = this.element.querySelectorAll('[data-stock]');
        stockElements.forEach((element) => {
          const requiredStock = parseInt(element.getAttribute('data-stock')) || 0,
                variantStock = variant && variant.inventory_quantity || 0;
          if (variantStock >= requiredStock) {
            element.classList.remove('none');
          }
          else {
            element.classList.add('none');
          }
        });
      }
    }, {
      key: '_updateInfoBoxes',
      value: function _updateInfoBoxes(variant) {
        const infoBoxesContainer = document.querySelector('.Product__InfoBoxes');
        const currentlyVisibleBoxes = infoBoxesContainer.querySelectorAll('[data-variant-info-box]:not(.none)');
        if (currentlyVisibleBoxes.length) currentlyVisibleBoxes.forEach(box => box.classList.add('none'));
        const variantBoxes = infoBoxesContainer.querySelectorAll(`[data-variant-info-box="${variant.id}"].none`);
        if (variantBoxes.length) {
          variantBoxes.forEach(box => box.classList.remove('none'));
          infoBoxesContainer.classList.remove('none');
        }
        else if (!infoBoxesContainer.querySelectorAll('[data-product-info-box]').length) {
          infoBoxesContainer.classList.add('none');
        }
      }
    }, {
      key: '_initHandbookSelector',
      value: function _initHandbookSelector() {
        const handbookElements = this.element.querySelectorAll('.ProductForm__Handbook');
        if (!handbookElements.length) return;
        document.addEventListener('theme:cart:refreshed', e => {
          const itemVariantIds = e.detail.itemVariantIds;
          handbookElements.forEach(handbookElement => {
            const handbookCheckbox = handbookElement.querySelector('input[type="checkbox"]');
            if (!handbookCheckbox.disabled && itemVariantIds.includes(parseInt(handbookCheckbox.value))) {
              handbookElement.querySelector('.Checkbox').classList.add('Checkbox--disabled');
              handbookCheckbox.disabled = true;
              handbookCheckbox.checked = false;
              handbookElement.querySelector('[data-handbook-state="in_cart"]').classList.remove('none');
            }
            else if (handbookCheckbox.disabled && !itemVariantIds.includes(parseInt(handbookCheckbox.value))) {
              handbookElement.querySelector('.Checkbox').classList.remove('Checkbox--disabled');
              handbookCheckbox.disabled = false;
              handbookElement.querySelector('[data-handbook-state="in_cart"]').classList.add('none');
            }
          });
        });
      }
    }, {
      key: '_updateAdvantagePackages',
      value: function _updateAdvantagePackages(variant) {
        const advantageSelector = document.querySelector('.AdvantageVariantList');
        if (!advantageSelector) return;
        const advantageContainer = advantageSelector.closest('.ProductForm__Variants');
        if (this.variantMetafields[variant.id].advantage_packages_enabled) {
          advantageContainer.classList.remove('none');
        }
        else {
          advantageContainer.classList.add('none');
        }
      }
    }, {
      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
       * ---------------------------------------------------------------------------------------------------
       */
      key: "_addToCart",
      value: function _addToCart(event) {
        var _this4 = this;

        event.preventDefault(); // Prevent form to be submitted

        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart');

        // If we have 2 step add to cart for external products, return
        if (addToCartButton.getAttribute('data-external') === 'block') {
          const modalActivator = this.element.querySelector('#open-external-modal');
          if (modalActivator) modalActivator.click();
          return;
        }
        
        // First, we switch the status of the button
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        
        // Then we add the product in Ajax
        var formElement = this.element.querySelector('form[action*="/cart/add"]');
        const serializedForm = Form.serialize(formElement);
        if (this.advantageQuantityMultiplier) serializedForm.quantity *= this.advantageQuantityMultiplier;
        if (serializedForm.free_handbook) {
          const items = [
            { id: serializedForm.id, quantity: serializedForm.quantity }
          ];
          if (serializedForm.free_handbook instanceof Array) {
            for (let handbookId of serializedForm.free_handbook) {
              items.push({ id: handbookId, quantity: 1 });
            }
          }
          else {
            items.push({ id: serializedForm.free_handbook, quantity: 1 });
          }
          serializedForm.items = items;
          delete serializedForm.id;
          delete serializedForm.quantity;
          delete serializedForm.free_handbook;
        }
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(serializedForm),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          if (addToCartButton.hasAttribute('data-external')) addToCartButton.setAttribute('data-external', 'block');

          var quantityElement = formElement.querySelector('[name="quantity"]');

          if (response.ok) {
            InitFunctions.loyaltyCartChange(false);
            // We simply trigger an event so the mini-cart can re-render
            _this4.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this4.currentVariant,
                quantity: quantityElement ? parseInt(quantityElement.value) : 1
              }
            }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });
        event.preventDefault();
      }
    }, {
      key: "_externalAddToCart",
      value: function _externalAddToCart() {
        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart');
        addToCartButton.setAttribute('data-external', 'execute');
        addToCartButton.click();
      }
    }, {
      /**
       * ---------------------------------------------------------------------------------------------------
       * OTHER
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * When using the quantity selector, this can be used to decrease the quantity (be ensuring it won't be lower than 1)
       */
      key: "_decreaseQuantity",
      value: function _decreaseQuantity(event, target) {
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
        target.nextElementSibling.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, {
      /**
       * When using the quantity selector, this can be used to increase the quantity
       */
      key: "_increaseQuantity",
      value: function _increaseQuantity(event, target) {
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
        target.previousElementSibling.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, {
      /**
       * Make sure the quantity does not go below when manually changed
       */
      key: "_validateQuantity",
      value: function _validateQuantity(event, target) {
        target.value = Math.max(parseInt(target.value) || 1, 1);
        target.previousElementSibling.setAttribute('aria-disabled', target.value === '1' ? 'true' : 'false');
      }
    }, {
      key: '_stickyAddToCart',
      value: function _stickyAddToCart() {
        this.element.querySelector('[data-action="add-to-cart"]').click();
      }
    }, {
      key: '_stickyVariantChange',
      value: function _stickyVariantChange(event) {
        event.target.setAttribute('data-status', 'active');
        this.element.querySelector('button.ProductForm__Item--Geschmack').click();
      }
    }]);

    return ProductVariants;
  }();

  /**
   * Selling plan selector
   */
  var SellingPlans = function () {
    function SellingPlans(container, jsonData) {
      _classCallCheck(this, SellingPlans);

      if (jsonData.product['selling_plan_groups'].length === 0) return;

      this.element = container;
      const { product: jsonProduct, selected_variant_id: initialVariantId } = jsonData;
      this.productData = jsonProduct;
      this.currentVariant = null;
      this.currentPlan = null;
      this.currentAllocation = null;
      this.variantChanged = false;
      this.planInput = document.querySelector('.ProductForm input[name="selling_plan"]');
      this.sellingPlans = {};
      this.planElements = { default: {} };
      // Create object for easy lookup of selling plans
      this.productData['selling_plan_groups'].forEach((group) => {
        this.sellingPlans[group.id] = {};
        this.planElements[group.id] = { options: {} };
        group['selling_plans'].forEach((plan) => {
          this.sellingPlans[group.id][plan.id] = plan;
        });
      });
      // Create object for easy lookup of selling plan selector elements
      this.element.querySelectorAll('.SellingPlanGroup').forEach((groupElement) => {
        const groupData = this.planElements[groupElement.dataset['planGroupId']],
              plans = groupElement.querySelectorAll('input[name^="purchase_option"], select[name^="purchase_option"] option');
        groupData.element = groupElement;
        groupData.displayed = groupElement.hasAttribute('disabled') ? false : true;
        plans.forEach((plan) => {
          const option = plan.closest('[data-option-name]').dataset.optionName;
          groupData.options[option] = groupData.options[option] || {};
          groupData.options[option][plan.value] = {};
          groupData.options[option][plan.value].element = plan;
          groupData.options[option][plan.value].displayed = plan.hasAttribute('disabled') ? false : true;
          groupData.options[option][plan.value].show = false;
        });
      });
      
      // Find currently selected variant
      for (let i = 0; i < this.productData.variants.length; i++) {
        const variant = this.productData.variants[i];
        if (variant.id === initialVariantId) {
          this.currentVariant = variant;
          break;
        }
      }

      this.element.querySelectorAll('[name^="purchase_option"]').forEach((input) => {
        input.addEventListener('change', this._onPlanSelect.bind(this));
      });
      this.element.querySelectorAll('input[name="selling_plan_group"]').forEach((input) => {
        input.addEventListener('change', this._onGroupSelect.bind(this));
      });
    }

    _createClass(SellingPlans, [{
      key: "_onVariantChange",
      value: function _onVariantChange(variant) {
        this.currentVariant = variant;
        if (!variant) {
          this.element.classList.add('none');
          return;
        }
        this.variantChanged = true;
        this.currentVariant['selling_plan_allocations'].forEach((allocation) => {
          const plan = this.sellingPlans[allocation['selling_plan_group_id']][allocation['selling_plan_id']];
          plan.options.forEach((option) => {
            const optionEntry = this.planElements[allocation['selling_plan_group_id']].options[option.name][option.value];
            optionEntry.show = true;
          });
        });
        this._refreshPlans();
        this.variantChanged = false;
      }
    }, {
      key: "_onPlanSelect",
      value: function _onPlanSelect(e) {
        const groupElement = e.target.closest('.SellingPlanGroup'),
              groupRadio = groupElement.querySelector('input[name="selling_plan_group"]'),
              optionPosition = e.target.dataset.position,
              optionValue = e.target.value,
              groupData = this.sellingPlans[groupElement.dataset.planGroupId],
              planArray = Array.from(Object.entries(groupData));
        for (let i = 0; i < planArray.length; i++) {
          const [, plan] = planArray[i],
                planOptionValue = plan.options[optionPosition - 1].value;
          if (optionValue === planOptionValue) {
            this._selectPlan(plan);
            break;
          }
        }
        if (!groupRadio.checked) {
          groupRadio.checked = true;
          this._onGroupDeselect(this.element.querySelector('.SellingPlanGroup.active'));
          groupElement.classList.add('active');
        }
        const activeOption = groupElement.querySelector('.SellingPlanGroup__SellingPlan.active');
        if (activeOption) activeOption.classList.remove('active');
        if (e.target.tagName === 'INPUT') e.target.closest('.SellingPlanGroup__SellingPlan').classList.add('active');
        this._updatePlanDetails(groupElement);
        document.querySelectorAll('[data-noplan]').forEach((element) => {
          element.classList.add('none');
        });
      }
    }, {
      key: "_onGroupSelect",
      value: function _onGroupSelect(e) {
        const activeCollapsibleOpener = this.element.querySelector('[data-action="toggle-collapsible"][aria-expanded="true"]'),
              groupElement = e.target.closest('.SellingPlanGroup'),
              collapsibleOpener = groupElement.querySelector('[data-action="toggle-collapsible"]');
        this._onGroupDeselect(this.element.querySelector('.SellingPlanGroup.active'));
        groupElement.classList.add('active');
        if (groupElement.dataset.planGroupId !== 'default') {
          const groupData = this.planElements[groupElement.dataset.planGroupId],
                valueElement = Array.from(Object.values(Array.from(Object.values(groupData.options))[0]))[0].element;
          if (valueElement.tagName === 'OPTION') {
            const selectElement = valueElement.closest('select');
            selectElement.value = valueElement.value;
            selectElement.dispatchEvent(new Event('change'));
          }
          else {
            valueElement.click();
          }
        }
        else {
          const checkedRadio = this.element.querySelector('input[name^="purchase_option"]:checked');
          if (checkedRadio) checkedRadio.checked = false;
          this._selectPlan(null);
          document.querySelectorAll('[data-noplan]').forEach((element) => {
            element.classList.remove('none');
          });
        }
        if (collapsibleOpener && collapsibleOpener.getAttribute('aria-expanded') === 'true') return;
        if (activeCollapsibleOpener && !collapsibleOpener) activeCollapsibleOpener.click();
        if (collapsibleOpener) collapsibleOpener.click();
      }
    }, {
      key: "_onGroupDeselect",
      value: function _onGroupDeselect(group) {
        group.classList.remove('active');
        const previousPlan = group.querySelector('.SellingPlanGroup__SellingPlan.active');
        if (previousPlan) {
          previousPlan.classList.remove('active');
          const checkedRadio = previousPlan.querySelector('input[name^="purchase_option"]:checked');
          if (checkedRadio) checkedRadio.checked = false;
        }
        const contentElement = group.querySelector('.SellingPlanGroup__Content'),
              removeContent = () => {
                contentElement.querySelector('.SellingPlanGroup__PriceAdjustments').innerText = '';
                contentElement.querySelector('.SellingPlanGroup__Description').innerText = '';
              };
        if (contentElement) {
          if (group.querySelector('[data-action="toggle-collapsible"]').getAttribute('aria-expanded') === 'true') {
            // Remove content after transition ended. 'transitionend' event not possible because it does not fire correctly when the whole element gets hidden in between
            setTimeout(removeContent, 400);
          }
          else {
            removeContent();
          }
        }
      }
    }, {
      key: "_selectPlan",
      value: function _selectPlan(plan) {
        this.currentPlan = plan;
        this.currentAllocation = null;
        this.planInput.value = plan ? plan.id : '';
        const search = new URLSearchParams(window.location.search);
        let url = null;
        if (plan !== null) {
          this.currentAllocation = this.currentVariant['selling_plan_allocations'].reduce((prev, curr) => {
            return prev ? prev : curr['selling_plan_id'] === plan.id ? curr : null;
          }, null);
          search.set('selling_plan', plan.id);
          if (!search.has('variant')) search.set('variant', this.currentVariant.id);
          url = window.location.protocol + "//" + window.location.host + window.location.pathname;
          if (Array.from(search.keys()).length > 0) url += '?' + search.toString();
        }
        else if (search.has('selling_plan')) {
          search.delete('selling_plan');
          url = window.location.protocol + "//" + window.location.host + window.location.pathname;
          if (Array.from(search.keys()).length > 0) url += '?' + search.toString();
        }
        if (url) window.history.replaceState({ path: url }, '', url);
        if (!this.variantChanged) window.dispatchEvent(new CustomEvent('theme:sellingplan:change'));
      }
    }, {
      key: "_selectFirstAvailablePlan",
      value: function _selectFirstAvailablePlan() {
        if (this.element.classList.contains('none')) {
          this._selectPlan(null);
          return;
        }
        let exitLoop = false;
        Object.entries(this.planElements).forEach(([groupId, group]) => {
          if (exitLoop) return;
          if (group.displayed) {
            if (groupId === 'default') {
              group.element.querySelector('input[name="selling_plan_group"]').click();
              exitLoop = true;
            }
            else {
              Object.values(group.options).forEach((option) => {
                if (exitLoop) return;
                Object.values(option).forEach((optionValue) => {
                  if (exitLoop) return;
                  if (optionValue.displayed) {
                    if (optionValue.element.tagName === 'OPTION') {
                      const selectElement = optionValue.element.closest('select');
                      selectElement.value = optionValue.element.value;
                      selectElement.dispatchEvent(new Event('change'));
                    }
                    else {
                      optionValue.element.click();
                    }
                    exitLoop = true;
                  }
                });
              });
            }
          }
        });
      }
    }, {
      key: "_stringifyPriceAdjustment",
      value: function _stringifyPriceAdjustment(priceAdjustment) {
        if (priceAdjustment['value_type'] === 'percentage') {
          return `${priceAdjustment.value}%`.replace('.', ',');
        }
        else if (priceAdjustment['value_type'] === 'fixed_amount') {
          return Currency.formatMoney(priceAdjustment.value, window.theme.moneyFormat);
        }
        else if (priceAdjustment['value_type'] === 'price') {
          return Currency.formatMoney(priceAdjustment.value - this.currentAllocation['compare_at_price'], window.theme.moneyFormat);
        }
      }
    }, {
      key: "_updatePlanDetails",
      value: function _updatePlanDetails(group) {
        if (!this.currentPlan) return;
        const detailsElement = group.querySelector('.SellingPlanGroup__Details'),
              adjustments = this.currentPlan['price_adjustments'];
        let adjustmentsHtml = '';
        if (adjustments.length <= 1) {
          const deliveryHtml = `${Currency.formatMoney(this.currentAllocation['per_delivery_price'], window.theme.moneyFormat)} pro Lieferung`;
          adjustmentsHtml = adjustmentsHtml.concat(deliveryHtml);
          if (adjustments.length === 1 && adjustments.reduce((prev, curr) => prev || curr.value !== 0, false)) {
            const paymentHtml = ` <span class="SeparatorDot"></span> du sparst <span class="SellingPlanGroup__PriceAdjustmentsDiscount">${this._stringifyPriceAdjustment(adjustments[0])}</span>`;
            adjustmentsHtml = adjustmentsHtml.concat(paymentHtml);
          }
        }
        else {
          const secondDiscountHtml = `, dann <span class="SellingPlanGroup__PriceAdjustmentsDiscount">${this._stringifyPriceAdjustment(adjustments[1])}</span> bei allen weiteren Zahlungen`;
          let mainHtml = `<span class="SellingPlanGroup__PriceAdjustmentsAbsolute">
                ${adjustments[0]['order_count'] === 1 ? 'Erste Zahlung' : 'Erste ' + adjustments[0]['order_count'] + ' Zahlungen'}
                ${Currency.formatMoney(this.currentAllocation['price_adjustments'][0].price, window.theme.moneyFormat)},
                dann ${adjustments[1]['order_count'] === null ? 'jede Zahlung' : adjustments[1]['order_count'] + ' Zahlungen'}
                ${Currency.formatMoney(this.currentAllocation['price_adjustments'][1].price, window.theme.moneyFormat)}
              </span><br><span class="SellingPlanGroup__PriceAdjustmentsRelative">Du sparst
                <span class="SellingPlanGroup__PriceAdjustmentsDiscount">`;
          if (adjustments[0]['value'] === 0) {
            mainHtml += `${this._stringifyPriceAdjustment(adjustments[1])}</span> ab der ${adjustments[0]['order_count'] + 1}. Zahlung`;
          }
          else {
            mainHtml += `${this._stringifyPriceAdjustment(adjustments[0])}</span> ${adjustments[0]['order_count'] === 1 ? 'bei der ersten Zahlung' : 'bei den ersten ' + adjustments[0]['order_count'] + ' Zahlungen'}${adjustments[1].value !== 0 ? secondDiscountHtml : ''}
            </span>`;
          }
          adjustmentsHtml = adjustmentsHtml.concat(mainHtml);
        }
        detailsElement.querySelector('.SellingPlanGroup__PriceAdjustments').innerHTML = adjustmentsHtml;
        if (this.currentPlan.description) {
          detailsElement.querySelector('.SellingPlanGroup__Description').innerText = this.currentPlan.description;
        }
        else {
          detailsElement.querySelector('.SellingPlanGroup__Description').innerText = '';
        }
      }
    }, {
      key: "_refreshPlans",
      value: function _refreshPlans() {
        let hideAllPlans = true;
        Object.entries(this.planElements).forEach(([groupId, group]) => {
          if (groupId === 'default') {
            if (group.displayed && this.currentVariant['requires_selling_plan']) {
              group.displayed = false;
              group.setAttribute('disabled', 'disabled');
            }
            else if (!group.displayed && !this.currentVariant['requires_selling_plan']) {
              group.displayed = true;
              group.element.removeAttribute('disabled');
            }
          }
          else {
            let hideGroup = true;
            Object.values(group.options).forEach((option) => {
              Object.values(option).forEach((optionValue) => {
                if (optionValue.displayed && !optionValue.show) {
                  optionValue.displayed = false;
                  optionValue.element.setAttribute('disabled', 'disabled');
                }
                else if (!optionValue.displayed && optionValue.show) {
                  optionValue.displayed = true;
                  optionValue.element.removeAttribute('disabled');
                }
                if (optionValue.show) {
                  optionValue.show = false;
                  hideGroup = false;
                }
                if (group.element.querySelector('input[name="selling_plan_group"]').checked && ((optionValue.element.tagName === 'OPTION' && optionValue.element.value === optionValue.element.closest('select').value) || (optionValue.tagName !== 'OPTION' && optionValue.element.checked))) {
                  if (optionValue.displayed) {
                    if (optionValue.element.tagName === 'OPTION') {
                      const selectElement = optionValue.element.closest('select');
                      selectElement.dispatchEvent(new Event('change'));
                    }
                    else {
                      optionValue.element.dispatchEvent(new Event('change'));
                    }
                  }
                  else {
                    this._selectFirstAvailablePlan();
                  }
                }
              });
              
              if (group.displayed && hideGroup) {
                group.displayed = false;
                group.element.setAttribute('disabled', 'disabled');
              }
              else if (!group.displayed && !hideGroup) {
                group.displayed = true;
                group.element.removeAttribute('disabled');
              }
              if (!hideGroup) hideAllPlans = false;
            });
          }
        });
        if (!this.element.classList.contains('none') && hideAllPlans) {
          this.element.classList.add('none');
        }
        else if (this.element.classList.contains('none') && !hideAllPlans) {
          this.element.classList.remove('none');
        }
      }
    }]);

    return SellingPlans;
  }();

  var ProductVideo = function () {
    function ProductVideo(element, enableVideoLooping) {
      _classCallCheck(this, ProductVideo);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.enableVideoLooping = enableVideoLooping;
      this.player = null;

      switch (this.element.getAttribute('data-media-type')) {
        case 'video':
          var stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
          document.head.appendChild(stylesheet);
          window.Shopify.loadFeatures([{
            name: 'video-ui',
            version: '1.0',
            onLoad: this._setupHtml5Video.bind(this)
          }]);
          break;

        case 'external_video':
          this._setupExternalVideo();
          break;

        case 'wistia_slider_video':
          this.wistiaVideo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          break;
      }
    }

    _createClass(ProductVideo, [{
      key: "destroy",
      value: function destroy() {
        if (this.player) {
          this.player.destroy(); // Both Plyr and YouTube API use the same name
        }
        else if (this.wistiaVideo) {
          this.wistiaVideo.remove();
        }
      }
    }, {
      key: "hasBeenSelected",
      value: function hasBeenSelected() {
        // As per guidelines, we only need to autoplay when it's not a touch device
        if (Responsive.matchesBreakpoint('supports-hover')) {
          this.play();
        }
      }
    }, {
      key: "hasBeenDeselected",
      value: function hasBeenDeselected() {
        this.pause();
      }
    }, {
      key: "play",
      value: function play() {
        switch (this.element.getAttribute('data-media-type')) {
          case 'video':
            this.player.play();
            break;

          case 'external_video':
            this.player.playVideo();
            break;

          case 'wistia_slider_video':
            if (this.wistiaVideo && this.wistiaVideo.state() !== 'playing') {
              this.wistiaVideo.play();
            }
            break;
        }
      }
    }, {
      key: "pause",
      value: function pause() {
        switch (this.element.getAttribute('data-media-type')) {
          case 'video':
            this.player.pause();
            break;

          case 'external_video':
            this.player.pauseVideo();
            break;

          case 'wistia_slider_video':
            if (this.wistiaVideo && this.wistiaVideo.state() === 'playing') {
              this.wistiaVideo.pause();
            }
            break;
        }
      }
    }, {
      key: "_setupHtml5Video",
      value: function _setupHtml5Video() {
        var _this = this;

        this.player = new Shopify.Plyr(this.element.querySelector('video'), {
          controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
          loop: {
            active: this.enableVideoLooping
          },
          hideControlsOnPause: true,
          clickToPlay: true,
          iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
          tooltips: {
            controls: false,
            seek: true
          }
        });
        this.player.on('play', function () {
          _this.element.dispatchEvent(new CustomEvent('video:played', {
            bubbles: true
          }));
        });
        this.player.on('pause', function () {
          _this.element.dispatchEvent(new CustomEvent('video:paused', {
            bubbles: true
          }));
        });
      }
    }, {
      key: "_setupExternalVideo",
      value: function _setupExternalVideo() {
        if (this.element.getAttribute('data-video-host') === 'youtube') {
          this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
        }
      }
    }, {
      key: "_setupYouTubePlayer",
      value: function _setupYouTubePlayer() {
        var _this2 = this;

        var playerLoadingInterval = setInterval(function () {
          if (window.YT !== undefined && window.YT.Player !== undefined) {
            _this2.player = new YT.Player(_this2.element.querySelector('iframe'), {
              videoId: _this2.element.getAttribute('data-video-id'),
              events: {
                onStateChange: function onStateChange(event) {
                  if (event.data === window.YT.PlayerState.PLAYING) {
                    _this2.element.dispatchEvent(new CustomEvent('video:played', {
                      bubbles: true
                    }));
                  } else if (event.data === YT.PlayerState.PAUSED) {
                    _this2.element.dispatchEvent(new CustomEvent('video:paused', {
                      bubbles: true
                    }));
                  }

                  if (event.data === window.YT.PlayerState.ENDED && _this2.enableVideoLooping) {
                    event.target.seekTo(0);
                  }
                }
              }
            });
            clearInterval(playerLoadingInterval);
          }
        }, 50);
      }
    }, {
      key: "_loadYouTubeScript",
      value: function _loadYouTubeScript() {
        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = '//www.youtube.com/iframe_api';
        });
      }
    }]);

    return ProductVideo;
  }();

  /**
   * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
   */
  var ScrollSpy = function () {
    function ScrollSpy(container, elementsToSpy, observerOptions) {
      var _this = this;

      _classCallCheck(this, ScrollSpy);

      this.container = container;
      this.targets = [];
      this.targetIndices = {};
      this.indicesInViewPort = [];
      this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);
      elementsToSpy.forEach(function (elementToSpy, index) {
        _this.targets.push(elementToSpy);
        _this.targetIndices[elementToSpy.id] = index;
        _this.observer.observe(elementToSpy);
      });
    }

    _createClass(ScrollSpy, [{
      key: "destroy",
      value: function destroy() {
        this.observer.disconnect();
      }
    }, {
      /**
       * Called whenever there is a change of visibility
       */
      key: "_onIntersectionChange",
      value: function _onIntersectionChange(changes) {
        var oldTargetIndex = this.indicesInViewPort[0] || 0;

        for (var i = changes.length - 1; i >= 0; i--) {
          this._updateIndicesInViewPort(changes[i], oldTargetIndex);
        }
        
        // Firefox generates duplicates so make sure to remove
        this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });

        if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
          return;
        }

        var event = new CustomEvent('scrollspy:target:changed', {
          detail: {
            newTarget: this.targets[this.indicesInViewPort[0]],
            oldTarget: this.targets[oldTargetIndex]
          }
        });
        this.container.dispatchEvent(event);
      }
    }, {
      /**
       * Update indices visible in the view port
       */
      key: "_updateIndicesInViewPort",
      value: function _updateIndicesInViewPort(change, oldTargetIndex) {
        var index = this.targetIndices[change.target.id];

        if (change.intersectionRatio === 0) {
          var indexInViewPort = this.indicesInViewPort.indexOf(index);

          if (indexInViewPort !== -1) {
            this.indicesInViewPort.splice(indexInViewPort, 1);
          }
        } else {
          if (index < oldTargetIndex) {
            this.indicesInViewPort.unshift(index);
          } else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
            this.indicesInViewPort.push(index);
          } else {
            this.indicesInViewPort.push(index);
            this.indicesInViewPort.sort();
          }
        }
      }
    }]);

    return ScrollSpy;
  }();

  var SearchBar = function () {
    function SearchBar() {
      _classCallCheck(this, SearchBar);

      this.documentDelegate = new domDelegate.Delegate(document.body);
      this.searchElement = document.getElementById('search');
      if (!this.searchElement) return;
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.isOpen = false;
      this.currentActivator = null;

      this._attachListeners();
    }

    _createClass(SearchBar, [{
      key: "destroy",
      value: function destroy() {
        this.documentDelegate.off();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
        this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
        this.searchElement.addEventListener('keydown', this._onKeyPress.bind(this));
        this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
        document.addEventListener('theme:search:changed', e => {
          InitFunctions.initButtonLoading(e.detail);
        });
      }
    }, {
      /**
       * Listen to escape key press to close search
       */
      key: "_onKeyPress",
      value: function _onKeyPress(event) {
        if (event.key === 'Escape' && this.isOpen) {
          this._closeSearch();
          event.preventDefault();
        }
      }
    }, {
      /**
       * Open the search form and trap focus
       */
      key: "_openSearch",
      value: function _openSearch(event) {
        event.preventDefault();

        // Resource loading on first open
        if (!window.themeSearch) {
          const searchScript = document.createElement('script');
          document.head.appendChild(searchScript);
          searchScript.src = window.routes.searchScriptUrl;
          const searchStyles = document.createElement('link');
          searchStyles.rel = 'stylesheet';
          document.head.appendChild(searchStyles);
          searchStyles.href = window.routes.searchStylesUrl;
        }

        this.searchElement.setAttribute('aria-hidden', 'false');
        this.currentActivator = event.target;
        this.currentActivator.setAttribute('aria-expanded', 'true');
        
        let fakeInput;
        if (('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
          // workaround for iOS Safari from https://stackoverflow.com/questions/12204571/mobile-safari-javascript-focus-method-on-inputfield-only-works-with-click/55652503#55652503
          fakeInput = document.createElement('input');
          fakeInput.setAttribute('type', 'text');
          fakeInput.style.position = 'absolute';
          fakeInput.style.opacity = 0;
          fakeInput.style.height = 0;
          fakeInput.style.fontSize = '16px';
          document.body.prepend(fakeInput);
          fakeInput.focus();
        }

        const transitionEndListener = () => {
          Accessibility.trapFocus(this.searchElement, 'search');
          if (fakeInput) {
            fakeInput.remove();
          }
          this.searchElement.removeEventListener('transitionend', transitionEndListener);
        };

        this.searchElement.addEventListener('transitionend', transitionEndListener);
        this.isOpen = true;
        Dom.disableDocumentScroll(true, this.searchElement);
        window.pageOverlay.open(this.searchElement, { onClick: this._closeSearch.bind(this) });
        document.dispatchEvent(new CustomEvent('search:afteropen'));
      }
    }, {
      /**
       * Close the search form and clear focus
       */
      key: "_closeSearch",
      value: function _closeSearch() {        
        if (!this.isOpen) {
          return;
        }

        Accessibility.removeTrapFocus(this.searchElement, 'search');
        this.searchElement.setAttribute('aria-hidden', 'true');
        if (this.currentActivator) {
          this.currentActivator.setAttribute('aria-expanded', 'false');
          this.currentActivator.focus();
          this.currentActivator = null;
        }
        this.isOpen = false;

        // var onTransitionEnd = function onTransitionEnd(event) {
        //   if (event.propertyName === 'visibility') {
        //     window.pageOverlay.element.removeEventListener('transitionend', onTransitionEnd);
        //   }
        // };

        Dom.disableDocumentScroll(false, this.searchElement);
        // window.pageOverlay.element.addEventListener('transitionend', onTransitionEnd);
        window.pageOverlay.close(this.searchElement);
        document.dispatchEvent(new CustomEvent('search:afterclose'));
      }
    }]);

    return SearchBar;
  }();

  var ScrollList = function () {
    function ScrollList(element) {
      _classCallCheck(this, ScrollList);
      this.element = element;
      this.options = {};
      if (this.element.hasAttribute('data-options')) {
        try {
          this.options = JSON.parse(this.element.getAttribute('data-options'));
        }
        catch(e) {
          console.error('Unable to parse options from scrolllist', this.element);
        }
      }
      this.scrollBox = element.querySelector('.scroll-list__content');
      this.leftButton = element.querySelector('.scroll-list__nav--left');
      this.rightButton = element.querySelector('.scroll-list__nav--right');
      if (this.options.wheelScroll !== false) {
        this._onScrollListener = this._onScroll.bind(this);
        this.scrollBox.addEventListener('wheel', (e) => this._onScrollListener(e));
      }
      if (this.leftButton) this.leftButton.addEventListener('click', () => {
        const minOffset = this.scrollBox.scrollLeft * -1;
        this.scroll(Math.max(minOffset, -250), true);
      });
      if (this.rightButton) this.rightButton.addEventListener('click', () => {
        const maxOffset = this.scrollBox.scrollWidth - this.scrollBox.clientWidth;
        this.scroll(Math.min(maxOffset, 250), true);
      });
      this.element.addEventListener('theme:hsl:refresh', this.refresh.bind(this));
      this.leftObserver = this.createObserver(this.leftButton);
      this.rightObserver = this.createObserver(this.rightButton);
      this.dragging = false;
      this.scrollableLeft = false;
      this.scrollableRight = false;
      this.scrollBox.addEventListener('mousedown', this._onDragStart.bind(this));
      document.documentElement.addEventListener('mouseup', this._onDragEnd.bind(this));
      document.documentElement.addEventListener('mouseleave', this._onDragEnd.bind(this));
      document.documentElement.addEventListener('mousemove', this._onDrag.bind(this));
      // Prevent link default dragging behavior
      this.element.addEventListener('dragstart', (e) => {
        if (e.target.tagName === 'A' || e.target.tagName === 'IMG') e.preventDefault();
      });
      this.refresh();
    }

    _createClass(ScrollList, [{
      key: "destroy",
      value: function destroy() {
        this.leftObserver.disconnect();
        this.rightObserver.disconnect();
      }
    }, {
      key: "_onScroll",
      value: function _onScroll(e) {
        if (!this.scrollableLeft && !this.scrollableRight) return;
        e.preventDefault();
        const position = e.deltaY > 0 ? 50 : -50;
        this.scroll(position, false);
      }
    }, {
      key: "_onDragStart",
      value: function _onDragStart() {
        this.dragging = 1;
      }
    }, {
      key: "_onDragEnd",
      value: function _onDragEnd() {
        this.dragging = false;
        this.element.classList.remove('dragging');
      }
    }, {
      key: "_onDrag",
      value: function _onDrag(e) {
        if (!this.dragging || !this.scrollableLeft && !this.scrollableRight) return;
        if (this.dragging < 5) {
          this.dragging++;
        }
        else if (this.dragging === 5) {
          this.element.classList.add('dragging');
          this.dragging = 6;
        }
        if (this.dragging === 6) e.preventDefault();
        this.scroll(e.movementX * -1, false);
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.leftObserver.disconnect();
        this.rightObserver.disconnect();
        this.items = this.element.querySelectorAll('.scroll-list__item');
        if (this.items.length <= 1) return;
        this.items.forEach(item => {
          item.removeAttribute('data-position');
        })
        this.items[0].setAttribute('data-position', 'left');
        this.leftObserver.observe(this.items[0]);
        this.items[this.items.length - 1].setAttribute('data-position', 'right');
        this.rightObserver.observe(this.items[this.items.length - 1]);
      }
    }, {
      key: "createObserver",
      value: function createObserver(target) {
        return new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (target) target.classList.toggle('is-visible', !entry.isIntersecting);
            if (entry.target.getAttribute('data-position') === 'left') {
              this.element.classList.toggle('scrollable--left', !entry.isIntersecting);
              this.scrollableLeft = !entry.isIntersecting;
            }
            if (entry.target.getAttribute('data-position') === 'right') {
              this.element.classList.toggle('scrollable--right', !entry.isIntersecting);
              this.scrollableRight = !entry.isIntersecting;
            }
          });
        }, {
          root: this.element,
          rootMargin: '100% 0px 100% 0px',
          threshold: 0.99
        });
      }
    }, {
      key: "scroll",
      value: function scroll(offset, smooth) {
        this.scrollBox.scrollBy({
          left: offset,
          behavior: smooth ? 'smooth' : 'auto'
        });
      }
    }]);

    return ScrollList;
  }();

  var TableOfContents = function () {
    function TableOfContents(summaryContainers, contentContainer, properties = {}) {
      _classCallCheck(this, TableOfContents);

      this.summarys = summaryContainers;
      this.content = contentContainer;
      this.onScroll = properties.additionalOnScroll;
      this.activeSelector = properties.activeSelector;
      this.scrollListener = this._scrollListener.bind(this);

      this.init();
      document.addEventListener('theme:navigation:change', this.init.bind(this));

      // Define scroll properties
      this.scrollProperties = {
        windowY: window.scrollY,
        currentAnchor: null,
        scrollingTo: null
      };

      // Initialize scroll listener
      window.addEventListener('scroll', this.scrollListener, { passive: true });
      this._scrollListener();
    }

    _createClass(TableOfContents, [{
      key: "destroy",
      value: function destroy() {
        window.removeEventListener('scroll', this.scrollListener);
      }
    }, {
      key: "init",
      value: function init() {
        this.anchorMap = new Map();
        this.anchors = [];
        this.links = [];
  
        // Build the anchor map
        const anchors = this.content.querySelectorAll('.Anchor');
        anchors.forEach((anchor) => {
          this.anchorMap.set(anchor, []);
          this.anchors.push(anchor);
        });
        this.summarys.forEach((summary) => {
          const links = summary.querySelectorAll('.toc-link:not([href="#%anchor%"])');
          links.forEach((link) => {
            this.links.push(link);
            const anchor = this.content.querySelector(new URL(link.href).hash);
            if (anchor) this.anchorMap.get(anchor).push(link);
            link.addEventListener('click', (e) => {
              let aElement = e.target;
              if (aElement.nodeName !== 'A') {
                aElement = e.target.closest('a');
              }
              this.scrollProperties.scrollingTo = this.content.querySelector(new URL(aElement.href).hash);
            });
          });
        });
  
        // Remove unused anchors
        this.anchorMap.forEach((value, key) => {
          if (value.length > 0) return;
          this.anchorMap.delete(key);
          this.anchors.splice(this.anchors.indexOf(key), 1);
        });
      }
    }, {
      key: "_scrollListener",
      value: function _scrollListener() {
        const props = this.scrollProperties;
        props.windowY = window.scrollY;
        for (let i = this.anchors.length - 1; i >= 0; i--) {
          const anchorOffset = this.anchors[i].getBoundingClientRect().top;
          if (anchorOffset > 10) continue;
          if (props.currentAnchor !== props.scrollingTo && (this.anchors[i] == props.currentAnchor || (props.scrollingTo !== null && props.scrollingTo !== this.anchors[i]))) break;
          props.scrollingTo = null;
          props.currentAnchor = this.anchors[i];
          this.links.forEach((link) => {
            if (this.activeSelector) {
              link.closest(this.activeSelector).classList.remove('is-active');
              link.classList.remove('is-active'); // Always remove class from link due to collapsible functionality
            }
            else {
              link.classList.remove('is-active');
            }
          });
          const activeLinks = this.anchorMap.get(this.anchors[i]);
          activeLinks.forEach((link) => {
            const collapsible = link.closest('.Collapsible');
            let collapsibleButton = null,
                collapsibleInner = null;
            if (collapsible) {
              collapsibleButton = collapsible.querySelector('[data-action="toggle-collapsible"]');
              if (collapsibleButton.getAttribute('aria-expanded') === 'false') {
                collapsibleButton.click();
              }
              // If link is in collapsible inner, additionally add active class to it
              collapsibleInner = link.closest('.Collapsible__Inner');
              if (this.activeSelector) {
                link.closest(`${this.activeSelector}[data-toc-level="1"]`).classList.add('is-active');
                if (collapsibleInner) link.closest(this.activeSelector).classList.add('is-active');
              }
              else {
                link.classList.add('is-active');
              }
            }
            else {
              if (this.activeSelector) {
                link.closest(this.activeSelector).classList.add('is-active');
              }
              else {
                link.classList.add('is-active');
              }
            }
            const closestToc = link.closest('.TableOfContents');
            if (closestToc) {
              // Scroll to current link, quite complex due to collapsible functionality and different locations of toc in sidebar and popover
              const topLevelLink = (collapsibleInner && this.activeSelector) ? collapsibleInner.closest(this.activeSelector) : this.activeSelector ? link.closest(this.activeSelector) : link,
                    scrollContainer = closestToc.closest('.Popover__ValueList') || closestToc,
                    menuScrollTop = topLevelLink.offsetTop - scrollContainer.clientHeight / 4;
              scrollContainer.scroll({
                top: menuScrollTop,
                behavior: "instant"
              });
              // Close any remaining open collapsibles
              const openCollapsibles = closestToc.querySelectorAll('.Collapsible__Button[aria-expanded="true"]');
              openCollapsibles.forEach(openCollapsible => {
                if (!collapsibleButton || openCollapsible !== collapsibleButton) openCollapsible.querySelector('[data-action="toggle-collapsible"]').click();
              });
            }
          });
          if (this.onScroll) {
            this.onScroll(this.anchors[i], activeLinks);
          }
          break;
        }
      }
    }]);

    return TableOfContents;
  }();

  var MultiStepForm = function () {
    function MultiStepForm(element, options) {
      _classCallCheck(this, MultiStepForm);
      
      this.element = element;

      const formOptions = this.element.getAttribute('data-form-options');
      this.options = formOptions ? JSON.parse(formOptions.replaceAll("'", '"')) : {};

      if (this.options.loading) this.element.classList.add('LoadingContainer');

      this.initListeners();
    }

    _createClass(MultiStepForm, [{
      key: "initListeners",
      value: function initListeners() {
        this.element.querySelectorAll('[data-form-step-action="continue"], [data-form-step-action="return"]').forEach(btn => {
          btn.addEventListener('click', e => {
            const currentStepContainer = e.target.closest('[data-form-step]'),
                  action = e.target.getAttribute('data-form-step-action');
            if (action === 'continue' && !this.validateStep(currentStepContainer)) return;
            let step = parseInt(currentStepContainer.getAttribute('data-form-step'));
            if (action === 'continue' && this.options.submit === 'manual') {
              if (this.options.loading) this.element.classList.add('loading');
              this.element.dispatchEvent(new CustomEvent('theme:form:step', { detail: this.toJson() }));
              return;
            }
            action === 'continue' ? step++ : step--;
            this.setStep(step);

          });
        });
        this.element.addEventListener('submit', e => {
          e.preventDefault();
        });
        this.element.querySelectorAll('button[type="submit"]').forEach(btn => {
          btn.addEventListener('click', e => {
            const currentStepContainer = e.target.closest('[data-form-step]');
            if (!this.validateStep(currentStepContainer)) return;
            if (this.options.submit === 'manual') {
              if (this.options.loading) this.element.classList.add('loading');
              this.element.dispatchEvent(new CustomEvent('theme:form:submit', { detail: this.toJson() }));
              return;
            }
            this.element.submit();
            this.element.dispatchEvent(new CustomEvent('theme:form:done'));
          });
        });

        // Hook to allow external logic to set active step
        this.element.addEventListener('theme:form:setstep', e => {
          const step = e.detail;
          this.setStep(step);
        });
        // Hook to allow external logic to go to next step
        this.element.addEventListener('theme:form:continue', e => {
          this.element.classList.remove('loading');
          const currentStepContainer = this.element.querySelector('[data-form-step][aria-hidden="false"]');
          if (!currentStepContainer) return;
          const nextStep = parseInt(currentStepContainer.getAttribute('data-form-step')) + 1;
          this.setStep(nextStep);
          if (e.detail.successAlert) this.showAlert(e.detail.successAlert, true);
        });
        // Hook to allow external logic to signal the form submit is done
        this.element.addEventListener('theme:form:done', () => {
          this.element.classList.remove('loading');
          this.showAlert('done', true);
        });
        // Hook to allow external logic to signal the form submit is done
        this.element.addEventListener('theme:form:alert', e => {
          this.element.classList.remove('loading');
          this.hideAlerts();
          this.showAlert(e.detail.name, e.detail.success);
        });
      }
    }, {
      key: "validateStep",
      value: function validateStep(stepElement) {
        this.hideAlerts(stepElement);
        let valid = true;
        stepElement.querySelectorAll('input, textarea, select').forEach(input => {
          if (!input.validity.valid) {
            valid = false;
            input.reportValidity();
          }
        });
        if (!valid) this.showAlert();
        return valid;
      }
    }, {
      key: "setStep",
      value: function setStep(step) {
        const currentStepContainer = this.element.querySelector('[data-form-step][aria-hidden="false"]'),
              currentStep = parseInt(currentStepContainer.getAttribute('data-form-step'));
        if (step !== currentStep) {
          const newStepContainer = this.element.querySelector(`[data-form-step="${step}"]`);
          if (!newStepContainer) return;
          currentStepContainer.setAttribute('aria-hidden', 'true');
          newStepContainer.setAttribute('aria-hidden', 'false');
          this.hideAlerts(newStepContainer);
        }
        const firstInput = this.element.querySelector('[data-form-step][aria-hidden="false"] input');
        if (firstInput) firstInput.focus();
      }
    }, {
      key: "toJson",
      value: function toJson() {
        const formData = new FormData(this.element);
        const json = {};
        formData.forEach((value, key) => {
          if (value !== '') json[key] = value;
        });
        return json;
      }
    }, {
      key: "showAlert",
      value: function showAlert(name = 'validation', success = false) {
        const alertElement = this.element.querySelector(`[data-form-step][aria-hidden="false"] [data-form-${success ? 'success' : 'error'}="${name}"]`);
        if (!alertElement) return;
        alertElement.setAttribute('aria-hidden', 'false');
        alertElement.closest('.Form__Alert').setAttribute('aria-hidden', 'false');
      }
    }, {
      key: "hideAlerts",
      value: function hideAlerts(container = this.element) {
        const alertElements = container.querySelectorAll('.Alert__Message[aria-hidden="false"]');
        if (alertElements.length === 0) return;
        alertElements.forEach(element => {
          element.setAttribute('aria-hidden', 'true');
          element.closest('.Form__Alert').setAttribute('aria-hidden', 'true');
        });
      }
    }]);

    return MultiStepForm;
  }();

  var Bibliography = function () {
    function Bibliography() {
      _classCallCheck(this, Bibliography);

      const bibContainer = document.querySelector('.bibliography-global');
      if (!bibContainer) return;
      this.bibContainer = bibContainer;
      this.init();
    }

    _createClass(Bibliography, [{
      key: "init",
      value: function init() {
        const entries = document.querySelectorAll('[data-bib-title]'),
              bibWrapper = this.bibContainer.closest('.ReferenceListWrapper'),
              bibToggle = bibWrapper.querySelector('[data-action="toggle-collapsible"], [data-action="open-drawer"]');
        let html = '',
            index = 1;
        const template = this.bibContainer.querySelector('li').outerHTML,
              referenceIndices = {};
        entries.forEach(entry => {
          const title = entry.dataset.bibTitle;
          let source = entry.dataset.bibSource,
              entryIndex;
          if (referenceIndices[title] !== undefined) {
            entryIndex = referenceIndices[title];
          }
          else {
            entryIndex = index;
            referenceIndices[title] = index;
            let templateInstance = template.replaceAll('$number', index).replace('$title', title);
            if (source) {
              source = source.replace(/#.*$/, ''); // Remove hashes because there is a bug where links break and only scroll to top
              templateInstance = templateInstance.replace(/href="#"/, 'href="' + source + '"');
            }
            else {
              templateInstance = templateInstance.replace('ReferenceList__Item ', 'ReferenceList__Item ReferenceList__Item--no-link ');
            }
            html += templateInstance;
            index++;
          }
          entry.href = '#';
          entry.querySelector('sup').innerText = entryIndex;
          if (bibToggle) {
            entry.addEventListener('click', (e) => {
              e.preventDefault();
              if (bibToggle.getAttribute('aria-expanded') === 'false') bibToggle.click();
            });
          }
        });
        this.bibContainer.querySelector('ul').innerHTML = html;
        if (index > 1) this.bibContainer.closest('.ReferenceListWrapper').classList.remove('none');
      }
    }]);

    return Bibliography;
  }();

  var Timer = function () {
    function Timer(element, options = {}) {
      _classCallCheck(this, Timer);

      this.element = element;
      this.options = options;
      this.msecs = {
        s: 1000,
        m: 1000 * 60,
        h: 1000 * 60 * 60,
        d: 1000 * 60 * 60 * 24
      }
      this.init();
      this.addListeners();
    }

    _createClass(Timer, [{
      key: "init",
      value: function init() {
        if (this.interval) clearInterval(this.interval);
        const dateAttribute = this.element.getAttribute('data-timer-date');
        if (dateAttribute === 'expires') return;
        const timeAttribute = this.element.getAttribute('data-timer-time');
        let timeString = timeAttribute && /^\d\d:\d\d$/.test(timeAttribute) ? timeAttribute : '23:59';
        const dateString = `${dateAttribute}T${timeString}:00+${String(new Date().getTimezoneOffset() * -1 / 60).padStart(2, '0')}:00`;
        this.dateTimestamp = new Date(dateString).getTime();
        this.active = false;
        this.expired = false;
        this.interval = null;
        this.daysElement = this.element.querySelector('[data-timer-days]');
        this.hoursElement = this.element.querySelector('[data-timer-hours]');
        this.minutesElement = this.element.querySelector('[data-timer-minutes]');
        this.secondsElement = this.element.querySelector('[data-timer-seconds]');
        this.element.setAttribute('data-timer-initialized', 'true');
        if (!this.options.inactive) this.start();
      }
    },
    {
      key: "addListeners",
      value: function addListeners() {
        this.element.addEventListener('theme:timer:init', this.init.bind(this));
      }
    },
    {
      key: "update",
      value: function update() {
        const now = Date.now(),
              distance = this.dateTimestamp - now;
        if (distance <= 0) {
          this.daysElement.innerText = '0';
          this.hoursElement.innerText = '0';
          this.minutesElement.innerText = '0';
          this.secondsElement.innerText = '0';
          this.expired = true;
          this.element.dispatchEvent(new CustomEvent('theme:timer:expired'));
          this.stop();
        }
        else {
          this.daysElement.innerText = Math.floor(distance / this.msecs.d);
          this.hoursElement.innerText = Math.floor((distance % this.msecs.d) / this.msecs.h);
          this.minutesElement.innerText = Math.floor((distance % this.msecs.h) / this.msecs.m);
          this.secondsElement.innerText = Math.floor((distance % this.msecs.m) / this.msecs.s);
        }
      }
    },
    {
      key: "start",
      value: function start() {
        this.active = true;
        this.update();
        this.interval = setInterval(this.update.bind(this), 1000);
      }
    },
    {
      key: "stop",
      value: function timer() {
        this.active = false;
        clearInterval(this.interval);
        this.interval = null;
      }
    }]);

    return Timer;
  }();

  var CountrySelector = function () {
    function CountrySelector(countrySelect, provinceSelect) {
      _classCallCheck(this, CountrySelector);

      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;

      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners();

        this._initSelectors();
      }
    }

    _createClass(CountrySelector, [{
      key: "destroy",
      value: function destroy() {
        if (this.countrySelect) {
          this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
        }
      }
    }, {
      key: "_initSelectors",
      value: function _initSelectors() {
        // Check first the default value of country
        var defaultCountry = this.countrySelect.getAttribute('data-default');

        if (defaultCountry) {
          for (var i = 0; i !== this.countrySelect.options.length; ++i) {
            if (this.countrySelect.options[i].text === defaultCountry) {
              this.countrySelect.selectedIndex = i;
              break;
            }
          }
        } else {
          this.countrySelect.selectedIndex = 0;
        }

        var event = new Event('change', {
          bubbles: true
        });
        this.countrySelect.dispatchEvent(event);
        
        // Then the province
        var defaultProvince = this.provinceSelect.getAttribute('data-default');
        if (defaultProvince) {
          for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
            if (this.provinceSelect.options[_i].text === defaultProvince) {
              this.provinceSelect.selectedIndex = _i;
              break;
            }
          }
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onCountryChangedListener = this._onCountryChanged.bind(this);
        this.countrySelect.addEventListener('change', this._onCountryChangedListener);
      }
    }, {
      key: "_onCountryChanged",
      value: function _onCountryChanged() {
        var _this = this;

        var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
            provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');
            
        // First remove all options
        this.provinceSelect.innerHTML = '';
        if (provinces.length === 0) {
          this.provinceSelect.parentNode.style.display = 'none';
          return;
        }
        
        // We need to build the provinces array
        provinces.forEach(function (data) {
          _this.provinceSelect.options.add(new Option(data[1], data[0]));
        });
        this.provinceSelect.parentNode.style.display = 'block';
      }
    }]);

    return CountrySelector;
  }();

  var AddressesSection = function AddressesSection() {
    var _this = this;

    _classCallCheck(this, AddressesSection);

    this.countrySelectors = [];
    Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
      _this.countrySelectors.push(new CountrySelector(modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
    });
  };

  var ArticleSection = function () {
    function ArticleSection(container) {
      var _this = this;

      _classCallCheck(this, ArticleSection);

      this.element = container;
      this.toolbarElement = this.element.querySelector('.ArticleToolbar');
      this.articleNavElement = this.element.querySelector('.ArticleNav');
      
      // Popover table of contents mobile
      const popoverElement = document.querySelector('#table-of-contents-popover');
      if (popoverElement) {
        new Popover(popoverElement, { preferredPosition: 'bottom' });
        const popoverLinks = popoverElement.querySelectorAll('a.toc-link'),
              popoverClose = popoverElement.querySelector('[data-action="close-popover"]');
        popoverLinks.forEach((link) => {
          link.addEventListener('click', () => {
            popoverClose.click();
          });
        });
      }

      // Open bibliography when an anchor link is clicked
      const bibliographyToggle = document.querySelector('.ReferenceListWrapper [data-action="toggle-collapsible"]');
      if (bibliographyToggle) {
        const bibLinks = this.element.querySelectorAll('.ReferenceLink');
        bibLinks.forEach((link) => {
          link.addEventListener('click', () => {
            if (bibliographyToggle.getAttribute('aria-expanded') == 'false') {
              bibliographyToggle.click();
            }
          });
        })
      }

      // Initialize table of contents
      const articleBody = document.querySelector('.ArticleBody');
      if (articleBody) {
        this.tableOfContents = new TableOfContents(Dom.nodeListToArray(document.querySelectorAll('.TableOfContents')), articleBody, { activeSelector: '.toc-link-item' });
      }

      // Recipe portion calculator
      const ingredientsContainer = document.querySelector('.Recipe__Ingredients');
      if (ingredientsContainer) {
        const parseNumber = (string) => {
          let number = 1;
          if (string.includes('/')) {
            const parts = string.split('/');
            number = parseInt(parts[0]) / parseInt(parts[1]);
          }
          else if (string.includes(',') || string.includes('.')) {
            const fixed = string.replace(',', '.');
            number = parseFloat(fixed);
          }
          else {
            number = parseInt(string);
          }
          return number;
        };
        const formatNumber = (number) => {
          if (Number.isInteger(number)) {
            return '' + number;
          }
          else if (number < 1) {
            for (let denominator = 2; denominator <= 4; denominator++) {
              const numerator = number * denominator;
              if (Number.isInteger(numerator)) {
                return `${numerator}/${denominator}`;
              }
            }
          }
          return number.toLocaleString('de-DE', { maximumFractionDigits: 2 });
        };
        const portionElement = ingredientsContainer.querySelector('input[data-ingr-portion]'),
              amountElements = ingredientsContainer.querySelectorAll('[data-ingr-amount]'),
              minusButton = ingredientsContainer.querySelector('[data-action="decrease-quantity"]'),
              plusButton = ingredientsContainer.querySelector('[data-action="increase-quantity"]');
        if (portionElement) {
          const originalPortionSize = parseNumber(portionElement.getAttribute('data-ingr-portion'));
          portionElement.addEventListener('input', (e) => {
            const newPortionSize = parseNumber(e.target.value);
            if (!isNaN(newPortionSize) && newPortionSize > 0) {
              const multiplicator = newPortionSize / originalPortionSize;
              amountElements.forEach((element) => {
                const newAmount = parseNumber(element.getAttribute('data-ingr-amount')) * multiplicator;
                element.innerText = formatNumber(newAmount);
              });
              minusButton.setAttribute('aria-disabled', newPortionSize === 1 ? 'true' : 'false');
            }
            else {
              portionElement.value = originalSize;
              portionElement.dispatchEvent(new Event('input'));
            }
          });
          if (minusButton) {
            minusButton.addEventListener('click', () => {
              if (portionElement.value > 1) {
                portionElement.value = parseInt(portionElement.value) - 1;
                portionElement.dispatchEvent(new Event('input'));
              }
            });
          }    
          if (plusButton) {
            plusButton.addEventListener('click', () => {
              portionElement.value = parseInt(portionElement.value) + 1;
              portionElement.dispatchEvent(new Event('input'));
            });
          }      
        }
      }
    }

    _createClass(ArticleSection, [{
      key: "onUnload",
      value: function onUnload() {
        window.removeEventListener('scroll', this._onScrollListener);
      }
    }]);

    return ArticleSection;
  }();

  var CartSection = function () {
    function CartSection(container) {
      _classCallCheck(this, CartSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.documentDelegate = new domDelegate.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];
      this.isCartNoteOpen = false;

      if (this.options['drawer']) {
        this.sidebarDrawer = new Drawer(this.element, {
          onClose: this._onDrawerClosed.bind(this),
          onOpen: this._onDrawerOpened.bind(this)
        });
      }

      this._attachListeners();
    }

    _createClass(CartSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
        document.removeEventListener('product:added', this._onProductAddedListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onProductAddedListener = this._onProductAdded.bind(this);
        this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this));

        this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
        this.delegateElement.on('change', '[name="updates[]"]', this._updateItemQuantity.bind(this));
        
        // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page
        if (this.options['drawer']) {
          this.delegateElement.on('click', '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
        }

        document.addEventListener('product:added', this._onProductAddedListener);
        
        // We attach a listener at page level which allows to re-render the cart
        // this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false)); // Old version replaced due to problems
        document.addEventListener('cart:refresh', this._rerenderCart.bind(this));
        document.addEventListener('cart:loading:start', this._addCartLoading.bind(this));

        //Init LoyaltyLion cart events
        this._initLoyaltyEvents();
        
        //Init button loading animations
        this._initButtonLoading();
      }
    }, {
      key: "_updateCartNote",
      value: function _updateCartNote(event, target) {
        fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            note: target.value
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        });
      }
    }, {
      key: "_toggleCartNote",
      value: function _toggleCartNote() {
        var _this = this;

        var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
            cartNote = this.element.querySelector('#cart-note');
        this.element.classList.toggle('has-note-open');
        this.element.querySelector('.Cart__NoteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;
        noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
        this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';

        if (this.element.classList.contains('has-note-open')) {
          var transitionEndListener = function transitionEndListener() {
            _this.element.querySelector('#cart-note').focus();

            noteContainer.removeEventListener('transitionend', transitionEndListener);
          };

          noteContainer.addEventListener('transitionend', transitionEndListener);
        }
      }
    }, {
      key: "_updateItemQuantity",
      value: function _updateItemQuantity(event, target) {
        var _this2 = this;

        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        this._addCartLoading();
        var quantity = null,
            elementToAnimate = null;

        if (target.tagName === 'INPUT') {
          quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
        } else {
          quantity = parseInt(target.getAttribute('data-quantity'));
        }
        
        // If the quantity is 0, then we will animate the product with a removal effect
        if (quantity === 0) {
          elementToAnimate = target.closest('.CartItemWrapper');
        }

        fetch("".concat(window.routes.cartChangeUrl, ".js"), {
          body: JSON.stringify({
            line: target.getAttribute('data-line'),
            quantity: quantity
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (cart) {
          cart.json().then(function (content) {
            InitFunctions.loyaltyCartChange(content);
            _this2.itemCount = content['item_count'];
            _this2._rerenderCart(elementToAnimate);
          });
        });
        event.preventDefault();
      }
    }, {
      key: "_onProductAdded",
      value: function _onProductAdded(event) {
        var _this3 = this;

        // this.itemCount += event.detail.quantity;

        this._rerenderCart().then(function () {
          if (window.theme.pageType != "cart") {
            _this3.sidebarDrawer.open();
          }
        });
      }
    }, {
      key: "_onDrawerClosed",
      value: function _onDrawerClosed() {
        if (this.isCartNoteOpen) {
          this._toggleCartNote();
        }
      }
    }, {
      key: "_onDrawerOpened",
      value: function _onDrawerOpened() {
        document.dispatchEvent(new CustomEvent('theme:sidebarMenu:close'));
      }
    }, {
      /**
       * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
       * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
       * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
       * all the time and hence having easier logic.
       */
      key: "_rerenderCart",
      value: function _rerenderCart(elementToAnimate) {
        let _this4 = this,
            elementsToAnimate = [],
            readyToReplace = true;
        if (elementToAnimate instanceof CustomEvent) {
          if (elementToAnimate.detail && elementToAnimate.detail.elementsToAnimate) elementsToAnimate.push(...elementToAnimate.detail.elementsToAnimate);
        }
        else if (elementToAnimate) {
          elementsToAnimate.push(elementToAnimate);
        }
        if (elementsToAnimate.length > 0) {
          readyToReplace = false;
          elementsToAnimate.forEach((element, index) => {
            element.classList.add('removed');
            if (index === elementsToAnimate.length - 1) element.addEventListener('transitionend', (content) => {
              readyToReplace = true;
              this.element.dispatchEvent(new CustomEvent('theme:cart:canreplace'));
            }, { once: true });
          });
        }

        // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
        return fetch(window.routes.cartUrl + '?view=' + (this.options['drawer'] ? 'drawer' : 'ajax') + '&timestamp=' + Date.now(), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (content) {
          const onReadyToReplace = () => {
            content.text().then((html) => {
              _this4._replaceContent(html);
            });
          };
          if (elementsToAnimate.length > 0 && !readyToReplace) {
            _this4.element.addEventListener('theme:cart:canreplace', onReadyToReplace, { once: true });
          } else {
            onReadyToReplace();
          }
        });
      }
    }, {
      key: "_replaceContent",
      value: function _replaceContent(html) {
        var _this5 = this;

        const tempElement = document.createElement('div');
        tempElement.innerHTML = html;

        var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));

        if (this.options['drawer']) {
          const currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
          this.element.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
          this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;

          // Ugly hack to prevent the white screen bug on android browsers
          if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
            const androidFixElem = document.createElement('div');
            androidFixElem.innerText = "Google, bitte fixt euren Browser";
            androidFixElem.style.position = "absolute";
            androidFixElem.style.top = "-9999px";
            androidFixElem.style.width = "1px";
            androidFixElem.style.height = "1px";
            document.body.appendChild(androidFixElem);
          }
        } else {
          // For dedicated page we replace the whole section if there is no more product
          if (this.itemCount === 0 || cartResult["itemCount"] === 0) {
            this.element.innerHTML = tempElement.querySelector('.shopify-section [data-section-id="main-cart"]').innerHTML;
          } else {
            const cartNode = this.element.querySelector('.Cart');
            cartNode.parentNode.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
            this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
          }
        }
        
        if (cartResult["itemCount"] != 0) {
          this._initializeCountry();
        }
        
        // Eval new scripts
        var newScripts = this.element.getElementsByTagName("script");
        for (let i = 0; i < newScripts.length; i++) {
          eval((newScripts[i].text || newScripts[i].textContent || newScripts[i].innerHTML));
        }
        
        // We can also update the dot and the quantity
        var cartDot = Dom.nodeListToArray(document.querySelectorAll('.ShopHeader__CartDot')),
            cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.ShopHeader__CartCount'));
        this.itemCount = cartResult['itemCount'];
        cartDot.forEach(function (item) {
          if (_this5.itemCount === 0) {
            item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
          } else {
            item.classList.add('is-visible');
          }
        });
        cartQuantity.forEach(function (item) {
          item.textContent = _this5.itemCount;
        });

        //Reinitialize tracking and buttons
        document.dispatchEvent(new CustomEvent('theme:tracking:init', { detail: { element: this.element } }));
        InitFunctions.initDefaultCloseButtons(this.element);

        //Reinitialize LoyaltyLion
        if (!this.options['drawer']) {
          this._initLoyaltySlider();
        }

        //Reinitialize button loading animations
        this._initButtonLoading();

        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.dispatchEvent(new CustomEvent('theme:cart:refreshed', { detail: cartResult }));
      }
    }, {
      key: '_initButtonLoading',
      value: function _initButtonLoading() {
        const checkoutBtns = this.element.querySelectorAll('.Cart__Checkout');
        checkoutBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.target.classList.add('loading');
          });
        });
      }
    }, {
      key: '_addCartLoading',
      value: function _addCartLoading() {
        if (this.options['drawer'] && this.element.getAttribute('aria-hidden') === 'true') return;
        const _thisL = this;
        // Stack loading is needed for subsequent cart operations, e.g. in special offer
        if (this.element.classList.contains('loading')) {
          if (this.element.hasAttribute('data-stack-loading')) {
            const oldStack = parseInt(this.element.getAttribute('data-stack-loading'));
            this.element.setAttribute('data-stack-loading', oldStack + 1);
          }
          else {
            this.element.setAttribute('data-stack-loading', 1);
          }
          return;
        }
        this.element.classList.add('loading');
        const endLoadingListener = () => {
          const currentStack = _thisL.element.hasAttribute('data-stack-loading') ? parseInt(_thisL.element.getAttribute('data-stack-loading')) : 0;
          if (currentStack > 0) {
            if (currentStack === 1) {
              _thisL.element.removeAttribute('data-stack-loading');
            }
            else {
              _thisL.element.setAttribute('data-stack-loading', currentStack - 1);
            }
            document.addEventListener('theme:loading:end', endLoadingListener, { once: true });
            return;
          }
          _thisL.element.classList.remove('loading');
        }
        document.addEventListener('theme:loading:end', endLoadingListener, { once: true });
      }
    }, {
      key: '_initLoyaltyEvents',
      value: function _initLoyaltyEvents() {
        if (window.loyaltylion) {
          window.loyaltylion.on('cart.addedItem', (data) => {
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: data.variant_id,
                quantity: data.quantity
              }
            }));
          });
          window.loyaltylion.on('cart.removedItems', () => {
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          });
        }
        else {
          setTimeout(this._initLoyaltyEvents, 500);
        }
      }
    }, {
      key: '_initLoyaltySlider',
      value: function _initLoyaltySlider() {
        if (window.loyaltylion) {
          if (this.loyaltySlider) {
            this.loyaltySlider.disable();
          }
          const newLoyaltySlider = this.element.querySelector('.CartClubSlider .Slider');
          if (newLoyaltySlider) {
            const loyaltyButtons = newLoyaltySlider.querySelectorAll('a[data-lion-seamless-product-reward]');
            loyaltyButtons.forEach((button) => {
              button.addEventListener('click', () => {
                document.dispatchEvent(new CustomEvent('cart:loading:start'));
                document.dispatchEvent(new CustomEvent('theme:loading:start'));
                button.style.pointerEvents = 'none';
              });
            });

            this.loyaltySlider = new Slider(newLoyaltySlider);
            document.dispatchEvent(new CustomEvent('theme:product_carousel:loaded', { detail: newLoyaltySlider }));
          }
        }
        else {
          setTimeout(this._initLoyaltySlider, 500);
        }
      }
    }, {
      key: '_initializeCountry',
      value: async function _initializeCountry() {
        let countryCode = await Localization.getIpLocation();
        let elementsToShow = "threshold_general";
        switch (countryCode) {
          case "DE":
          case "AT":
            elementsToShow = "threshold_de";
            break;
          case "CH":
            elementsToShow = "threshold_ch";
            break;
          case "NL":
          case "BE":
          case "LU":
            elementsToShow = "threshold_benelux";
            break;
        }
        const threshold_elements = document.querySelectorAll('.Cart__ShippingThreshold');
        threshold_elements.forEach((threshold_element) => {
          const threshold_data = JSON.parse(threshold_element.dataset.thresholds)[elementsToShow],
                threshold_progress_element = threshold_element.querySelector('.ShippingThreshold__Progress'),
                threshold_text_element = threshold_element.querySelector('.ShippingThreshold__Text');
          threshold_progress_element.style.width = `${threshold_data.percentage}%`;
          threshold_progress_element.classList.add(threshold_data.class);
          threshold_text_element.innerHTML = `${threshold_data.text}`;
        });
      }
    }]);

    return CartSection;
  }();

  var ContentSliderSection = function () {
    function ContentSliderSection(container) {
      _classCallCheck(this, ContentSliderSection);

      this.element = container;
      var sliderElement = this.element.querySelector('.Slider');

      if (sliderElement) {
        this.carousel = new Slider(sliderElement);
        window.dispatchEvent(new Event('resize')); // Trigger resize to fix a bug in Safari where the slider did not initialize properly
      }
    }

    _createClass(ContentSliderSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.disable();
        }
      }
    }]);

    return ContentSliderSection;
  }();

  var VideoSection = function () {
    function VideoSection(container) {
      _classCallCheck(this, VideoSection);

      this.element = container;
      const playButton = this.element.querySelector('[data-action="play-video"]'),
            onPlayButtonClickListener = this.onPlayButtonClick.bind(this);

      if (playButton) playButton.addEventListener('click', onPlayButtonClickListener);
    }

    _createClass(VideoSection, [{
      key: "onPlayButtonClick",
      value: function onPlayButtonClick(e) {
        const openButton = this.element.querySelector('.wistia_click_to_play a');
        if (openButton) openButton.click();
      }
    }]);

    return VideoSection;
  }();

  /**
   * This class allows to automatically scrolls within a div when this div does not fit into the visible space
   */
  var OverflowScroller = function () {
    function OverflowScroller(element) {
      _classCallCheck(this, OverflowScroller);

      if (!element) {
        return;
      }

      this.element = element;
      this.lastKnownY = window.scrollY;
      this.currentTop = 0;
      this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);

      this._attachListeners();
    }

    _createClass(OverflowScroller, [{
      key: "destroy",
      value: function destroy() {
        window.removeEventListener('scroll', this._checkPositionListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._checkPositionListener = this._checkPosition.bind(this);
        window.addEventListener('scroll', this._checkPositionListener);
      }
    }, {
      key: "_checkPosition",
      value: function _checkPosition() {
        var _this = this;

        fastdom.measure(function () {
          var bounds = _this.element.getBoundingClientRect(),
              maxTop = bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
              minTop = _this.element.clientHeight - window.innerHeight;

          if (window.scrollY < _this.lastKnownY) {
            _this.currentTop -= window.scrollY - _this.lastKnownY;
          } else {
            _this.currentTop += _this.lastKnownY - window.scrollY;
          }

          _this.currentTop = Math.min(Math.max(_this.currentTop, -minTop), maxTop, _this.initialTopOffset);
          _this.lastKnownY = window.scrollY;
        });
        fastdom.mutate(function () {
          _this.element.style.top = "".concat(_this.currentTop, "px");
        });
      }
    }]);

    return OverflowScroller;
  }();

  var CollectionSection = function () {
    function CollectionSection(element) {
      _classCallCheck(this, CollectionSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.toolbarElement = this.element.querySelector('.CollectionToolbar');
      this.collectionInnerElement = this.element.querySelector('.CollectionInner__Products');

      this.settings = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.currentTags = this.settings['currentTags'];
      this.currentSortBy = this.settings['sortBy'];

      this.temporaryTags = this.currentTags.slice(); // This allows to do a deep copy of the current tags

      // Create the popover if available
      var sortPopoverElement = document.getElementById('collection-sort-popover');
      if (sortPopoverElement) {
        this.sortPopover = new Popover(sortPopoverElement, { onValueChanged: this._sortByChanged.bind(this) });
      }

      // Create the filter drawer if available
      var filterDrawerElement = document.getElementById('collection-filter-drawer');

      if (filterDrawerElement) {
        this.filterDrawer = new Drawer(filterDrawerElement, { onClose: this._removeUncommittedTags.bind(this) });
      }

      // Create scroller of sidebar
      if (this.settings['filterPosition'] === 'sidebar') {
        this.filterInnerSidebarScroller = new OverflowScroller(this.element.querySelector('.CollectionInner__Sidebar'));
      }

      this._attachListeners();

      //AddToCart buttons
      const addToCartButtons = document.querySelectorAll('button.Promotion__AddToCart');
      if (addToCartButtons.length > 0) {
        addToCartButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            const variantId = e.target.getAttribute('data-variant-id');
            if (variantId) {
              window.addToCart([{id: variantId, quantity: 1}]);
            }
          });
        })
      }

      // Init drawers
      document.querySelectorAll('.Section__OffScreen .Drawer').forEach(drawer => {
        new Drawer(drawer);
      });
    }

    _createClass(CollectionSection, [{
      key: 'onUnload',
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.sortPopover) {
          this.sortPopover.destroy();
        }

        if (this.filterDrawer) {
          this.filterDrawer.destroy();
        }

        if (this.filterInnerSidebarScroller) {
          this.filterInnerSidebarScroller.destroy();
        }
      }
    }, /* Removed the themes grid layout, therefore this wont work anymore. Maybe this will be interesting in the future for other similar features {
      key: '_changeLayoutMode',
      value: function _changeLayoutMode(event, target) {
        var _this3 = this;

        var layoutType = target.getAttribute('data-grid-type'),
            newCount = parseInt(target.getAttribute('data-count'));

        // Otherwise we detect the mode, and change all classes
        var productList = this.collectionInnerElement.querySelector('.ProductList');

        if (productList) {
          var previousCount = parseInt(productList.getAttribute('data-' + layoutType + '-count'));

          if (previousCount === newCount) {
            return; // Nothing has changed so we just return to avoid reflow
          }

          productList.setAttribute('data-' + layoutType + '-count', newCount);

          Dom.nodeListToArray(productList.querySelectorAll('.Grid__Cell')).forEach(function (item) {
            if (layoutType === 'mobile') {
              item.classList.remove('1/' + previousCount + '--phone'); // IE11 and lower does not support classList.replace
              item.classList.add('1/' + newCount + '--phone');
            } else {
              var previousTabletCount = previousCount === 2 ? 2 : 3,
                  newTabletCount = newCount === 2 ? 2 : 3;

              if (_this3.settings['filterPosition'] === 'drawer') {
                item.classList.remove('1/' + previousCount + '--lap-and-up');
                item.classList.add('1/' + newCount + '--lap-and-up');
              } else {
                item.classList.remove('1/' + previousCount + '--desk');
                item.classList.add('1/' + newCount + '--desk');
              }

              item.classList.remove('1/' + previousTabletCount + '--tablet-and-up');
              item.classList.add('1/' + newTabletCount + '--tablet-and-up');
            }
          });

          // Force lazy sizes to recalculate item sizes
          lazySizes.autoSizer.checkElems();
        }

        target.classList.add('is-active');
        Dom.getSiblings(target)[0].classList.remove('is-active');

        // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
        // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript

        fetch(window.routes.cartUrl + '/update.js', {
          body: JSON.stringify({
            attributes: _defineProperty({}, 'collection_' + layoutType + '_items_per_row', newCount)
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        });
      }
    }, */ {
      key: '_sortByChanged',
      value: function _sortByChanged(sortBy) {
        if (this.currentSortBy === sortBy) {
          return;
        }

        this.currentSortBy = sortBy;
        this._reloadProducts();
      }
    }, {
      key: '_toggleTag',
      value: function _toggleTag(event) {
        var element = event.target;

        if (element.classList.contains('is-active')) {
          this.temporaryTags.splice(this.temporaryTags.indexOf(element.getAttribute('data-tag')), 1); // Delete the tag if already active
        } else {
          var activeSibling = element.closest('.FilterGroup').querySelector('.is-active');

          if (activeSibling) {
            this.temporaryTags.splice(this.temporaryTags.indexOf(activeSibling.getAttribute('data-tag')), 1);
          }

          this.temporaryTags.push(element.getAttribute('data-tag')); // Add if not previously active
        }

        this._updateActiveTags();

        // If we have the mode set as "sidebar" and that we are on desktop, we auto-commit
        if (Responsive.matchesBreakpoint('lap-and-up') && this.settings['filterPosition'] === 'sidebar') {
          this._commit();
        }
      }
    }, {
      key: '_removeUncommittedTags',
      value: function _removeUncommittedTags() {
        this.temporaryTags = this.currentTags.slice(); // We simply reset the temporary tags to the active tags
        this._updateActiveTags();
      }
    }, {
      key: '_applyTags',
      value: function _applyTags() {
        this._updateActiveTags();
        this._commit();
      }
    }, {
      key: '_resetTags',
      value: function _resetTags() {
        this.temporaryTags = []; // We simply remove all tags
        this._applyTags();
      }
    }, {
      key: '_updateActiveTags',
      value: function _updateActiveTags() {
        var _this4 = this;

        Dom.nodeListToArray(this.element.querySelectorAll('.CollectionFilters [data-tag]')).forEach(function (item) {
          // IE11 and lower does not support classList.toggle...
          if (_this4.temporaryTags.includes(item.getAttribute('data-tag'))) {
            item.classList.add('is-active');
            item.parentNode.classList.add('is-selected'); // For the case of "ListItem"
          } else {
            item.classList.remove('is-active');
            item.parentNode.classList.remove('is-selected'); // For the case of "ListItem"
          }
        });
      }
    }, {
      key: '_commit',
      value: function _commit() {
        var _this5 = this;

        if (this.currentTags.sort().join(',') !== this.temporaryTags.sort().join(',')) {
          this.currentTags = this.temporaryTags.slice();
          this._reloadProducts();
        }

        if (this.filterDrawer.isOpen) {
          this.filterDrawer.close();
        }

        Dom.nodeListToArray(this.element.querySelectorAll('[data-action="reset-tags"]')).forEach(function (resetButton) {
          resetButton.style.display = _this5.currentTags.length === 0 ? 'none' : 'block';
        });
      }
    }, {
      key: '_reloadProducts',
      value: function _reloadProducts() {
        var _this6 = this;

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        var filterElement = this.toolbarElement.querySelector('.CollectionToolbar__Item--filter');

        if (filterElement) {
          var filterElementCount = filterElement.querySelector('span');

          if (filterElementCount) {
            filterElement.removeChild(filterElementCount);
          }

          if (this.currentTags.length === 0) {
            filterElement.classList.add('Text--subdued');
          } else {
            filterElement.classList.remove('Text--subdued');
            filterElement.innerHTML += '<span class="Text--subdued">(' + this.currentTags.length + ')</span>';
          }
        }

        // We also rewrite the URL if browser supports it
        if (history.replaceState) {
          var tags = this.currentTags.length > 0 ? this.currentTags.join('+') : '';
          var newUrl = window.location.protocol + '//' + window.location.host + this.settings['collectionUrl'] + '/' + tags + '?sort_by=' + this.currentSortBy;

          window.history.pushState({ path: newUrl }, '', newUrl);
        }

        var formData = new FormData();
        formData.append('view', 'ajax');
        formData.append('sort_by', this.currentSortBy);

        fetch(location.pathname + '?view=ajax&sort_by=' + this.currentSortBy, {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            var tempElement = document.createElement('div');
            tempElement.innerHTML = content;

            _this6.collectionInnerElement.innerHTML = tempElement.querySelector('.shopify-section').innerHTML;
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            document.dispatchEvent(new CustomEvent('theme:collection:changed', { detail: _this6.element }));

            // We scroll to the top
            var elementOffset = _this6.element.querySelector('.CollectionMain').getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--header-height'));

            if (Responsive.matchesBreakpoint('lap-and-up') && _this6.toolbarElement && _this6.toolbarElement.clientHeight === 0) {
              elementOffset -= 50;
            }

            if (elementOffset < 0) {
              window.scrollBy({ top: elementOffset, behavior: 'smooth' });
            }
          });
        });
      }
    }, {
      key: '_attachListeners',
      value: function _attachListeners() {
        this._toggleTagListener = this._toggleTag.bind(this);
        this._applyTagsListener = this._applyTags.bind(this);
        this._resetTagsListener = this._resetTags.bind(this);
        // this._changeLayoutModeListener = this._changeLayoutMode.bind(this);

        this.delegateElement.on('click', '[data-action="toggle-tag"]', this._toggleTagListener);
        this.delegateElement.on('click', '[data-action="apply-tags"]', this._applyTagsListener);
        this.delegateElement.on('click', '[data-action="reset-tags"]', this._resetTagsListener);
        // this.delegateElement.on('click', '[data-action="change-layout-mode"]', this._changeLayoutModeListener);

        window.addEventListener('popstate', function (event) {
          if (event.state.path) {
            window.location.href = event.state.path;
          }
        });
      }
    }]);

    return CollectionSection;
  }();

  var FaqPageSection = function () {
    function FaqPageSection(element) {
      _classCallCheck(this, FaqPageSection);

      this.element = element;

      const toc = this.element.querySelector('.TableOfContentsSidenav'),
            content = this.element.querySelector('.FAQList');
      if (toc && content) this.tableOfContents = new TableOfContents([toc], content, { activeSelector: '.toc-link-item' });
    }

    _createClass(FaqPageSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.tableOfContents) {
          this.tableOfContents.destroy();
          this.tableOfContents = null;
        }
      }
    }]);

    return FaqPageSection;
  }();

  var FeaturedBlogPostsSection = function () {
    function FeaturedBlogPostsSection(container) {
      var _this = this;

      _classCallCheck(this, FeaturedBlogPostsSection);

      this.element = container;
      this.carousels = [];
      Dom.nodeListToArray(this.element.querySelectorAll('.Slider')).forEach((item, index) => {
        _this.carousels.push(new Slider(item));
      });

      this._attachListeners();
    }

    _createClass(FeaturedBlogPostsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.disable();
        });
        delete this.carousels();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        const tabList = this.element.querySelector('.tab-switch');
        if (tabList) {
          new TabSwitch(tabList, { onSwitch: this._reactivateCarousels.bind(this) });
        }
      }
    }, {
      key: "_reactivateCarousels",
      value: function _reactivateCarousels() {
        this.carousels.forEach(carousel => {
          if (carousel.element.closest('.tab-panel').getAttribute('aria-hidden') === 'false') {
            carousel.enable();
          }
          else {
            carousel.disable();
          }
        });
      }
    }]);

    return FeaturedBlogPostsSection;
  }();

  var FeaturedProductsSection = function () {
    function FeaturedProductsSection(container) {
      var _this = this;

      _classCallCheck(this, FeaturedProductsSection);

      this.element = container;
      this.carousels = [];
      Dom.nodeListToArray(this.element.querySelectorAll('.Slider')).forEach((item, index) => {
        _this.carousels.push(new Slider(item));
      });

      this._attachListeners();
    }

    _createClass(FeaturedProductsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.disable();
        });
        delete this.carousels();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        const tabList = this.element.querySelector('.tab-switch');
        if (tabList) {
          new TabSwitch(tabList, { onSwitch: this._reactivateCarousels.bind(this) });
        }
      }
    }, {
      key: "_reactivateCarousels",
      value: function _reactivateCarousels() {
        this.carousels.forEach(carousel => {
          if (carousel.element.closest('.tab-panel').getAttribute('aria-hidden') === 'false') {
            carousel.enable();
          }
          else {
            carousel.disable();
          }
        });
      }
    }]);

    return FeaturedProductsSection;
  }();

  var GiftCardSection = function () {
    function GiftCardSection(container) {
      _classCallCheck(this, GiftCardSection);

      this.element = container;

      this._setupPrint();
    }

    _createClass(GiftCardSection, [{
      key: "_setupPrint",
      value: function _setupPrint() {
        var printElement = document.getElementById('PrintGiftCard');

        if (printElement) {
          printElement.addEventListener('click', function () {
            window.print();
          });
        }
      }
    }]);

    return GiftCardSection;
  }();

  var GlobalBlocksSection = function () {
    function GlobalBlocksSection(container) {
      _classCallCheck(this, GlobalBlocksSection);

      this.element = container;
      this.timers = [];

      this.addListeners();
    }

    _createClass(GlobalBlocksSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.timers.forEach(timer => timer.stop());
      }
    }, {
      key: "addListeners",
      value: function addListeners() {
        const timerElements = this.element.querySelectorAll('[data-timer-date]');
        timerElements.forEach(element => {
          this.timers.push(new Timer(element));
        });
      }
    }]);

    return GlobalBlocksSection;
  }();

  var HeaderSection = function () {
    function HeaderSection(container) {
      var _this = this;

      _classCallCheck(this, HeaderSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.lastScrollPosition = -1;
      this.isNavOpen = false;

      this.headerContainer = document.querySelector('#shopify-section-shop-header');
      
      // Set up the search bar
      this.searchBar = new SearchBar();

      this._attachListeners();

      this._verifyNavigationOverlap();
      
      // We set again some CSS variables that are used for some calculations in CSS
      var mainLogo = this.element.querySelector('.ShopHeader__LogoImage--primary');

      if (mainLogo && !mainLogo.complete) {
        mainLogo.addEventListener('load', function () {
          fastdom.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
          });
        });
      } else {
        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
        });
      }
    }

    _createClass(HeaderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.element.removeEventListener('mouseleave', this._closeNavigationListener);
        this.delegateElement.off();
        window.removeEventListener('resize', this._verifyNavigationOverlapListener);

        this.searchBar.destroy();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {

        var listItem = event.target.closest('.ShopHeader__MainMenuItem');
        fastdom.mutate(function () {
          event.target.setAttribute('aria-hidden', 'false');

          if (listItem) {
            listItem.setAttribute('aria-expanded', 'true');
            Dom.getSiblings(listItem, '[aria-expanded="true"]').forEach(function (item) {
              item.setAttribute('aria-expanded', 'false');
            });
          }
        });
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        var listItem = event.target.closest('.ShopHeader__MainMenuItem');
        fastdom.mutate(function () {
          event.target.setAttribute('aria-hidden', 'true');

          if (listItem) {
            listItem.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._closeNavigationListener = this._closeNavigation.bind(this);
        this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
        this._pageOverlayClosedListener = this._onPageOverlayClosed.bind(this);
        this.element.addEventListener('mouseleave', this._closeNavigationListener);
        this.delegateElement.on('mouseenter', '.ShopHeader__MainMenu button[data-level="1"]', this._openMenu.bind(this), true);
        this.delegateElement.on('click', '.ShopHeader__MainMenu button[data-level="1"], .ShopHeader__MainMenu button[data-level="2"]', this._handleButtonClick.bind(this));
        this.delegateElement.on('mouseenter', '.ShopHeader__MainMenu a[data-level="1"]', this._closeNavigationListener, true);
        this.delegateElement.on('focusout', '.ShopHeader__Item--MainMenu', this._closeNavigationListener);
        this.delegateElement.on('click', '[data-action="open-search"], [data-action="open-drawer"][data-drawer-id="sidebar-cart"]', this._closeNavigationListener);
        this.delegateElement.on('mouseenter', '.ShopHeader__MainColumn button[data-level="2"]', this._openThirdLevel.bind(this), true);
        this.delegateElement.on('keydown', '.ShopHeader__MainMenu', this._onKeyPress.bind(this));
        this.secondLevelEntryMouseMoveListener = window.throttle(this._onSecondLevelEntryMouseMove.bind(this), 50);
        this.secondLevelEntryMouseLeaveListener = this._onSecondLevelEntryMouseLeave.bind(this);

        window.addEventListener('resize', this._verifyNavigationOverlapListener);
      }
    }, {
      key: "calcHoverArea",
      value: function calcHoverArea(activator, box, moveEvent) {
        const activatorRect = activator.getBoundingClientRect(),
              boxRect = box.getBoundingClientRect(),
              mouseX = moveEvent.clientX - activatorRect.left,
              mouseY = moveEvent.clientY - activatorRect.top;
        // Do not change area if mouse is outside the activator
        if (mouseY < 0 || mouseY > activatorRect.height || mouseX > activatorRect.width) return;
      
        const pufferAreaWidth = 0,
              boxRelativePositions = { top: boxRect.top - activatorRect.top, left: boxRect.left - activatorRect.left, bottom: boxRect.bottom - activatorRect.top },
              polygonPoints = [{ x: Math.max(0, mouseX - pufferAreaWidth), y: boxRelativePositions.top * -1 }, { x: boxRelativePositions.left, y: 0 }, { x: boxRelativePositions.left, y: Math.max(activatorRect.height, boxRelativePositions.bottom) - boxRelativePositions.top }, { x: Math.max(0, mouseX - pufferAreaWidth), y: boxRelativePositions.top * -1 + activatorRect.height }];
      
        this.setHoverArea(activator, boxRelativePositions.top, boxRelativePositions.left, polygonPoints);
      }
    }, {
      key: "setHoverArea",
      value: function setHoverArea(element, topOffset, width, points) {
        const height = points[2].y - points[1].y,
              pointsString = points.map(p => `${p.x},${p.y}`).join(' '),
              oldSvg = element.querySelector('svg.ShopHeader__HoverArea');
        if (oldSvg) {
          oldSvg.setAttribute('viewBox', `0 0 ${width} ${height}`);
          oldSvg.style.height = `${height}px`;
          oldSvg.querySelector('polygon').setAttribute('points', pointsString);
        }
        else {
          const SVG_TEMPLATE = `<svg class="ShopHeader__HoverArea" viewBox="0 0 {{width}} {{height}}" xmlns="http://www.w3.org/2000/svg" style="top: {{topOffset}}px; width: {{width}}px; height: {{height}}px;">
                  <polygon points="{{points}}" fill="none"/>
                </svg>`,
                svg = SVG_TEMPLATE.replace(/{{width}}/g, width).replace(/{{height}}/g, height).replace(/{{topOffset}}/g, topOffset).replace(/{{points}}/g, pointsString);
          element.insertAdjacentHTML('beforeend', svg);
        }
      }
    }, {
      key: "removeHoverArea",
      value: function removeHoverArea(element) {
        const area = element.querySelector('svg.ShopHeader__HoverArea');
        if (area) area.remove();
      }
    }, {
      key: "_onSecondLevelEntryMouseMove",
      value: function _onSecondLevelEntryMouseMove(e) {
        const activator = e.target.hasAttribute('aria-expanded') ? e.target : e.target.closest('[aria-expanded]');
        const box = this.element.querySelector(`#${activator.getAttribute('aria-controls')}`);
        if (!activator || !box) return;
        this.calcHoverArea(activator, box, e);
      }
    }, {
      key: "_onSecondLevelEntryMouseLeave",
      value: function _onSecondLevelEntryMouseMove(e) {
        e.target.removeEventListener('mousemove', this.secondLevelEntryMouseMoveListener);
        e.target.removeEventListener('mouseleave', this.secondLevelEntryMouseLeaveListener);
        this.removeHoverArea(e.target);
      }
    }, {
      key: "_handleButtonClick",
      value: function _handleButtonClick(e) {
        const button = e.target.tagName === 'BUTTON' ? e.target : e.target.closest('button');
        if (!button || !button.hasAttribute('data-level')) return;
        const level = button.getAttribute('data-level');
        if (button.getAttribute('aria-expanded') === 'true') {
          if (level === '1') {
            this._closeNavigation(e, button);
          }
          else if (level === '2') {
            this._closeThirdLevel(e, button);
          }
        }
        else {
          if (level === '1') {
            this._openMenu(e, button);
          }
          else if (level === '2') {
            this._openThirdLevel(e, button);
          }
        }
      }
    }, {
      key: "_onKeyPress",
      value: function _onKeyPress(event, target) {
        if (event.type !== 'keydown') return;

        const activator = event.target.hasAttribute('aria-controls') ? event.target : null;
        const controlledElement = activator ? document.getElementById(activator.getAttribute('aria-controls')) : null;

        if (event.key === 'Escape') {
          const openThirdLevel = this.element.querySelector('.ShopHeader__MainColumn button[data-level="2"][aria-expanded="true"]');
          if (openThirdLevel) {
            this._closeThirdLevel(event, openThirdLevel);
            return;
          }
          const openSecondLevel = this.element.querySelector('.ShopHeader__MainMenu button[data-level="1"][aria-expanded="true"]');
          if (openSecondLevel) this._closeNavigation(event, openSecondLevel);
        }
        else if (event.key === 'Tab') {
          if (!activator || !controlledElement || activator.getAttribute('aria-expanded') === 'false' || event.shiftKey) return;
          const focusTrapElement = controlledElement.querySelector('.ShopHeader__MainColumn') || controlledElement;
          Accessibility.trapFocus(focusTrapElement, activator.getAttribute('aria-controls'));
          controlledElement.querySelector('button,a[href]').focus();
          event.preventDefault();
        }
        else if (event.key === 'Enter' || event.key === ' ') {
          if (!activator || !controlledElement) return;
          if (activator.getAttribute('data-level') === '2') {
            this._openThirdLevel(event, activator);
            event.preventDefault();
          }
          else if (activator.getAttribute('data-level') === '1') {
            this._openMenu(event, activator);
            event.preventDefault();
          }
        }
        else {
          event.preventDefault();
        }
      }
    }, {
      key: "_openThirdLevel",
      value: function _openThirdLevel(event, target) {
        if (event.type === 'mouseenter' && target !== event.target) return;
        
        const controlledElement = document.getElementById(target.getAttribute('aria-controls'));

        if (target.getAttribute('aria-expanded') === 'true') return;

        const openElement = target.closest('.ShopHeader__MainColumn').querySelector('button[data-level="2"][aria-expanded="true"]');
        if (openElement) this._closeThirdLevel(null, openElement);

        target.setAttribute('aria-expanded', 'true');
        controlledElement.setAttribute('aria-hidden', 'false');
        target.addEventListener('mousemove', this.secondLevelEntryMouseMoveListener, { passive: true });
        target.addEventListener('mouseleave', this.secondLevelEntryMouseLeaveListener);
      }
    }, {
      key: "_closeThirdLevel",
      value: function _closeThirdLevel(event, target) {
        if (target.getAttribute('aria-expanded') === 'false') return;

        const controlledElement = document.getElementById(target.getAttribute('aria-controls'));
        
        Accessibility.removeTrapFocus(controlledElement, target.getAttribute('aria-controls'));
        if (event && event.type === 'keydown') target.focus();
        controlledElement.setAttribute('aria-hidden', 'true');
        target.setAttribute('aria-expanded', 'false');
        target.removeEventListener('mousemove', this.secondLevelEntryMouseMoveListener);
        target.removeEventListener('mouseleave', this.secondLevelEntryMouseLeaveListener);
        this.removeHoverArea(target);
      }
    }, {
      key: "_closeNavigation",
      value: function _closeNavigation(event, target) {
        if (event && target && event.type === 'focusout' && target.contains(event.relatedTarget)) return;

        if (!this.isNavOpen) return;
        this.isNavOpen = false;

        const openElement = this.element.querySelector('.ShopHeader__MainMenu button[data-level="1"][aria-expanded="true"]');
        if (openElement) this._closeMenu(event, openElement);

        if (event && target && event.type === 'click' && target.getAttribute('data-action') === 'open-search') {
          this.headerContainer.style.zIndex = '';
        }
        else {
          window.pageOverlay.element.addEventListener('transitionend', this._pageOverlayClosedListener);
        }

        window.pageOverlay.close(this.element);
      }
    }, {
      key: "_onPageOverlayClosed",
      value: function _onPageOverlayClosed(event) {
        if (event.propertyName === 'visibility') {
          if (!this.searchBar.isOpen) this.headerContainer.style.zIndex = '';
          window.pageOverlay.element.removeEventListener('transitionend', this._pageOverlayClosedListener);
        }
      }
    }, {
      key: "_openMenu",
      value: function _openMenu(event, target) {
        if (event.type === 'mouseenter' && target !== event.target) return;

        const controlledElement = document.getElementById(target.getAttribute('aria-controls'));

        if (target.getAttribute('aria-expanded') === 'true') return;
        
        this.headerContainer.style.zIndex = 10;
        window.pageOverlay.element.removeEventListener('transitionend', this._pageOverlayClosedListener);
        this.isNavOpen = true;
        window.pageOverlay.open(this.element);

        const openElement = this.element.querySelector('.ShopHeader__MainMenu button[data-level="1"][aria-expanded="true"]');
        if (openElement) this._closeMenu(null, openElement);

        if (controlledElement) {
          target.setAttribute('aria-expanded', 'true');
          controlledElement.setAttribute('aria-hidden', 'false');
        }
      }
    }, {
      key: "_closeMenu",
      value: function _closeMenu(event, target) {
        if (target.getAttribute('aria-expanded') === 'false') return;
        const controlledElement = document.getElementById(target.getAttribute('aria-controls'));

        const openElement = controlledElement.querySelector('.ShopHeader__MainColumn button[data-level="2"][aria-expanded="true"]');
        if (openElement) this._closeThirdLevel(null, openElement);

        Accessibility.removeTrapFocus(controlledElement.querySelector('.ShopHeader__MainColumn'), target.getAttribute('aria-controls'));
        if (event && event.type === 'keydown') target.focus();

        controlledElement.setAttribute('aria-hidden', 'true');
        target.setAttribute('aria-expanded', 'false');
      }
    }, {
      key: "_verifyNavigationOverlap",
      value: function _verifyNavigationOverlap() {
        const _this5 = this,
              headerGrid = this.element.querySelector('.ShopHeader__Items');

        if (this.element.classList.contains('Header--overflowing')) {
          this.element.classList.remove('Header--overflowing');
          this.element.clientWidth; // Forces a reflow
        }

        let isOverlapping = false;

        // For performance, only check overlaps on large screens, the condition here must match the CSS media query where the layout is change to desktop view
        if (window.matchMedia("(min-width: 1024px)").matches) {
          fastdom.measure(function () {
            // To detect if the navigation is overflowing, we check if any item's right side is beyond the right side of the grid
            if (headerGrid) {
              const gridRight = Math.round(headerGrid.getBoundingClientRect().right);
              const headerItems = headerGrid.querySelectorAll('.ShopHeader__Item');
              for (let i = headerItems.length - 1; i >= 0; i--) {
                const itemRight = Math.round(headerItems[i].getBoundingClientRect().right);
                if (itemRight > gridRight) {
                  isOverlapping = true;
                  break;
                }
              }
            }
          });
        }

        fastdom.mutate(function () {
          if (isOverlapping) {
            _this5.element.classList.add('ShopHeader--overflowing');
          }
          _this5.element.classList.remove('ShopHeader--initializing');
          fastdom.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
          });
        });
      }
    }]);

    return HeaderSection;
  }();

  var FooterSection = function () {
    function FooterSection(container) {
      _classCallCheck(this, FooterSection);

      this.element = container;
      var localePopoverElement = document.getElementById('footer-locale-popover');

      if (localePopoverElement) {
        this.localePopover = new Popover(localePopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        });
      }

      var currencyPopoverElement = document.getElementById('footer-currency-popover');

      if (currencyPopoverElement) {
        this.currencyPopover = new Popover(currencyPopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        });
      }
    }

    _createClass(FooterSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.localePopover) {
          this.localePopover.destroy();
        }

        if (this.currencyPopover) {
          this.currencyPopover.destroy();
        }
      }
    }]);

    return FooterSection;
  }();

  var InstagramPostsSection = function () {
    function InstagramPostsSection(container) {
      _classCallCheck(this, InstagramPostsSection);

      this.element = container;
      this.sliderElement = this.element.querySelector('.Slider');

      this.init();
    }

    _createClass(InstagramPostsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.slider.disable();
        this.resizeObserver.disconnect();
      }
    }, {
      key: "init",
      value: function init() {
        if (this.sliderElement && !this.slider) {
          this.slider = new Slider(this.sliderElement);
          this.resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
              if (entry.target.querySelector('iframe.instagram-media-rendered')) {
                this.slider.onResize();
              }
            }
          });
          this.resizeObserver.observe(this.sliderElement.querySelector('.Slider__Slide'));
        }
      }
    }]);

    return InstagramPostsSection;
  }();

  var LoginSection = function () {
    function LoginSection(container) {
      _classCallCheck(this, LoginSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.customerLoginForm = this.element.querySelector('#customer_login');
      this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');
      this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
    }

    _createClass(LoginSection, [{
      key: "_showRecoverPassword",
      value: function _showRecoverPassword() {
        var isLoginActive = this.customerLoginForm.style.display === 'block';

        if (isLoginActive) {
          this.customerLoginForm.style.display = 'none';
          this.recoverPasswordForm.style.display = 'block';
        }
        else {
          this.customerLoginForm.style.display = 'block';
          this.recoverPasswordForm.style.display = 'none';
        }
      }
    }]);

    return LoginSection;
  }();

  var MultiColumnSection = function () {
    function MultiColumnSection(container) {
      _classCallCheck(this, MultiColumnSection);

      this.element = container;
      this.sliderElement = this.element.querySelector('.Slider');

      this.init();
    }

    _createClass(MultiColumnSection, [{
      key: "init",
      value: function init() {
        if (this.sliderElement && !this.slider) this.slider = new Slider(this.sliderElement);
      }
    }]);

    return MultiColumnSection;
  }();

  var NewsletterPopupSection = function () {
    function NewsletterPopupSection(element) {
      _classCallCheck(this, NewsletterPopupSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(element.getAttribute('data-section-settings'));
      
      // If the popup has been already displayed, we do not display it
      try {
        if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
          this._openPopup();
        } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
          setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
        }
      } catch (error) {
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }

      this._attachListeners();
    }

    _createClass(NewsletterPopupSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._openPopup();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this._closePopup();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
      }
    }, {
      key: "_openPopup",
      value: function _openPopup() {
        this.element.setAttribute('aria-hidden', 'false');
        localStorage.setItem('themePopup', 'true');
      }
    }, {
      key: "_closePopup",
      value: function _closePopup() {
        this.element.setAttribute('aria-hidden', 'true');
      }
    }]);

    return NewsletterPopupSection;
  }();

  var ProductRecommendationsSection = function () {
    function ProductRecommendationsSection(container) {
      _classCallCheck(this, ProductRecommendationsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (this.options['useRecommendations']) {
        this._loadRecommendations().then(this._createSlideshow.bind(this));
      } else {
        this._createSlideshow();
      }
    }

    _createClass(ProductRecommendationsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.disable();
      }
    }, {
      key: "_loadRecommendations",
      value: function _loadRecommendations() {
        var _this = this;

        var url = "".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&product_id=").concat(this.options['productId'], "&limit=").concat(this.options['recommendationsCount']);
        return fetch(url).then(function (response) {
          return response.text().then(function (content) {
            var container = document.createElement('div');
            container.innerHTML = content;
            const liveContainer = _this.element.querySelector('.ProductRecommendations');
            liveContainer.innerHTML = container.querySelector('.ProductRecommendations').innerHTML;
            document.dispatchEvent(new CustomEvent('theme:product_carousel:loaded', { detail: _this.element }));
            document.dispatchEvent(new CustomEvent('theme:tracking:init', { detail: { element: liveContainer } }));
            InitFunctions.initButtonLoading(liveContainer);
          });
        });
      }
    }, {
      key: "_createSlideshow",
      value: function _createSlideshow() {
        var carouselElement = this.element.querySelector('.Slider');

        if (!carouselElement) {
          return;
        }

        this.carousel = new Slider(carouselElement);
      }
    }]);

    return ProductRecommendationsSection;
  }();

  var ProductImageSlider = function () {
    function ProductImageSlider(container, options, variantData) {

      _classCallCheck(this, ProductImageSlider);

      this.container = container;

      const productSlideshowElement = this.container.querySelector('.Product__Slideshow .Slider');
      if (productSlideshowElement) {
        this.productSlideshow = new Slider(productSlideshowElement);
        this.allSlides = Array.from(this.productSlideshow.slides);
        this.mediaList = {}; // Keep track of all videos
        this.previouslySelectedMedia = null; // Keep track of the previously selected media
        this.currentVariantGroup = 'all';
        this.options = options;
        this.variantData = variantData;

        // Slideshow nav
        if (this.options.enableThumbnailNav) {
          this.enableThumbnailNav();
        }

        // Only display variant images
        if (this.productSlideshow.slides.length > 1) {
          const variantSelections = this.container.querySelectorAll('.ProductForm__Option .ProductForm__Item');
          let variantGroup = '';
          if (variantSelections.length > 0) {
            variantSelections.forEach((elem) => {
              const selectedVariantElement = this.container.querySelector(`#${elem.getAttribute('aria-controls')} .Popover__ValueList button.is-selected`);
              if (selectedVariantElement) {
                if (variantGroup !== '') {
                  variantGroup += ' / ';
                }
                variantGroup += selectedVariantElement.getAttribute('data-value');
              }
            });
          }
          else {
            const selectedVariantElement = document.querySelector('.ProductForm__Variants input[type="radio"][checked="checked"]:not([name="advantage-package-pseudo-variant"])');
            variantGroup = selectedVariantElement && selectedVariantElement.value || '';
          }
          if (this.variantData && this.variantData.length > 1) {
            if (variantGroup === '' && this.variantData[0]) variantGroup = this.variantData[0].title;
            this.allSlides.forEach(slide => this.productSlideshow.removeSlide(slide));
            this.reloadSlider(variantGroup);
          }
          else {
            // Hide images that are set to be hidden
            let foundHiddenImages = false;
            this.allSlides.forEach(slide => {
              if (slide.getAttribute('data-media-visible') === 'false') {
                this.productSlideshow.removeSlide(slide);
                foundHiddenImages = true;
              }
            });
            if (foundHiddenImages) this.reloadSlider(variantGroup);
          }
        }

        // Set slideshow visible
        this.productSlideshow.enable();
        productSlideshowElement.classList.remove('is-hidden');

        // Enable features in A/B testing
        productSlideshowElement.addEventListener('theme:slider:reload', (e) => {
          if (e.detail.defaultImagePosition) this.options.defaultImagePosition = e.detail.defaultImagePosition;
          if (e.detail.enableThumbnailNav) {
            this.options.enableThumbnailNav = e.detail.enableThumbnailNav;
            this.enableThumbnailNav();
            this.thumbnailNavElement.classList.remove('none');
            // Remove all slides too because otherwise the nav will not be built correctly on reload
            if (this.variantData && this.variantData.length > 1) this.allSlides.forEach(slide => this.productSlideshow.removeSlide(slide));
            this.productSlideshow.config.nav = false;
          }
          if (e.detail.showHiddenImage) {
            this.allSlides.forEach(slide => {
              if (slide.getAttribute('data-media-visible') !== 'false') return;
              if (e.detail.showHiddenImage === 'all' || e.detail.showHiddenImage === slide.getAttribute('data-media-id')) {
                slide.setAttribute('data-media-visible', 'true');
              }
            });
          }
          this.reloadSlider(this.currentVariantGroup);
        });
      }
    
    }

    _createClass(ProductImageSlider, [{
      key: 'enableThumbnailNav',
      value: function enableThumbnailNav() {
        this.thumbnailNavElement = this.container.querySelector('.Product__SlideshowNav');
        if (!this.thumbnailNavElement) return;
        this.thumbnailNavContent = this.thumbnailNavElement.querySelector('.scroll-list__content');
        this.allThumbnails = Array.from(this.thumbnailNavElement.querySelectorAll('.Product__SlideshowNavItem'));
        if (this.variantData && this.variantData.length > 1) {
          this.allThumbnails.forEach(thumbnail => thumbnail.remove());
          this.currentThumbnails = [];
        }
        else {
          this.currentThumbnails = this.allThumbnails;
          this.currentThumbnails.forEach(thumbnail => thumbnail.addEventListener('click', this.onThumbnailSelect.bind(this)));
          this.selectThumbnail(this.productSlideshow.currentIndex || 0);
        }
        this.productSlideshow.config.onSlideEnter = (slide) => {
          const index = this.productSlideshow.slides.indexOf(slide);
          this.selectThumbnail(index);
        }
        this.thumbnailNavElement.classList.remove('is-hidden');
      }
    },
    {
      key: 'addThumbnail',
      value: function addThumbnail(thumbnail, index) {
        if (this.currentThumbnails.includes(thumbnail)) return;
        if (index >= this.currentThumbnails.length || this.currentThumbnails.length === 0) {
          this.thumbnailNavContent.appendChild(thumbnail);
          this.currentThumbnails.push(thumbnail);
        }
        else {
          this.thumbnailNavContent.insertBefore(thumbnail, this.currentThumbnails[index]);
          this.currentThumbnails.splice(index, 0, thumbnail);
        }
        thumbnail.addEventListener('click', this.onThumbnailSelect.bind(this));
      }
    },
    {
      key: 'removeThumbnail',
      value: function removeThumbnail(thumbnail) {
        thumbnail.remove();
        this.currentThumbnails = this.currentThumbnails.filter(item => item !== thumbnail);
      }
    },
    {
      key: 'selectThumbnail',
      value: function selectThumbnail(index) {
        this.currentThumbnails.forEach(item => item.classList.remove('is-selected'));
        this.currentThumbnails[index].classList.add('is-selected');
      }
    },
    {
      key: 'onThumbnailSelect',
      value: function onThumbnailSelect(e) {
        const index = this.currentThumbnails.indexOf(e.currentTarget);
        this.selectThumbnail(index);
        this.productSlideshow.select(index);
      }
    },
    {
      key: 'reloadSlider',
      value: function reloadSlider(variantGroup) {
        if (!this.productSlideshow.slides) return;
        this.currentVariantGroup = variantGroup;
        let defaultImage, defaultThumbnail;
        for (let i = 0; i < this.allSlides.length; i++) {
          const cellElement = this.allSlides[i],
                cellGroup = cellElement.getAttribute("data-media-variant-group"),
                cellType = cellElement.getAttribute("data-media-image-type"),
                cellPosition = parseInt(cellElement.getAttribute("data-media-position")),
                currentSlides = this.productSlideshow.slides;
          if (cellElement.getAttribute('data-media-visible') === 'false') continue;
          if (cellGroup.includes(':')) {
            // Media group addresses a single option instead of specific variant
            const optionValue = cellGroup.split(':')[1];
            if (!variantGroup.split('/').map(group => group.trim()).includes(optionValue)) {
              if (currentSlides.includes(cellElement)) {
                this.productSlideshow.removeSlide(cellElement);
                if (this.options.enableThumbnailNav) this.removeThumbnail(this.allThumbnails[i]);
              }
            }
            else {
              let addAtIndex = currentSlides.length;
              if (!currentSlides.includes(cellElement)) {
                for (let k = currentSlides.length - 1; k >= 0; k--) {
                  const kSlide = currentSlides[k],
                        kGroup = kSlide.getAttribute('data-media-variant-group');
                  if (kGroup === 'all' || (kGroup.includes(':') && parseInt(kSlide.getAttribute('data-media-position')) > cellPosition)) {
                    addAtIndex = k;
                    break;
                  }
                }
                this.productSlideshow.addSlide(cellElement, addAtIndex);
                if (this.options.enableThumbnailNav) this.addThumbnail(this.allThumbnails[i], addAtIndex);
              }
            }
          }
          else if (cellGroup !== 'all' && cellGroup !== variantGroup) {
            // Media group does not match
            if (currentSlides.includes(cellElement)) {
              this.productSlideshow.removeSlide(cellElement);
              if (this.options.enableThumbnailNav) this.removeThumbnail(this.allThumbnails[i]);
            }
          }
          else if (cellGroup === variantGroup || (cellGroup === 'all' && this.variantData.length === 1)) {
            // Media corresponds to current variant
            if (cellType === 'default') {
              this.productSlideshow.removeSlide(cellElement);
              if (this.options.enableThumbnailNav) this.removeThumbnail(this.allThumbnails[i]);
              defaultImage = cellElement;
              if (this.options.enableThumbnailNav) defaultThumbnail = this.allThumbnails[i];
            }
            else if (!currentSlides.includes(cellElement)) {
              let addAtIndex = currentSlides.length;
              for (let k = currentSlides.length - 1; k >= 0; k--) {
                const kSlide = currentSlides[k],
                      kGroup = kSlide.getAttribute('data-media-variant-group');
                if (cellGroup === 'all') {
                  if (kGroup === 'all' && parseInt(kSlide.getAttribute('data-media-position') > cellPosition)) {
                    addAtIndex = k;
                    break;
                  }
                }
                else {
                  if (kGroup === 'all' || kGroup.includes(':') || parseInt(kSlide.getAttribute('data-media-position') > cellPosition)) {
                    addAtIndex = k;
                    break;
                  }
                }
              }
              this.productSlideshow.addSlide(cellElement, addAtIndex);
              if (this.options.enableThumbnailNav) this.addThumbnail(this.allThumbnails[i], addAtIndex);
            }
          }
          else if (!currentSlides.includes(cellElement)) {
            let addAtIndex = currentSlides.length;
            for (let k = currentSlides.length - 1; k >= 0; k--) {
              const kSlide = currentSlides[k],
                    kGroup = kSlide.getAttribute('data-media-variant-group');
              if (kGroup === 'all' && parseInt(kSlide.getAttribute('data-media-position') > cellPosition)) {
                addAtIndex = k;
                break;
              }
            }
            this.productSlideshow.addSlide(cellElement, addAtIndex);
            if (this.options.enableThumbnailNav) this.addThumbnail(this.allThumbnails[i], addAtIndex);
          }
        }
        if (defaultImage) {
          if (this.options.defaultImagePosition === 'end' && this.productSlideshow.slides.some(slide => slide.getAttribute('data-media-image-type').includes('presentation'))) {
            this.productSlideshow.addSlide(defaultImage, this.productSlideshow.slides.length);
            if (this.options.enableThumbnailNav) this.addThumbnail(defaultThumbnail, this.currentThumbnails.length);
          }
          else {
            this.productSlideshow.addSlide(defaultImage, 0);
            if (this.options.enableThumbnailNav) this.addThumbnail(defaultThumbnail, 0);
          }
        }
        this.productSlideshow.init();
        this.productSlideshow.select(0);
        if (this.options.enableThumbnailNav) {
          this.thumbnailNavElement.dispatchEvent(new CustomEvent('theme:hsl:refresh'));
          this.selectThumbnail(0);
        }
      }
    }]);

    return ProductImageSlider;
  }();

  var ProductSection = function () {
    function ProductSection(container) {
      var _this = this;

      _classCallCheck(this, ProductSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      if (!['not-for-sale', 'bundle-exclusive'].includes(this.options['templateSuffix'])) {
        this.productVariants = new ProductVariants(container, this.options);
      }

      // Save product information for further processing
      const productJson = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
      this.variantData = productJson && productJson.product && productJson.product.variants;
      this.productOptions = productJson && productJson.product && productJson.product.options;

      this.productImageSlider = new ProductImageSlider(this.element, this.options, this.variantData);

      this.productWrapperElement = this.element.querySelector('.Product__Wrapper');
      this.productInfoElement = this.element.querySelector('.Product__Info');
      this.productGalleryElement = this.element.querySelector('.Product__Gallery');

      this._setupDeviceFeatures();
      this._attachListeners();

      // Sticky add to cart
      this.stickyBar = document.querySelector('.StickyAddToCart');
      if (this.stickyBar) {
        this.stickyBarHidden = true;
        this.observerVisibleElements = new Set();
        this.stickyBarObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              _this.observerVisibleElements.add(entry.target);
            }
            else {
              _this.observerVisibleElements.delete(entry.target);
            }
          });
          const newHidden = _this.observerVisibleElements.size == 0 ? false : true;
          if (_this.stickyBarHidden != newHidden) {
            _this.stickyBarHidden = newHidden;
            _this.stickyBar.setAttribute('aria-hidden', newHidden);
            document.documentElement.style.setProperty('--sticky-cta-height', newHidden ? '0' : `${_this.stickyBar.offsetHeight}px`);
          }
        }, {
          threshold: 0.25
        });
        const observables = [
          document.querySelector('.ProductMeta'),
          document.querySelector('.ProductForm__AddToCart '),
          document.querySelector('[id$="__product-recommendations"]'),
          document.querySelector('[id$="__recently-viewed-products"]'),
          document.querySelector('#shopify-section-shop-footer')
        ];
        observables.forEach((observable) => {
          if (observable) _this.stickyBarObserver.observe(observable);
        });
      }

      // Advantage variant selection
      const advantageElement = this.element.querySelector('.advantage-variant-list');
      if (advantageElement) {
        this.variantHeadline = this.element.querySelector('.ProductForm__Label--advantage');
        this.defaultVariantElement = advantageElement.querySelector('.advantage-variant-list input.AdvantageVariant__Radio');
        if (!this.defaultVariantElement.checked) {
          const selectedVariant = advantageElement.querySelector('input[type="radio"][checked="checked"]').value;
          this._advantageSelection(null, selectedVariant);
        }
        this.defaultVariantElement = this.defaultVariantElement.closest('li');
        document.addEventListener('advantage_package:changed', this._advantageSelection.bind(this));
      }

      // Hashtag variant selection / collapsible opener for products
      let rawHash = window.location.hash;
      if (!rawHash) { // Workaround to get hash from search because Instagram URI-encodes #
        const search = decodeURIComponent(window.location.search);
        if (search.includes('#')) {
          const searchArr = search.split('#')
          rawHash = searchArr[searchArr.length - 1];
        }
      }
      else {
        rawHash = decodeURIComponent(rawHash);
      }
      if (window.theme.pageType === 'product' && rawHash) {
        let hash = rawHash.replace('#', '').replaceAll('_', ' ');
        hash = hash.includes('?') ? hash.split('?')[0] : hash;
        const variants = hash.split('&');
        let hashIsVariant = false;
        // Variant selection
        const variantPopovers = document.querySelectorAll('.Product__OffScreen .OptionSelector');
        for (let i = 0, shift = 0; i - shift < variants.length && i < variantPopovers.length; i++) {
          const variantItems = variantPopovers[i].querySelectorAll('button.Popover__Value'),
                variantHandle = window.handleize(variants[i - shift]);
          let found = false;
          for (let k = 0; k < variantItems.length; k++) {
            if (window.handleize(variantItems[k].getAttribute('data-value')) === variantHandle) {
              const clickElement = variantItems[k].querySelector('img') || variantItems[k];
              clickElement.click();
              found = true;
              hashIsVariant = true;
              break;
            }
          }
          if (!found) {
            shift++;
          }
        }
        // Collapsible opener
        if (!hashIsVariant) {
          const collapsibles = Dom.nodeListToArray(document.querySelectorAll('.Collapsible')),
                announcementBar = document.getElementById('shopify-section-announcement');
          let announcementHeight = 0;
          if (announcementBar) {
            announcementHeight = announcementBar.offsetHeight;
          }
          for (let i = 0; i < collapsibles.length; i++) {
            const collapsible = collapsibles[i],
                  button = collapsible.querySelector('.Collapsible__Button');
            if (window.handleize(button.innerText) === window.handleize(hash)) {
              window.scrollTo({
                behavior: 'smooth',
                top: collapsible.offsetTop - announcementHeight
              });
              button.click();
              break;
            }
          }
        }
      }

      // Initialize variant availability hints
      this._renderVariantAvailability();

      // Init section-based horizontal menu
      const navigationBar = document.querySelector('.NavigationBar');
      if (navigationBar) {
        this.navigationBar = navigationBar;
        const horizontalMenu = document.querySelector('.NavigationList');
        const itemTemplate = horizontalMenu.querySelector('.NavigationList__Item--template');
        const titledSections = document.querySelectorAll('[data-section-title]');
        if (titledSections.length === 0) {
          this.navigationBar.style = "visibility: hidden;";
        }
        else {
          titledSections.forEach((section, index) => {
            const anchor = document.createElement('DIV');
            anchor.classList.add('Anchor');
            const sectionTitle = section.getAttribute('data-section-title');
            anchor.id = sectionTitle.replaceAll('ä', 'ae').replaceAll('ö', 'oe').replaceAll('ü', 'ue').replaceAll('ß', 'ss').replaceAll(' ', '_');
            // Prefer to inject anchor inside header
            const header = section.querySelector('header');
            if (header) {
              header.prepend(anchor);
            } else {
              section.parentElement.insertBefore(anchor, section);
            }
            const menuItemWrapper = document.createElement('DIV');
            menuItemWrapper.innerHTML = itemTemplate.outerHTML.replace(' NavigationList__Item--template', `${index === 0 ? ' is-active' : ''}`).replaceAll('%anchor%', anchor.id).replaceAll('%title%', sectionTitle);
            horizontalMenu.appendChild(menuItemWrapper.firstChild);
          });
          // Add intersection observer to hide navigation bar if user scrolled below product content
          this.navigationBarHidden = false;
          this.navigationObserverVisibleElements = new Set();
          this.lastTitledSectionVisible = false;
          this.navigationBarObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.target.hasAttribute('data-section-title')) {
                this.lastTitledSectionVisible = entry.isIntersecting;
              }
              else {
                if (entry.isIntersecting) {
                  _this.navigationObserverVisibleElements.add(entry.target);
                }
                else {
                  _this.navigationObserverVisibleElements.delete(entry.target);
                }
              }
            });
            const newHidden = _this.navigationObserverVisibleElements.size == 0 || this.lastTitledSectionVisible ? false : true;
            if (_this.navigationBarHidden != newHidden) {
              _this.navigationBarHidden = newHidden;
              _this.navigationBar.setAttribute('aria-hidden', newHidden);
            }
          }, {
            threshold: 0.2
          });
          const observables = [
            titledSections[titledSections.length - 1],
            document.querySelector('[id$="__product-recommendations"]'),
            document.querySelector('[id$="__recently-viewed-products"]'),
            document.querySelector('#shopify-section-shop-footer')
          ];
          observables.forEach((observable) => {
            if (observable) _this.navigationBarObserver.observe(observable);
          });
        }

        itemTemplate.remove();
      }

      // Init nutrition selector
      const nutritionSelector = this.element.querySelector('select[data-action="set-nutrition"]');
      if (nutritionSelector) {
        nutritionSelector.addEventListener('change', this._setNutrition.bind(this));
        document.addEventListener('variant:changed', this._setNutrition.bind(this));
        this.nutritionSelector = nutritionSelector;
      }
    }

    _createClass(ProductSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.productVariants) {
          this.productVariants.destroy();
        }

        if (this.productSlideshow) {
          this.productSlideshow.destroy();
        }

        if (this.carouselNavScrollSpy) {
          this.carouselNavScrollSpy.destroy();
        }

        if (this.productInfoScroller) {
          this.productInfoScroller.destroy();
        }

        if (this.productThumbnailsScroller) {
          this.productThumbnailsScroller.destroy();
        }

        if (window.ResizeObserver && this.productInfoResizeObserver) {
          this.productInfoResizeObserver.disconnect();
        }

        if (this.stickyBarObserver) {
          this.stickyBarObserver.disconnect();
        }

        if (this.navigationBarObserver) {
          this.navigationBarObserver.disconnect();
        }

        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
        this.delegateElement.on('click', '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));
        this.delegateElement.on('variant:changed', this._updateSlideshowImages.bind(this));
        this.delegateElement.on('variant:changed', this._renderVariantAvailability.bind(this));
        this.delegateElement.on('video:played', this._onMediaPlayed.bind(this));
        this.delegateElement.on('video:paused', this._onMediaPaused.bind(this));
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);

        this.delegateElement.on('click', '.Product__SlideshowNavDot, .Product__SlideshowNavArrow', this._switchToImage.bind(this));

        const productForm = this.element.querySelector('form.ProductForm');
        if (productForm) {
          productForm.addEventListener('submit', (e) => {
            e.preventDefault();
          });
        }
      }
    }, {
      key: '_renderVariantAvailability',
      value: function _renderVariantAvailability() {
        const optionSelectors = this.element.querySelectorAll('.OptionSelector:not(.PopoverGlobal)'),
              currentOptions = [],
              selectedElements = [];
        if (!this.variantData || !this.productOptions || optionSelectors.length != this.productOptions.length) {
          return;
        }
        // Create an availability map containing variant titles and availability to improve performance
        if (!this.availabilityMap) {
          this.availabilityMap = new Map();
          for (let i = 0; i < this.variantData.length; i++) {
            const variant = this.variantData[i],
                  mapKey = []
            for (let k = 1; k <= this.productOptions.length; k++) {
              mapKey[k-1] = variant['option' + k];
            }
            this.availabilityMap.set(mapKey.join(' / '), variant.available);
          }
        }
        // Determine the currently selected options
        for (let i = 0; i < optionSelectors.length; i++) {
          const selected = optionSelectors[i].querySelector('.is-selected[data-action="select-value"]');
          if (selected) {
            currentOptions[i] = selected.getAttribute('data-value');
            selectedElements[i] = selected;
          }
        }
        // Initally remove availability attribute from second option selector
        if (optionSelectors.length == 2) {
          const optionButton = this.element.querySelector('[aria-controls="' + optionSelectors[1].id + '"]');
          if (optionButton) {
            optionButton.removeAttribute('data-availability');
          }
        }
        // Go through all option selectors to calculate availability for every option instance. If an option instance is not available in every
        // combination with other options it gets is 'sold-out'. If the option instance is the currently selected one in the first option selector,
        // the second option selector - if existent - gets 'other-option'.
        for (let i = 0; i < optionSelectors.length; i++) {
          const options = optionSelectors[i].querySelectorAll('[data-action="select-value"]');
          for (let k = 0; k < options.length; k++) {
            const option = options[k],
                  variant = Array.from(currentOptions);
            variant[i] = option.getAttribute('data-value');
            const variantAvailability = this.availabilityMap.get(variant.join(' / '));
            option.disabled = false;
            if (variantAvailability === true) {
              option.setAttribute('data-availability', 'available');
            }
            else {
              if (i === 1 && variantAvailability === undefined) {
                option.setAttribute('data-availability', 'non-existent');
                option.disabled = true;
                continue;
              }
              let otherVariantFound = false;
              if (i == 0 && this.productOptions.length == 2) {
                const mapKeys = Array.from(this.availabilityMap.keys()).filter((name) => {
                  let keep = name.includes(variant[0]);
                  for (let j = 1; j < variant.length; j++) {
                    keep = keep && !name.includes(variant[j]);
                  }
                  return keep;
                });
                if (mapKeys.length > 0) {
                  for (let j = 0; j < mapKeys.length; j++) {
                    const key = mapKeys[j];
                    if (this.availabilityMap.get(key)) {
                      otherVariantFound = true;
                      break;
                    }
                  }
                }
              }
              if (otherVariantFound && option == selectedElements[i]) {
                const optionButton = this.element.querySelector('[aria-controls="' + optionSelectors[1].id + '"]');
                if (optionButton) {
                  optionButton.setAttribute('data-availability', 'other-option');
                }
              }
              else if (otherVariantFound) {
                option.setAttribute('data-availability', 'available');
              }
              else {
                option.setAttribute('data-availability', 'sold-out');
              }
            }
          }
        }
        // Customize the link to vegan product to fit the selected size
        if (this.productOptions.length == 2) {
          const additionalLink = optionSelectors[0].querySelector('a.Popover__Value:not([data-action])');
          if (additionalLink) {
            let newHref = additionalLink.href;
            if (newHref.includes('#')) {
              newHref = newHref.split('#')[0];
            }
            newHref += '#' + currentOptions[1].replaceAll(' ', '_');
            additionalLink.href = newHref;
          }
        }
      }
    }, {
      key: '_advantageSelection',
      value: function _advantageSelection(event, variantTitle) {
        if (event) {
          if (this.defaultVariantElement) {
            this.defaultVariantElement.classList.remove('none');
            this.variantHeadline.textContent = `Variante: ${event.detail.variant.title}`;
          }
        }
        else {
          if (this.variantHeadline) {
            this.variantHeadline.textContent = `Variante: ${variantTitle}`;
          }
        }
      }
    }, {
      key: "_setNutrition",
      value: function _setNutrition(e) {
        const variantId = e.type === 'change' ? e.target.value : e.detail.variant && e.detail.variant.id;
        if (!variantId) return;
        if (e.type !== 'change') this.nutritionSelector.value = variantId;
        const nutritionContainer = this.element.querySelector('.Nutrition');
        nutritionContainer.querySelectorAll('[data-nutrition-variant]:not(.none)').forEach(element => {
          element.classList.add('none');
        });
        nutritionContainer.querySelectorAll(`[data-nutrition-variant="${variantId}"]`).forEach(element => {
          element.classList.remove('none');
        });
      }
    }, {
      /**
       * Update the main carousel image
       */
      key: "_updateSlideshowImages",
      value: function _updateSlideshowImages(event) {
        var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant;

        if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
          return;
        }
        
        // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor
        this._slideWillChange();

        let variantTitle = variant && variant.title;
        this.productImageSlider.reloadSlider(variantTitle);
      }
    }, {
      /**
       * This happens when a media is played
       */
      key: "_onMediaPlayed",
      value: function _onMediaPlayed(event) {
        // Remove draggability
        this.productSlideshow.config.isDraggable = false;

        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
          this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
        }
      }
    }, {
      /**
       * This happens when a given media is paused
       */
      key: "_onMediaPaused",
      value: function _onMediaPaused() {
        // Enable draggability
        this.productSlideshow.config.isDraggable = true;
      }
    }, {
      /**
       * This method is called when a media changed in the slideshow
       */
      key: "_handleMedia",
      value: function _handleMedia(item) {
        // First, we need to turn off the previous media (if any)
        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
          switch (this.previouslySelectedMedia.getAttribute('data-media-type')) {
            case 'video':
            case 'external_video':
              this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
              break;
            case 'wistia_slider_video':
              let wistiaVideo = this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')];
              if (typeof wistiaVideo !== 'undefined') {
                wistiaVideo.hasBeenDeselected();
              }
              break;
          }
        }
        
        // Then, we have to handle the currently selected media
        switch (item.getAttribute('data-media-type')) {
          case 'video':
          case 'external_video':
            this.mediaList[item.getAttribute('data-media-id')].hasBeenSelected();
            break;
          case 'wistia_slider_video':
            const wistiaVideo = this.mediaList[item.getAttribute('data-media-id')];
            if (wistiaVideo) {
              wistiaVideo.hasBeenSelected();
            }
            break;
        }
        
        // We set the previously selected media to the currently new one, so that when it changes it can be properly accounted
        this.previouslySelectedMedia = item;
      }
    }, {
      key: "_switchToImage",
      value: function _switchToImage(event, target) {
        event.preventDefault();

        this._slideWillChange();

        if (target.hasAttribute('data-direction')) {
          if (target.getAttribute('data-direction') === 'next') {
            this.productSlideshow.next();
          } else {
            this.productSlideshow.previous();
          }
          return;
        }

        for (var i = 0; i !== this.productSlideshow.slides.length; ++i) {
          var cellElement = this.productSlideshow.slides[i].element,
              mediaId = cellElement.getAttribute('data-media-id');

          if (mediaId === target.getAttribute('data-media-id')) {
            this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
          }
        }
      }
    }, {
      /**
       * Toggle the social share icons
       */
      key: "_toggleSocialShare",
      value: function _toggleSocialShare(event, target) {
        target.classList.toggle('is-active');
        target.classList.toggle('RoundButton--secondaryState');
        target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        target.nextElementSibling.setAttribute('aria-hidden', target.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
    }, {
      key: "_onImageChanged",
      value: function _onImageChanged(event, cell) {
        // If cell is video or model, we hide the action list
        if (Responsive.matchesBreakpoint('pocket')) {
          var productGalleryActionListElement = this.element.querySelector('.Product__Gallery .Product__ActionList');

          if (productGalleryActionListElement) {
            if (cell.classList.contains('Product__SlideItem--image')) {
              productGalleryActionListElement.classList.remove('is-hidden');
            } else {
              productGalleryActionListElement.classList.add('is-hidden');
            }
          }
        }
        
        // If we have non-stacked with thumbnails, update it
        var mediaId = cell.getAttribute('data-media-id');
        this.slideshowNavItems.forEach(function (thumbnail) {
          if (thumbnail.getAttribute('data-media-id') === mediaId) {
            thumbnail.classList.add('is-selected');
          } else {
            thumbnail.classList.remove('is-selected');
          }
        });
      }
    }, {
      key: "_onImageSettled",
      value: function _onImageSettled(index, cell) {
        this._handleMedia(cell);

        if (Responsive.matchesBreakpoint('lap-and-up')) {
          var slides = this.element.querySelectorAll('.Product__SlideItem:not(.is-selected)');
          slides.forEach(function (slide) {
            slide.classList.add('Product__SlideItem--hidden');
          });
        }
      }
    }, {
      key: "_slideWillChange",
      value: function _slideWillChange() {
        if (Responsive.matchesBreakpoint('lap-and-up')) {
          var slides = this.element.querySelectorAll('.Product__SlideItem');
          slides.forEach(function (slide) {
            slide.classList.remove('Product__SlideItem--hidden');
          });
        }
      }
    }, {
      /**
       * Verify when the screen size changes to create additional stuff on non pocket mode
       */
      key: "_setupDeviceFeatures",
      value: function _setupDeviceFeatures(event) {
        var _this4 = this;

        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;

        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }

        if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
          if (this.carouselNavScrollSpy) {
            this.carouselNavScrollSpy.destroy();
          }

          if (this.productInfoScroller) {
            this.productInfoScroller.destroy();
          }

          if (this.productThumbnailsScroller) {
            this.productThumbnailsScroller.destroy();
          }

          this.productWrapperElement.style.minHeight = null;

          this.productInfoElement.parentNode.style.maxHeight = null;
        } else {
          var productInfoStyles = window.getComputedStyle(this.productInfoElement),
              productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
              productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0; // 2nd: making sure to set up enough space in aside part

          var calculateMinHeight = function calculateMinHeight() {
            _this4.productWrapperElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop), "px");
          };

          calculateMinHeight(); // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
          // will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
          // but I feel it's already good to have a clean fix

          if (window.ResizeObserver) {
            this.productInfoResizeObserver = new ResizeObserver(function () {
              calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
            });
            this.productInfoResizeObserver.observe(this.productInfoElement);
          }
          
          // 3rd: let's handle the scroll for the product info
          this.productInfoScroller = new OverflowScroller(this.productInfoElement);
          
          // 4th: let's handle the scroll for the thumbnails
          if (this.slideshowNav) {
            this.productThumbnailsScroller = new OverflowScroller(this.slideshowNav);
          }
        }
      }
    }]);

    return ProductSection;
  }();

  var RecentlyViewedProductsSection = function () {
    function RecentlyViewedProductsSection(container) {
      _classCallCheck(this, RecentlyViewedProductsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (this.options['productId']) {
        this._saveProduct(this.options['productId']);
      }

      this._fetchProducts();
    }

    _createClass(RecentlyViewedProductsSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.disable();
        }
      }
    }, {
      /**
       * When we are on a product page, we need to save the current product into local storage
       */
      key: '_saveProduct',
      value: function _saveProduct(productId) {
        var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

        // We check if the current product already exists, and if it does not, we add it at the start
        if (!items.includes(productId)) {
          items.unshift(productId);
        }

        // Then, we save the current product into the local storage, by keeping only the 8 most recent
        try {
          localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
        } catch (error) {
          // Do nothing, this may happen in Safari in incognito mode
        }
      }
    }, {
      /**
       * In order to get the products to display, we hit the search template with the given IDS
       */
      key: "_fetchProducts",
      value: function _fetchProducts() {
        var _this = this;

        var queryString = this._getSearchQueryString();

        if (queryString === '') {
          return;
        }
        
        // If we have a non empty query string we do a search query
        fetch("".concat(window.routes.searchUrl, "?view=recently-viewed-products&type=product&q=").concat(queryString), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            var tempElement = document.createElement('div');

            tempElement.innerHTML = content;
            // Set the content
            _this.element.innerHTML = tempElement.querySelector('.Section').innerHTML;
            // Show the section
            _this.element.parentNode.style.display = 'block';
            // And finally let's create the carousel !
            _this.carousel = new Slider(_this.element.querySelector('.Slider'));

            document.dispatchEvent(new CustomEvent('theme:product_carousel:loaded', { detail: _this.element }));
            document.dispatchEvent(new CustomEvent('theme:tracking:init', { detail: { element: _this.element } }));
            InitFunctions.initButtonLoading(_this.element);
          });
        });
      }
    }, {
      key: "_getSearchQueryString",
      value: function _getSearchQueryString() {
        var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
        
        // If we are on a product template, we make sure to remove the main product from the related product
        if (items.includes(this.options['productId'])) {
          items.splice(items.indexOf(this.options['productId']), 1);
        }

        return items.map(function (item) {
          return 'id:' + item;
        }).join(' OR ');
      }
    }]);

    return RecentlyViewedProductsSection;
  }();

  /**
   * This code is extracted from Slate
   */
  var SectionContainer = function () {
    function SectionContainer() {
      _classCallCheck(this, SectionContainer);

      this.constructors = [];
      this.instances = [];

      this._attachListeners();
    }

    _createClass(SectionContainer, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
        document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
        document.addEventListener('shopify:section:select', this._onSelect.bind(this));
        document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
        document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
        document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
      }
    }, {
      key: "register",
      value: function register(type, constructor) {
        var _this = this;

        this.constructors[type] = constructor;
        Dom.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(type, "]"))).forEach(function (container) {
          _this._createInstance(container, constructor);
        });
      }
    }, {
      /**
       * Return an object from an array of objects that matches the provided key and value
       */
      key: "_findInstance",
      value: function _findInstance(array, key, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return array[i];
          }
        }
      }
    }, {
      /**
       * Remove an object from an array of objects by matching the provided key and value
       */
      key: "_removeInstance",
      value: function _removeInstance(array, key, value) {
        var i = array.length;

        while (i--) {
          if (array[i][key] === value) {
            array.splice(i, 1);
            break;
          }
        }

        return array;
      }
    }, {
      key: "_onSectionLoad",
      value: function _onSectionLoad(event) {
        var container = event.target.querySelector('[data-section-id]');

        if (container) {
          this._createInstance(container);
        }
      }
    }, {
      key: "_onSectionUnload",
      value: function _onSectionUnload(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (!instance) {
          return;
        }

        if (typeof instance.onUnload === 'function') {
          instance.onUnload(event);
        }

        this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
      }
    }, {
      key: "_onSelect",
      value: function _onSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
          instance.onSelect(event);
        }
      }
    }, {
      key: "_onDeselect",
      value: function _onDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
          instance.onDeselect(event);
        }
      }
    }, {
      key: "_onReorder",
      value: function _onReorder(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
          instance.onReorder(event);
        }
      }
    }, {
      key: "_onBlockSelect",
      value: function _onBlockSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
          instance.onBlockSelect(event);
        }
      }
    }, {
      key: "_onBlockDeselect",
      value: function _onBlockDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
          instance.onBlockDeselect(event);
        }
      }
    }, {
      key: "_createInstance",
      value: function _createInstance(container, constructor) {
        var id = container.getAttribute('data-section-id'),
            type = container.getAttribute('data-section-type');
        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
          return;
        }

        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      }
    }]);

    return SectionContainer;
  }();

  var SidebarMenuSection = function () {
    function SidebarMenuSection(container) {
      _classCallCheck(this, SidebarMenuSection);

      this.element = container;
      this.sidebarDrawer = new Drawer(container);

      this.menuOverlay = document.querySelector('.PageOverlay--menu');
      this.menuOverlay.addEventListener('click', () => {
        this.element.dispatchEvent(new CustomEvent('search:close', {
          bubbles: true
        }));
      });

      document.addEventListener('theme:sidebarMenu:close', () => {
        if (this.sidebarDrawer.isOpen) this.sidebarDrawer.close();
        if (this.menuOverlay.classList.contains('is-visible')) this.menuOverlay.classList.remove('is-visible');
      });
      
      const openSidebarButtons = document.querySelectorAll('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]');
      openSidebarButtons.forEach((button) => {
        button.addEventListener('click', this.loadContent.bind(this));
      });
      document.addEventListener('search:afteropen', () => {
        if (this.sidebarDrawer.isOpen) this.menuOverlay.classList.add('is-visible');
      });
      document.addEventListener('search:afterclose', () => {
        if (this.sidebarDrawer.isOpen) this.menuOverlay.classList.remove('is-visible');
      });
    }

    _createClass(SidebarMenuSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.sidebarDrawer.destroy();
      }
    }, {
      key: "loadContent",
      value: function loadContent() {
        if (this.element.hasAttribute('data-ajax-initialized')) return;
        this.element.classList.add('loading');
        fetch(window.location.pathname + '?section_id=sidebar-menu', {
          credentials: 'same-origin',
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        })
        .then((response) => response.text())
        .then((html) => {
          const temp = document.createElement('DIV');
          temp.innerHTML = html;
          const newDrawerContent = temp.querySelector('.Drawer__Content'),
                oldDrawerContent = this.element.querySelector('.Drawer__Content');
          if (!newDrawerContent || !oldDrawerContent) return;
          oldDrawerContent.parentNode.replaceChild(newDrawerContent, oldDrawerContent);
          this.element.classList.remove('loading');
          this.element.setAttribute('data-ajax-initialized', 'true');

          // Disable body scroll after content was loaded
          if (this.element.getAttribute('aria-hidden') === 'false') {
            Dom.disableDocumentScroll(true, this.element);
          }

          // Init scrolling to current collapsible
          this.element.querySelectorAll('[data-action="toggle-collapsible"]').forEach(collapsibleButton => {
            const parentCollapsible = collapsibleButton.closest('.Collapsible');
            const collapsibleInner = parentCollapsible.querySelector('.Collapsible__Inner');
            parentCollapsible.addEventListener('collapsible:opened', () => {
              const transitionEndListener = (e) => {
                if (e.propertyName !== 'height') return;

                e.target.removeEventListener('transitionend', transitionEndListener);
                const scrollContainer = e.target.closest('[data-scrollable]');
                if (collapsibleButton.getAttribute('aria-expanded') !== 'true') return;

                const buttonRect = collapsibleButton.getBoundingClientRect();
                const containerRect = scrollContainer.getBoundingClientRect();
                const scrollPosition = buttonRect.top - (buttonRect.height / 2) - containerRect.top + scrollContainer.scrollTop;
                // No scrolling if collapsible is in view
                if (buttonRect.top >= containerRect.top && buttonRect.bottom <= containerRect.bottom) return;

                scrollContainer.scrollTo({
                  top: scrollPosition,
                  behavior: 'smooth'
                });
              };
              collapsibleInner.addEventListener('transitionend', transitionEndListener);
            });
            // Close all second level collapsibles when parent collapsible is closed
            if (collapsibleButton.getAttribute('data-level') === '1') {
              parentCollapsible.addEventListener('collapsible:closed', () => {
                // We only need to close the first one because there is only one open at a time
                const openCollapsible = collapsibleInner.querySelector('[data-action="toggle-collapsible"][aria-expanded="true"]');
                if (openCollapsible) openCollapsible.click();
              });
            }
          });

          // Fire event when AJAX content is loaded
          document.dispatchEvent(new CustomEvent('theme:sidebarMenu:htmlLoaded'));

          if (window.loyaltylion && window.loyaltylion.ui) window.loyaltylion.ui.refresh();
        })
        .catch(function (err) {
          this.element.classList.remove('loading');
          console.error('Error on ajax section loading', err);
        });
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this.sidebarDrawer.open();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this.sidebarDrawer.close();
      }
    }]);

    return SidebarMenuSection;
  }();

  var SlideshowSection = function () {
    function SlideshowSection(container) {
      _classCallCheck(this, SlideshowSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.selectedSlide = null;
      this.shouldAnimate = true;

      // Init countdown elements
      this.countdowns = new Map();
      const countdownElements = this.element.querySelectorAll('[data-timer-date]');
      countdownElements.forEach(element => {
        this.countdowns.set(element, new Timer(element, { inactive: true }));
      });

      this.slideshow = new Slider(this.element.querySelector('.Slider'), { onSlideEnter: this._slideEnter.bind(this), onSlideLeave: this._slideLeave.bind(this) });
    }

    _createClass(SlideshowSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.slideshow.destroy();
        this.delegateElement.off();
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_slideLeave",
      value: function _slideLeave(slide) {
        const countdownElement = slide.querySelector('[data-timer-date]'),
              timer = this.countdowns.get(countdownElement);
        if (timer && timer.active) timer.stop();
      }
    }, {
      key: "_slideEnter",
      value: function _slideEnter(slide) {
        const countdownElement = slide.querySelector('[data-timer-date]'),
              timer = this.countdowns.get(countdownElement);
        if (timer && !timer.active) timer.start();
      }
    }]);

    return SlideshowSection;
  }();

  var PriceRange = function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement);

    var _super = _createSuper(PriceRange);

    function PriceRange() {
      _classCallCheck(this, PriceRange);

      return _super.apply(this, arguments);
    }

    _createClass(PriceRange, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;

        this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
        this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
        this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
        this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); // Select whole text on focus for text field to improve user experience

        this.textInputLowerBound.addEventListener('focus', function () {
          return _this.textInputLowerBound.select();
        });
        this.textInputHigherBound.addEventListener('focus', function () {
          return _this.textInputHigherBound.select();
        });
        
        // Keep in sync the range with the text input fields
        this.textInputLowerBound.addEventListener('change', function (event) {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          _this.rangeLowerBound.value = event.target.value;

          _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
        });
        this.textInputHigherBound.addEventListener('change', function (event) {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          _this.rangeHigherBound.value = event.target.value;

          _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
        });
        this.rangeLowerBound.addEventListener('change', function (event) {
          _this.textInputLowerBound.value = event.target.value;

          _this.textInputLowerBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        });
        this.rangeHigherBound.addEventListener('change', function (event) {
          _this.textInputHigherBound.value = event.target.value;

          _this.textInputHigherBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        });
        
        // We also have to bound the two range sliders
        this.rangeLowerBound.addEventListener('input', function (event) {
          event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputLowerBound.value = event.target.value;
        });
        this.rangeHigherBound.addEventListener('input', function (event) {
          event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputHigherBound.value = event.target.value;
        });
      }
    }]);

    return PriceRange;
  }(_wrapNativeSuper(HTMLElement));
  window.customElements.define('price-range', PriceRange);

  /**
   * Tracking
   */
  var ThemeTracking = function () {
    function ThemeTracking() {
      _classCallCheck(this, ThemeTracking);
      const _this = this;
      // Init theme tracking layer
      if (window.themeLayer != undefined) {
        window.themeLayer.forEach(entry => {
          processEvent(entry);
        });
      }
      window.themeLayer = [];
      window.themeLayer.push = function() {
        for (let i = 0; i < arguments.length; i++) {
          _this.processEvent(arguments[i]);
        };
        return arguments.length;
      };
      // Init delegate
      this.documentDelegate = new domDelegate.Delegate(document);
      // Init section and block tracking observer
      this.observedElements = [];
      this.seenElements = new Set();
      this.intersectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.getAttribute('aria-hidden') === 'true') return;
            const element = entry.target;
            if (element && element.hasAttribute('data-section-type')) {
              const sectionTypeAndPosition = `section:${element.getAttribute('data-section-type')}:${element.getAttribute('data-section-position')}`;
              this.seenElements.add(sectionTypeAndPosition);
              if (this.seenElements.has(sectionTypeAndPosition)) {
                window.themeLayer.push({
                  event: 'section_viewed',
                  section: this.generateSectionData(element)
                });
              }
            }
            else if (element && element.hasAttribute('data-block-type')) {
              const blockTypeAndPosition = `block:${element.getAttribute('data-block-type')}:${element.getAttribute('data-block-position')}`;
              this.seenElements.add(blockTypeAndPosition);
              if (this.seenElements.has(blockTypeAndPosition)) {
                window.themeLayer.push({
                  event: 'block_viewed',
                  section: this.generateSectionData(element.closest('[data-section-type]')),
                  block: this.generateBlockData(element)
                });
              }
            }
            this.intersectionObserver.unobserve(element);
            const index = this.observedElements.indexOf(element);
            if (index !== -1) {
              this.observedElements.splice(index, 1);
            }
          }
        });
      }, {
        rootMargin: '-20% 0px -20% 0px',
        threshold: 0
      });
      // Allow initializing elements after dom changes
      document.addEventListener('theme:tracking:init', this.initElement.bind(this));
      // Init page tracking and document listeners
      this.initPageTracking();
      this.initConsentTracking();
      this.initClickTracking();
      this.initFormTracking();
      this.initElement();
    }
    _createClass(ThemeTracking, [{
      key: "generateDocumentData",
      value: function generateDocumentData() {
        return {
          location: {
            hash: location.hash,
            host: location.host,
            hostname: location.hostname,
            href: location.href,
            origin: location.origin,
            pathname: location.pathname,
            search: location.search
          },
          referrer: document.referrer,
          title: document.title
        };
      }
    }, {
      key: "generateTemplateData",
      value: function generateTemplateData() {
        return {
          name: window.theme.template.name || '',
          suffix: window.theme.template.suffix || ''
        };
      }
    }, {
      key: "generateSectionData",
      value: function generateSectionData(section) {
        if (!section) return null;
        return {
          handle: section.getAttribute('data-section-handle') || '',
          type: section.getAttribute('data-section-type') || '',
          position: parseInt(section.getAttribute('data-section-position') || -1)
        };
      }
    }, {
      key: "generateBlockData",
      value: function generateBlockData(block) {
        if (!block) return null;
        return {
          handle: block.getAttribute('data-block-handle') || '',
          type: block.getAttribute('data-block-type') || '',
          position: parseInt(block.getAttribute('data-block-position') || -1)
        };
      }
    }, {
      key: "generateElementData",
      value: function generateElementData(element) {
        if (!element) return null;
        const urlObject = element.href && !element.href.includes('javascript:void') ? new URL(element.href) : element.hasAttribute('data-href') ? new URL(element.getAttribute('data-href')) : null;
        return {
          id: element.id || '',
          text: element.innerText || '',
          name: element.getAttribute('aria-label') || element.innerText || '',
          type: element.href ? 'link' : 'button',
          url: urlObject ? {
            hash: urlObject.hash,
            host: urlObject.host,
            hostname: urlObject.hostname,
            href: urlObject.href,
            origin: urlObject.origin,
            pathname: urlObject.pathname,
            search: urlObject.search
          } : null,
          dataset: {
            action: element.getAttribute('data-action') || ''
          },
          outbound: urlObject && urlObject.hostname !== location.hostname ? true : false
        };
      }
    }, {
      key: "generateVideoData",
      value: function generateVideoData(player) {
        if (!player) return null;
        const closestVslWrapper = player.closest('[data-progress-based-content-time]');
        return {
          name: player.name || '',
          id: player.mediaId || '',
          duration: player.duration || 0,
          currentTime: player.currentTime || 0,
          currentPercent: player.currentTime / player.duration || 0,
          percentWatched: player.percentWatched || 0,
          vsl: !!closestVslWrapper,
          vslProgressBasedContentReached: closestVslWrapper ? parseInt(closestVslWrapper.getAttribute('data-progress-based-content-time')) <= player.currentTime : false
        };
      }
    }, {
      key: "generateFormData",
      value: function generateFormData(form) {
        if (!form) return null;
        return {
          id: form.id || '',
          action: form.action || '',
          name: form.name || '',
          elements: Array.from(form.elements).map(element => ({
            id: element.id || '',
            name: element.name || '',
            type: element.type || '',
            value: element.type === 'checkbox' ? element.checked ? true : false : element.value || '',
            tagName: element.tagName
          }))
        };
      }
    }, {
      key: "initElement",
      value: function initElement(e) {
        this.observedElements = this.observedElements.filter(element => {
          if (element && element.isConnected) return true;
          this.intersectionObserver.unobserve(element);
          return false;
        });
        const element = e ? e.detail && e.detail.element : document;
        if (!element) return;
        this.initSectionTracking(element);
        this.initVideoTracking(element);
      }
    }, {
      key: "initPageTracking",
      value: function initPageTracking() {
        window.themeLayer.push({
          event: 'page_viewed'
        });

        const minScrollPercentage = 75,
              minEngagementTime = 15,
              minContentViewedTime = 60;
        let scrollPercentageReached = false,
            activeTime = 0,
            engagedFired = false,
            contentViewedFired = false;
        
        const checkEventConditions = () => {
          if (!contentViewedFired && scrollPercentageReached && activeTime >= minContentViewedTime) {
            window.themeLayer.push({
              event: 'content_viewed'
            });
            contentViewedFired = true;
          }
          if (!engagedFired && activeTime >= minEngagementTime) {
            window.themeLayer.push({
              event: 'engaged'
            });
            engagedFired = true;
          }
        };
        
        const scrollListener = () => {
          const scrollPercentage = window.scrollY / document.documentElement.scrollHeight * 100;
          if (scrollPercentage < minScrollPercentage) return;
          scrollPercentageReached = true;
          window.removeEventListener('scroll', scrollListener);
          checkEventConditions();
        }
        window.addEventListener('scroll', scrollListener, { passive: true });

        let timeListenerInterval = null;
        const timeListener = () => {
          if (document.visibilityState === 'visible') {
            activeTime++;
            if (activeTime >= minEngagementTime && activeTime >= minContentViewedTime) window.clearInterval(timeListenerInterval);
            checkEventConditions();
          }
        };
        timeListenerInterval = window.setInterval(timeListener, 1000);
      }
    }, {
      key: "initConsentTracking",
      value: function initConsentTracking() {
        window.addEventListener('theme:consent:change', (e) => {
          const consent = !!e.detail;
          window.themeLayer.push({
            event: 'consent_updated',
            consent: {
              marketingAllowed: consent,
              saleOfDataAllowed: consent,
              analyticsAllowed: consent,
              preferencesAllowed: consent
            }
          });
        });
      }
    }, {
      key: "initClickTracking",
      value: function initClickTracking() {
        this.documentDelegate.on('click', 'a, button', (e, target) => {
          window.themeLayer.push({
            event: 'element_clicked',
            section: this.generateSectionData(target.closest('[data-section-type]')),
            block: this.generateBlockData(target.closest('[data-block-type]')),
            element: this.generateElementData(target),
          });
        });
      }
    }, {
      key: "initVideoTracking",
      value: function initVideoTracking(element) {
        const players = element.querySelectorAll('wistia-player:not([data-tracking-initialized])');
        players.forEach(player => {
          const onPlay = () => {
            window.themeLayer.push({
              event: 'video_started',
              section: this.generateSectionData(player.closest('[data-section-type]')),
              video: this.generateVideoData(player)
            });
            player.removeEventListener('play', onPlay);
          };
          player.addEventListener('play', onPlay);
          const onSecondChange = () => {
            window.themeLayer.push({
              event: 'video_progressed',
              section: this.generateSectionData(player.closest('[data-section-type]')),
              video: this.generateVideoData(player)
            });
          };
          player.addEventListener('second-change', onSecondChange);
          player.setAttribute('data-tracking-initialized', 'true');
        });
      }
    }, {
      key: "initFormTracking",
      value: function initFormTracking() {
        this.documentDelegate.on('submit', 'form:not([data-form-tracking="none"])', (e, target) => {
          window.themeLayer.push({
            event: 'form_submitted',
            section: this.generateSectionData(target.closest('[data-section-type]')),
            form: this.generateFormData(target)
          });
        });
      }
    }, {
      key: "initSectionTracking",
      value: function initSectionTracking(element) {
        const sections = element.querySelectorAll('[data-section-type]:not([data-tracking-initialized])');
        sections.forEach(section => {
          if (this.observedElements.indexOf(section) === -1) {
            this.observedElements.push(section);
            this.intersectionObserver.observe(section);
            this.initBlockTracking(section);
          }
          section.setAttribute('data-tracking-initialized', 'true');
        });
      }
    }, {
      key: "initBlockTracking",
      value: function initBlockTracking(section) {
        const blocks = section.querySelectorAll('[data-block-type]:not([data-tracking-initialized])');
        blocks.forEach((block, index) => {
          if (this.observedElements.indexOf(block) === -1) {
            if (!block.hasAttribute('data-block-position')) block.setAttribute('data-block-position', index + 1);
            this.observedElements.push(block);
            this.intersectionObserver.observe(block);
          }
          block.setAttribute('data-tracking-initialized', 'true');
        });
      }
    }, {
      key: "processEvent",
      value: function processEvent(data) {
        if (!data || !data.event) return;
        data.document = this.generateDocumentData();
        data.template = this.generateTemplateData();
        const events = this.processSecondLayer(data);
        events.forEach(event => {
          const name = event.event;
          delete event.event;
          this.processThirdParties(name, event);
          if (!['page_viewed', 'form_submitted'].includes(name)) window.Shopify.analytics.publish(name, event);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: name,
            ...event
          });
        });
      }
    }, {
      key: "processSecondLayer",
      value: function processSecondLayer(data) {
        const events = [data];
        const transforms = window.theme.tracking.secondLayerTransforms;
        if (transforms && transforms.length) {
          transforms.forEach(transform => {
            try {
              if (transform.event !== data.event) return;
              const clone = JSON.parse(JSON.stringify(data));
              if (!transform.condition(clone)) return;
              const subevent = typeof transform.subevent === 'function' ? transform.subevent(clone) : transform.subevent;
              events.push({ event: `${clone.event}__${subevent}` });
            }
            catch (err) {
              console.error('[Theme Tracking] Error processing second layer transform', err);
            }
          });
        }
        return events;
      }
    }, {
      key: "processThirdParties",
      value: function processEventForThirdParties(eventName, data) {
        const thirdPartyEvents = window.theme.tracking.thirdPartyEvents;
        if (thirdPartyEvents && thirdPartyEvents.length) {
          thirdPartyEvents.forEach(thirdPartyEvent => {
            try {
              if (thirdPartyEvent.event !== eventName) return;
              const clone = JSON.parse(JSON.stringify(data));
              if (thirdPartyEvent.condition && !thirdPartyEvent.condition(clone)) return;
              const serviceEventName = thirdPartyEvent.serviceEvent || eventName;
              const serviceData = thirdPartyEvent.data ? thirdPartyEvent.data(clone) : undefined;
              if (thirdPartyEvent.service === 'facebook' && window.fbq !== undefined) {
                window.fbq(thirdPartyEvent.serviceNative ? 'track' : 'trackCustom', serviceEventName, serviceData);
              }
              else if (thirdPartyEvent.service === 'admetrics') {
                window.admDataLayer = window.admDataLayer || [];
                window.admDataLayer.push({
                  name: serviceEventName,
                  data: serviceData || {} // Always required
                });
              }
              else if (thirdPartyEvent.service === 'kameleoon') {
                window.kameleoonQueue = window.kameleoonQueue || [];
                window.kameleoonQueue.push(['Kameleoon.API.Goals.processConversion', serviceEventName]);
              }
              else if (thirdPartyEvent.service === 'gtm') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: serviceEventName,
                  ...serviceData
                });
              }
            }
            catch (err) {
              console.error('[Theme Tracking] Error sending third party event', err);
            }
          });
        }
      }
    }]);

    return ThemeTracking;
  }();

  /**
   * Additional custom init functions
   */
  var InitFunctions = function () {
    function InitFunctions() {
      _classCallCheck(this, InitFunctions);

      InitFunctions.initGlobalAddToCart();

      InitFunctions.initLazyLoadOptimizations();
  
      InitFunctions.initInsertLazyLoad();

      InitFunctions.initSlider(document.querySelector('#section-main-page-product-carousels')); // On custom page
      InitFunctions.initSlider(document.querySelector('.CoachingHomepage')); // On coaching homepage
      document.querySelectorAll('.CustomerStories section:not(.no-init)').forEach(element => {
        InitFunctions.initSlider(element);
        element.closest('.shopify-section').classList.remove('none');
      });
      InitFunctions.initSlider(document.querySelector('.SalesPageCustomerService'));

      InitFunctions.initDefaultCloseButtons(document);

      InitFunctions.initButtonLoading(document);

      InitFunctions.initNavigationBar();

      InitFunctions.initCrossSellButtons();

      InitFunctions.initClubProgress();

      InitFunctions.initKlaviyoSignups();

      InitFunctions.initWindowFunctions();

      InitFunctions.initGlobalTabSwitch(document);

      InitFunctions.initEmbeds(document);

      InitFunctions.initModalLoading(document);

      InitFunctions.initScrollLists(document);

      InitFunctions.initShowMore(document);

      InitFunctions.initMultiStepForms(document);
      InitFunctions.initBibliography();

      InitFunctions.initMasonryGrids(document);

      InitFunctions.initSidebars(document);
      document.addEventListener('theme:sidebar:init', e => {
        InitFunctions.initSidebars(e.detail || document);
      })

      InitFunctions.initTimers(document);

      InitFunctions.initZoom(document);

      InitFunctions.initIntercom();

      InitFunctions.initCustomerLoginEvents();
    }

    _createClass(InitFunctions, null, [{
      /** 
       * Initialize additional add to cart buttons
       * The buttons need to have the class 'GlobalAddToCart' and the attribute 'data-variant-id' containing the variant id of the product
       */
      key: "initGlobalAddToCart",
      value: function initGlobalAddToCart() {
        const delegate = new domDelegate.Delegate(document.body);
        delegate.on('click', 'button.GlobalAddToCart', (e) => {
          const variantId = e.target.getAttribute('data-variant-id');
          if (!variantId) return;
          window.addToCart([{id: variantId, quantity: 1}]);
        });
      }
    }, {
      key: "initScrollLists",
      value: function initScrollLists(container) {
        container.querySelectorAll('.scroll-list').forEach((element) => {
          new ScrollList(element);
        });
      }
    }, {
      /** 
       * Calculate smallest possible image sizes before image lazy loading, due to different aspect ratios this gives some optimization
       */
      key: "initLazyLoadOptimizations",
      value: function initLazyLoadOptimizations() {
        document.addEventListener('lazybeforesizes', (e) => {
          const percentualWidthElement = e.target.closest('[data-image-percentual-width]');
          if (percentualWidthElement) {
            e.detail.width = Math.round(e.detail.width * parseFloat(percentualWidthElement.getAttribute('data-image-percentual-width')));
          }
        });
      }
    }, {
      /** 
       * Insert lazy load class and enable wistia lazy loading for all pages except product pages, because there the wistia lazy loading includes slider videos.
       */
      key: "initInsertLazyLoad",
      value: function initInsertLazyLoad() {
        const videos = document.querySelectorAll('[data-wistia-lazyload-media-id]');
        InitFunctions.initWistiaLazyLoad(videos);
        InitFunctions.insertLazyLoad(document);
      }
    }, {
      /**
       * Initialize custom sliders
       */
      key: "initSlider",
      value: function initSlider(container) {
        if (!container) return;

        const sliders = container.querySelectorAll('.Slider:not(.is-initialized)');
        sliders.forEach((slider) => {
          new Slider(slider);
        });
      }
    }, {
      /**
       * Init default close buttons
       */
      key: "initDefaultCloseButtons",
      value: function initDefaultCloseButtons(container) {
        const closeButtons = container.querySelectorAll('button.DefaultCloseButton');
        closeButtons.forEach((closeButton) => {
          const initialDelay = parseInt(closeButton.getAttribute('data-initial-delay')),
                closeContainer = closeButton.closest('.DefaultCloseContainer'),
                cookieId = closeButton.getAttribute('data-cookie-id');
          if (!closeContainer) {
            console.warn("You defined a close button but not closable element", closeButton);
            return;
          }
          if (!cookieId || window.getCookie(`hide-${cookieId}`) === '') {
            if (!initialDelay || initialDelay == 0) {
              closeContainer.setAttribute('aria-hidden', false);
            }
            else if (initialDelay > 0) {
              setTimeout(() => {
                closeContainer.setAttribute('aria-hidden', false);
              }, initialDelay * 1000);
            }
            closeButton.addEventListener('click', (e) => {
              closeContainer.setAttribute('aria-hidden', true);
              const hideDuration = e.target.getAttribute('data-hide-duration'),
                    cookieId = e.target.getAttribute('data-cookie-id');
              if (cookieId && hideDuration) {
                window.setCookie(`hide-${cookieId}`, 'true', hideDuration);
              }
              else if (cookieId) {
                window.setCookie(`hide-${cookieId}`, 'true');
              }
            });
          }
          else if (cookieId && window.getCookie(`hide-${cookieId}`) !== '') {
            const ariaHidden = closeContainer.getAttribute('aria-hidden');
            if (!ariaHidden || ariaHidden == 'false') {
              closeContainer.setAttribute('aria-hidden', true);
            }
          }
        });
      }
    }, {
      /**
       * Init global button loading
       */
      key: "initButtonLoading",
      value: function initButtonLoading(container) {
        if (window.theme.pageType === 'cart') return;
        const buttons = container.querySelectorAll('button.ProductForm__AddToCart, button.GlobalAddToCart, button[data-action="sync_add"], .ProductItem__QuickAdd button:not(.DynamicPopoverActivator)');
        buttons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            let aElement = e.target;
            if (aElement.nodeName !== 'A') {
              aElement = e.target.closest('a');
            }
            const loadingButton = e.target.nodeName === 'BUTTON' ? e.target : e.target.closest('button');
            if (loadingButton.getAttribute('data-external') === 'block') return;
            loadingButton.classList.add('loading');
            document.addEventListener('theme:loading:end', () => {
              loadingButton.classList.remove('loading');
            }, { once: true });
          });
        });
      }
    }, {
      /**
       * Horizontal menu
       */
      key: "initNavigationBar",
      value: function initNavigationBar() {
        const navigationBar = document.querySelector('.NavigationBar');
        if (!navigationBar) return;

        const scrollSlider = navigationBar.querySelector('.NavigationList');
        // Initialize table of contents
        const scrollListener = (anchors, activeLinks) => {
          activeLinks.forEach((link) => {
            if (!link.closest('.NavigationList')) return;
            const menuScrollLeft = link.offsetLeft + link.clientWidth / 2 - scrollSlider.clientWidth / 2;
            scrollSlider.scroll({
              left: menuScrollLeft,
              behavior: "smooth"
            });
          });
        };
        this.tableOfContents = new TableOfContents([navigationBar], document, { additionalOnScroll: scrollListener, activeSelector: '.NavigationList__Item'});

        // Save the height of the navigation bar in a CSS variable to offset the anchor links
        const setNavigationHeightVariable = () => {
          const navigationHeight = navigationBar.offsetHeight;
          document.documentElement.style.setProperty('--navigation-height', navigationHeight + 'px');
        };
        setNavigationHeightVariable();
        window.addEventListener('resize', setNavigationHeightVariable, { passive: true });
      }
    }, {
      /**
       * Initialize cross-sell buttons.
       */
      key: "initCrossSellButtons",
      value: function initCrossSellButtons() {
        const dynamicPopover = document.querySelector('#dynamic-popover');
        if (!dynamicPopover) return;

        const dynamicPopoverContainer = dynamicPopover.querySelector('.Popover__Content'),
              selectionHandler = (value, button, activator) => {
                const variantId = button.getAttribute('data-variant-id');
                if (activator.hasAttribute('data-type') && activator.getAttribute('data-type') == 'loyaltyslider') {
                  const loyaltyButton = activator.closest('.ClubProduct').querySelector('[data-lion-seamless-product-reward]');
                  if (loyaltyButton && window.loyaltylion) {
                    loyaltyButton.setAttribute('data-variant-id', variantId);
                    window.loyaltylion.ui.refresh();
                    loyaltyButton.querySelector('button').click();
                  }
                  else {
                    console.warn('Loyaltyslider: Variant selected but no loyalty button found to trigger add to cart process.');
                  }
                }
                else {
                  window.addToCart([{id: variantId, quantity: 1}]);
                }
              },
              refreshLoyaltyButtons = (container) => {
                const variantButtons = container.querySelectorAll('a[data-type="loyaltyslider"]');
                if (!variantButtons) return;
                // Since loyaltylion refreshes UI asynchronously, we need to wait for the refresh to finish to update variant buttons
                const timeout = 10000,
                      start = Date.now();
                variantButtons.forEach((button) => {
                  const productItem = button.closest('.ClubProduct');
                  const updateVariantButton = () => {
                    if (!productItem) return;
                    const lionButton = productItem ? productItem.querySelector('.lion-in-cart-reward__button') : null;
                    if (!lionButton) {
                      if (Date.now() - start < timeout) setTimeout(updateVariantButton, 1000);
                      return;
                    }
                    const lionButtonActive = lionButton.hasAttribute('data-lion-active'),
                          lionButtonInactive = /^.*\d+.*$/.test(lionButton.innerText);
                    if (lionButtonActive || lionButtonInactive) {
                      if (lionButtonActive) {
                        button.removeAttribute('disabled');
                      }
                      else {
                        button.setAttribute('disabled', 'disabled');
                      }
                      if (!button.classList.contains('Button--icon_only')) button.innerText = lionButton.innerText;
                    }
                    else if (Date.now() - start < timeout) {
                      setTimeout(updateVariantButton, 1000);
                    }
                  }
                  updateVariantButton();
                });
              };
        
        const delegate = new domDelegate.Delegate(document.body),
              popoverInstance = new Popover(dynamicPopover, { activator: null, stickyActivator: false, section: 'general', onValueChanged: selectionHandler, type: 'dynamic-popover'});

        delegate.on('click', '.DynamicPopoverActivator', (e) => {
          if (e.target.hasAttribute('disabled')) return;

          dynamicPopoverContainer.style.removeProperty('height');
          popoverInstance.destroy();
          popoverInstance.activator = e.target;
          popoverInstance.section = e.target.closest('#sidebar-cart') ? 'cart' : 'general';
          popoverInstance._attachListeners();
          popoverInstance.open();
          popoverInstance.setLoading();
          let selectionURL = `${window.Shopify.routes.root}products/${e.target.getAttribute('data-handle')}?view=variantselection`;
          fetch(selectionURL, {
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then((response) => {
            if (response.ok) {
              return response.text();
            } else {
              response.json().then(function(content) {
                console.warn('Problem loading popover ajax content', content['description']);
              });
            }
          }).then((html) => {
            dynamicPopoverContainer.innerHTML = html;
            document.dispatchEvent(new CustomEvent('theme:tracking:init', { detail: { element: dynamicPopoverContainer } }));
            Animation.slideDown(dynamicPopoverContainer);
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          }).catch((error) => {
            console.error('There was a problem retrieving ajax popover content',  error);
          });
        });
        document.addEventListener('theme:product_carousel:loaded', e => {
          if (!window.loyaltylion || !window.loyaltylion.ui) return;
          window.loyaltylion.ui.refresh();
          refreshLoyaltyButtons(e.detail);
        });
        document.addEventListener('theme:search:changed', e => {
          if (!window.loyaltylion || !window.loyaltylion.ui) return;
          window.loyaltylion.ui.refresh();
          refreshLoyaltyButtons(e.detail);
        });
        refreshLoyaltyButtons(document);
      }
    }, {
      /**
       * Init club progress elements
       */
      key: "initClubProgress",
      value: function initClubProgress() {
        if (!window.loyaltylion) return;
        const hiddenPointsElement = document.createElement('DIV');
        hiddenPointsElement.classList.add('none');
        hiddenPointsElement.setAttribute('data-lion-points', 'approved');
        document.body.appendChild(hiddenPointsElement);
        let currentPoints = null;
        const updateProgress = (container) => {
          const progressElements = (container || document).querySelectorAll('[data-club-progress-price]');
          for (let i = 0; i < progressElements.length; i++) {
            const element = progressElements[i];
            if (!element) return;
            const priceForProduct = parseInt(element.getAttribute('data-club-progress-price'));
            if (currentPoints >= priceForProduct) {
              element.classList.add('none');
            }
            else {
              element.classList.remove('none');
              element.querySelector('[data-club-progress-bar]').style.setProperty('--progress', `${Math.round((currentPoints / priceForProduct) * 100)}%`);
              element.querySelector('[data-club-progress-missing-points]').innerText = Math.min(priceForProduct, priceForProduct - currentPoints);
            }
          }
        };
        const pointsObserver = new MutationObserver(() => {
          const newPoints = parseInt(hiddenPointsElement.innerText.replace(/[^\d]/g, ''));
          if (newPoints !== 0 && !newPoints || newPoints === currentPoints) return;
          currentPoints = newPoints;
          updateProgress();
        });
        pointsObserver.observe(hiddenPointsElement, { childList: true });
        if (window.loyaltylion && window.loyaltylion.ui) loyaltylion.ui.refresh();
        const updateProgressOnLoad = e => {
          if (e.detail) updateProgress(e.detail);
        }
        document.addEventListener('theme:search:changed', updateProgressOnLoad);
        document.addEventListener('theme:product_carousel:loaded', updateProgressOnLoad);
        document.addEventListener('theme:collection:changed', updateProgressOnLoad);
      }
    }, {
      /**
       * Init Klaviyo newsletter signup forms.
       */
      key: "initKlaviyoSignups",
      value: function initKlaviyoSignups() {
        const displaySubmitResult = function(success, formElement) {
          if (success) {
            const errorElements = formElement.querySelectorAll('.Form__Alert.Alert--error');
            errorElements.forEach((element) => {
              element.classList.add('none');
            });
            const successElements = formElement.querySelectorAll('.Form__Alert.Alert--success');
            successElements.forEach((element) => {
              element.classList.remove('none');
            });
            const inputContainer = formElement.querySelector('.signup_form_input');
            if (inputContainer) inputContainer.classList.add('none');
          }
          else {
            const errorElements = formElement.querySelectorAll('.Form__Alert.Alert--error');
            errorElements.forEach((element) => {
              element.classList.remove('none');
            });
          }
        };
        const signupForms = document.querySelectorAll('.KlaviyoForm');
        signupForms.forEach((signupForm) => {
          const inputFields = signupForm.querySelectorAll('input[required="required"]');
          inputFields.forEach((inputField) => {
            inputField.oninput = (e) => {
              e.target.setCustomValidity("");
            };
          });
          signupForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const formElement = e.target,
                  inputElements = formElement.querySelectorAll('input[required="required"]');
            // Custom validation to display more specific error messages
            let legal = true;
            inputElements.forEach((inputElement) => {
              if (inputElement.validity.valid) return;

              legal = false;
              switch (inputElement.getAttribute('name')) {
                case 'first_name':
                  inputElement.setCustomValidity("Bitte gib deinen Vornamen ein");
                  break;
                case 'email':
                  const email = inputElement.value;
                  if (email === '') {
                    inputElement.setCustomValidity("Bitte gib deine E-Mail-Adresse ein");
                  }
                  else {
                    inputElement.setCustomValidity("Bitte gib eine gültige E-Mail-Adresse ein");
                  }
                  break;
                case 'privacycheck':
                  inputElement.setCustomValidity("Bitte akzeptiere unsere Datenschutzerklärung");
                  break;
              }
            });
            if (legal) {
              const search = new URLSearchParams(location.search),
                    utm_source = search.get('utm_source') || 'None',
                    utm_medium = search.get('utm_medium') || 'None',
                    utm_campaign = search.get('utm_campaign') || 'None',
                    actionType = formElement.getAttribute('data-submit-action'),
                    formData = new FormData(formElement),
                    coaching_handle = formData.get('e:coaching_handle'),
                    profileProperties = {},
                    eventProperties = {};
              formData.forEach((value, key) => {
                if (/^e:.*$/.test(key)) {
                  eventProperties[key.replace('e:', '')] = value;
                }
                else if (/^p:.*$/.test(key)) {
                  profileProperties[key.replace('p:', '')] = value;
                }
              });
              if (coaching_handle) {
                profileProperties.utm_source = utm_source;
                profileProperties.utm_medium = utm_medium;
                profileProperties.utm_campaign = utm_campaign;
              }
              let action, bodyData, onSuccess;
              if (actionType === 'event') {
                action = 'https://a.klaviyo.com/client/events/';
                bodyData = {
                  type: 'event',
                  attributes: {
                    properties: eventProperties,
                    metric: {
                      data: {
                        type: 'metric',
                        attributes: {
                          name: formElement.name
                        }
                      }
                    },
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: formData.get('email'),
                          first_name: formData.get('first_name'),
                          properties: profileProperties
                        }
                      }
                    }
                  }
                };
                onSuccess = () => {
                  e.target.classList.remove('loading');
                  displaySubmitResult(true, formElement);
                  if (coaching_handle) {
                    const proceedButton = formElement.querySelector('[data-form-button="proceed"]');
                    if (proceedButton) proceedButton.href = window.Shopify.routes.root + 'blogs/' + coaching_handle;
                  }
                }
              }
              else {
                action = 'https://a.klaviyo.com/client/subscriptions/';
                bodyData = {
                  type: 'subscription',
                  attributes: {
                    custom_source: formData.get('source') || location.pathname,
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: formData.get('email'),
                          first_name: formData.get('first_name'),
                          properties: profileProperties
                        }
                      }
                    }
                  },
                  relationships: {
                    list: {
                      data: {
                        type: 'list',
                        id: formData.get('list_id')
                      }
                    }
                  }
                };
                onSuccess = () => {
                  displaySubmitResult(true, formElement);
                  const inputBlock = formElement.querySelector('.signup_form_input'),
                        resultBlock = formElement.querySelector('.signup_result_message');
                  if (inputBlock) inputBlock.style.display = "none";
                  if (resultBlock) resultBlock.innerText = "Schaue in deine Emails und bestätige die Anmeldung.";
                }
              }

              // Send event or signup to Klaviyo
              e.target.classList.add('loading');
              fetch(`${action}?company_id=${window.theme.tracking.klaviyoKey}`, {
                method: 'POST',
                headers: { revision: '2024-02-15', Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  data: bodyData
                })
              }).then(response => {
                if (response.ok) {
                  if (onSuccess) onSuccess();
                }
                else {
                  displaySubmitResult(false, formElement);
                }
              }).catch(err => {
                console.error(err);
                e.target.classList.remove('loading');
                displaySubmitResult(false, formElement);
              });
            }
          });
        });
      }
    }, {
      /** 
       * Important information for lazy load elements that may be visible instantly on the page:
       * Give them the class 'Image--insertLazyLoad' instead of 'Image--lazyLoad', because otherwise
       * the lazyload event may be fired before the listener is added to the document.
       */
      key: "insertLazyLoad",
      value: function insertLazyLoad(container) {
        const elementsToLazyLoad = container.querySelectorAll('.Image--insertLazyLoad');
        for (let i = 0; i < elementsToLazyLoad.length; i++) {
          elementsToLazyLoad[i].classList.add('Image--lazyLoad');
          elementsToLazyLoad[i].classList.remove('Image--insertLazyLoad');
        }
      }
    }, {
      /** 
       * Lazy load the given wistia videos. The param needs to be an array or nodelist that contains the containers with the [data-wistia-lazyload-id] attribute. Only call once per page.
       */
      key: "initWistiaLazyLoad",
      value: function initWistiaLazyLoad(elements, onReady) {
        const elementsType = NodeList.prototype.isPrototypeOf(elements) ? 'list' : 'single';
        if (elementsType === 'list' && elements.length == 0) return [];

        const createEmbedHtml = (element) => {
          if (!element.hasAttribute('data-wistia-lazyload-media-id')) return;
          const attributes = Array.from(element.attributes).reduce((str, attr) => {
            if (attr.specified && attr.name.includes('data-wistia-lazyload-')) return `${str} ${attr.name.replace('data-wistia-lazyload-', '')}${attr.value ? `="${attr.value}"` : ''}`;
            return str;
          }, '');
          return `<wistia-player ${attributes}></wistia-player>`;
        }

        const runLazyHandler = (element) => {
            const wistiaId = element.getAttribute('data-wistia-lazyload-media-id');
            const videoWrapper = element.closest('.VideoWrapper, .VideoWrapper--blank');
            if (!videoWrapper) {
                console.error('[Wistia lazy loading] No video wrapper found for video element', element);
                return;
            }
            const embedScript = document.createElement('SCRIPT');
            embedScript.type = 'module';
            embedScript.src = `https://fast.wistia.com/embed/${wistiaId}.js`;
            embedScript.async = true;

            videoWrapper.appendChild(embedScript);
            if (typeof Wistia === 'undefined' && !document.head.querySelector('script[src*="wistia.com/player.js"]')) {
                const wistiaScript = document.createElement('SCRIPT');
                wistiaScript.src = 'https://fast.wistia.com/player.js';
                wistiaScript.async = true;
                document.head.appendChild(wistiaScript);
            }
            if (element.getAttribute('data-wistia-after-lazyload') === 'remove-parent') {
                const parent = element.parentElement;
                parent.insertAdjacentHTML('beforebegin', createEmbedHtml(element));
                parent.remove();
            }
            else if (element.getAttribute('data-wistia-after-lazyload') === 'wrap-parent') {
                const parent = element.parentElement;
                parent.insertAdjacentHTML('beforebegin', createEmbedHtml(element));
                parent.style = 'position: relative; width: 100%; height: 100%;';
                const styleTag = document.createElement('style');
                styleTag.innerHTML = `
                    .wistia_click_to_play {
                    width: 100%;
                    }
                `;
                parent.append(styleTag);
                parent.parentElement.querySelector('wistia-player').appendChild(parent);
            }
            else {
                console.error('[Wistia lazy loading] Unknown data-wistia-after-lazyload value', element);
            }
            document.dispatchEvent(new CustomEvent('theme:tracking:init', { detail: { element: videoWrapper } }));
            if (onReady) {
                const playerElement = videoWrapper.querySelector('wistia-player');

                if (playerElement.readyState !== undefined) {
                    onReady(playerElement, videoWrapper);
                }
                else {
                    playerElement.addEventListener('api-ready', () => {
                        onReady(playerElement, videoWrapper);
                    });
                }
            }
        };


        const lazyHandler = (e) => {
            e.preventDefault();
            e.target.removeEventListener('load', lazyHandler);
            runLazyHandler(e.target);
        };


        const addLazyLoadListener = (elem) => {
            if(elem.complete) {
                runLazyHandler(elem);
            }else {
                elem.addEventListener('load', lazyHandler);
            }
        };

        if (elementsType === 'list') {
          elements.forEach(addLazyLoadListener);
        }
        else {
          addLazyLoadListener(elements);
        }
      }
    }, {
      key: "initGlobalTabSwitch",
      value: function initGlobalTabSwitch(container) {
        const tabLists = container.querySelectorAll('.tab-switch');

        if (tabLists.length === 0) return;

        tabLists.forEach((tabList) => {
          if (!tabList.classList.contains('tab-switch-initialized')) new TabSwitch(tabList);
        });
      }
    }, {
      /** 
       * Notify LoyaltyLion that the cart has changed. Needed because the cart is ajax.
       */
      key: "loyaltyCartChange",
      value: function loyaltyCartChange(cart) {
        if (!window.loyaltylion) return;

        if (cart) {
          window.loyaltylion.setCartState(cart);
        }
        else {
          fetch(window.routes.cartUrl + '.js', {
            credentials: 'same-origin',
            method: 'GET',
            headers: {
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {
            response.json().then((cart) => {
              window.loyaltylion.setCartState(cart);
            });
          });
        }
      }
    }, {
      /** 
       * Initialize embeds
       */
      key: "initEmbeds",
      value: function initEmbeds(container) {
        const embedPlaceholders = Array.from(container.querySelectorAll('.EmbedPlaceholder'));
        const initEmbed = function(placeholder) {
          const temp = document.createElement('DIV');
          temp.innerHTML = placeholder.querySelector('.EmbedPlaceholder__Embed').innerHTML;
          const scripts = temp.querySelectorAll('script');
          for (let script of scripts) {
            const clone = cloneScriptNode(script);
            script.parentNode.replaceChild(clone, script);
          }
          for (let node of temp.childNodes) {
            placeholder.parentNode.insertBefore(node, placeholder);
          }
          placeholder.remove();
        };
        const cloneScriptNode = function(node) {
          var script = document.createElement("script");
          script.innerText = node.innerHTML;
          for (let attr of node.attributes) {
            script.setAttribute(attr.name, attr.value);
          }
          return script;
        }
        const initAllEmbeds = function() {
          for (let embedPlaceholder of embedPlaceholders) {
            initEmbed(embedPlaceholder);
          }
        }
        if (window.theme.consent.getTrackingConsent()) {
          initAllEmbeds();
        }
        else {
          const consentChangeListener = function (e) {
            if (e.detail !== true) return;
            initAllEmbeds();
            window.removeEventListener('theme:consent:change', consentChangeListener);
          }
          window.addEventListener('theme:consent:change', consentChangeListener);
          for (let embedPlaceholder of embedPlaceholders) {
            const showButton = embedPlaceholder.querySelector('[data-action="show-embed"]');
            showButton.addEventListener('click', (e) => {
              const placeholder = e.target.closest('.EmbedPlaceholder');
              const index = embedPlaceholders.indexOf(placeholder);
              if (index > -1) {
                embedPlaceholders.splice(index, 1);
              }
              initEmbed(placeholder);
            });
          }
        }
      }
    }, {
      /** 
       * Init modal loading
       */
      key: "initModalLoading",
      value: function initModalLoading(container) {
        const showModalLoading = (elementOrData) => {
          const data = elementOrData instanceof HTMLElement ? JSON.parse(elementOrData.getAttribute('data-modal-loading').replaceAll('\'', '"')) : elementOrData,
                dataElement = elementOrData instanceof HTMLElement ? elementOrData : null,
                pageOverlay = document.querySelector('.PageOverlay--primary');
          const modal = document.getElementById(data.id);
          if (!modal) return console.warn("[ModalLoading] Unknown element id", data.id);
          const hideLoading = () => {
            if (dataElement && dataElement.hasAttribute('data-href')) {
              const url = dataElement.getAttribute('data-href')
              if (dataElement.target === '_blank') {
                window.pageOverlay.close(container);
                modal.setAttribute('aria-hidden', 'true');
                window.open(url, '_blank');
              }
              else {
                window.addEventListener('pageshow', (e) => {
                  if (e.persisted) {
                    window.pageOverlay.close(container);
                    modal.setAttribute('aria-hidden', 'true');
                  }
                }, { once: true });
                window.location.href = url;
              }
            }
            else {
              window.pageOverlay.close(container);
              if (data.initial) {
                pageOverlay.style.opacity = null;
                pageOverlay.style.transition = null;
                pageOverlay.classList.remove('PageOverlay--survey');
              }
              modal.setAttribute('aria-hidden', 'true');
            }
          };
          if (!data.loadingTime || !data.successTime) {
            console.warn(`[ModalLoading] Missing metafield data for loading time (${data.loadingTime}) or success time (${data.successTime})`);
            hideLoading();
            return;
          }
          window.pageOverlay.open(container);
          modal.setAttribute('aria-hidden', 'false');
          modal.querySelector('.LoadingContainer').classList.remove('none');
          modal.querySelector('.LoadingText--loading').classList.remove('none');
          modal.querySelector('.LoadingText--success').classList.add('none');
          setTimeout(() => {
            modal.querySelector('.LoadingContainer').classList.add('none');
            modal.querySelector('.LoadingText--loading').classList.add('none');
            modal.querySelector('.LoadingText--success').classList.remove('none');
            setTimeout(hideLoading, data.successTime * 1000);
          }, data.loadingTime * 1000);
          if (data.initial) window.setCookie(`theme_hide_${location.pathname.replace(/.*\//, '')}_${data.id}`, 'true');
        };
        const elements = container.querySelectorAll('[data-modal-loading]');
        elements.forEach((element) => {
          const data = JSON.parse(element.getAttribute('data-modal-loading').replaceAll('\'', '"'));
          if (data.initial) {
            // Changes in conditions for initial loading also need to be done in custom-js.liquid
            const search = new URLSearchParams(window.location.search);
            if ((!data.source || data.source === search.get('source')) && !window.getCookie(`theme_hide_${location.pathname.replace(/.*\//, '')}_${data.id}`)) showModalLoading(data);
          }
          else {
            if (element.href) {
              element.setAttribute('data-href', element.href);
              element.href = 'javascript:void(0);';
            }
            element.addEventListener('click', (e) => {
              showModalLoading(e.target.hasAttribute('data-modal-loading') ? e.target : e.target.closest('[data-modal-loading]'));
            });
          }
        });
      }
    }, {
      key: "initShowMore",
      value: function(element) {
        element.querySelectorAll('[data-action="show-more"]').forEach(toggleButton => {
          const transitionEndListener = (e) => {
            if (e.propertyName === 'grid-template-rows' || (e.target.classList.contains('ShowMore__Button') && e.propertyName === 'bottom')) {
              // Second condition is because grid-template-rows event is not fired on iOS
              let view = e.target;
              if (e.target.classList.contains('ShowMore__Button')) view = document.getElementById(e.target.getAttribute('aria-controls'));
              view.style.removeProperty(`--show-more-height-${view.id}`);
              view.removeEventListener('transitionend', transitionEndListener);
              if (view.getAttribute('data-show-more-state') === 'collapsed') {
                const scrollPosition = view.getBoundingClientRect().bottom + window.scrollY - window.innerHeight / 2;
                window.scrollTo({
                  top: scrollPosition,
                  behavior: 'smooth'
                });
              }
            }
          };
          const toggle = (e) => {
            const button = e.target,
                  controls = button.getAttribute('aria-controls'),
                  view = document.getElementById(controls);
            if (!view.classList.contains('ShowMore--breakText')) {
              view.style.setProperty(`--show-more-height-${view.id}`, view.firstElementChild.scrollHeight + 'px');
              view.offsetHeight; // Force reflow
              view.addEventListener('transitionend', transitionEndListener);
            }
            if (button.getAttribute('aria-expanded') === 'true') {
              button.setAttribute('aria-expanded', 'false');
              view.setAttribute('data-show-more-state', 'collapsed');
            }
            else {
              // const focusableElement = view.querySelector(Accessibility.getFocusableSelector());
              // if (focusableElement) focusableElement.focus();
              button.setAttribute('aria-expanded', 'true');
              view.setAttribute('data-show-more-state', 'open');
            }
            // If view is inside a masonry, we need to trigger a reload
            const closestMasonry = view.closest('[data-masonry-grid="true"]');
            if (closestMasonry) closestMasonry.dispatchEvent(new CustomEvent('theme:masonry:change'));
          };
          toggleButton.addEventListener('click', toggle);
        });
      }
    }, {
      key: "initMultiStepForms",
      value: function(element) {
        element.querySelectorAll('.Form--multistep').forEach(form => {
          new MultiStepForm(form);
        });
      }
    }, {
      key: "initWindowFunctions",
      value: function() {
        /** Cart ajax add to cart, products needs to be an array of JSONs.
         * Example: products = [{id: 36839749550239, quantity: 1}, {id: 36839787233439, quantity: 2}]
         */
        window.addToCart = function(products, callback) {
          if (products.constructor !== Array || products.length === 0) {
            console.error("addToCart error: parameter of wrong type or empty", products);
            if (callback) {
              callback();
            }
            return;
          }
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          document.dispatchEvent(new CustomEvent('cart:loading:start'));
          var variant_id = products[0].id,
          quantity_sum = 0,
          data = {
            items: products
          };
          for (let i = 0; i < products.length; i++) {
            quantity_sum += products[i].quantity;
          }
          fetch(window.routes.cartAddUrl + '.js', {
            body: JSON.stringify(data),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {
            if (response.ok) {
              InitFunctions.loyaltyCartChange(false);
              document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variant_id,
                  quantity: quantity_sum
                }
              }));
            } else {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              response.json().then(function(content) {
                console.error(content['description']);
              });
            }
            if (callback) {
              callback();
            }
          }).catch(function () {
            if (callback) {
              callback();
            }
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          });
        };

        /** Cart ajax add to cart, products needs to be a JSON with IDs followed by the new quantity.
         * Example: products = {36839787233439: 0, 36839749550239: 1}
         */
        window.updateItemQuantity = function(products, callback) {
          if (products.constructor !== Object || Object.keys(products).length === 0) {
            console.error("updateItemQuantity error: parameter of wrong type or empty", products);
            if (callback) {
              callback();
            }
            return;
          }
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          document.dispatchEvent(new CustomEvent('cart:loading:start'));
          const data = {
            updates: products
          };
          var elementsToAnimate = [],
              cartItemList = document.querySelector('.Cart__ItemList');

          if (cartItemList) {
            for (var itemId in products) {
              const itemIdFixed = itemId.includes(':') ? itemId.split(':')[0] : itemId;
              var tempItemElement = cartItemList.querySelector('[data-variantid="' + itemIdFixed + '"]');
              if (products[itemId] == 0 && tempItemElement != null) {
                const itemWrapperElement = tempItemElement.closest('.CartItemWrapper');
                if (itemWrapperElement) elementsToAnimate.push(itemWrapperElement);
              }
            }
          }
          if (elementsToAnimate.length === 0) {
            elementsToAnimate = null;
          }
          fetch(window.routes.cartUpdateUrl + '.js', {
            body: JSON.stringify(data),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (cart) {
            cart.json().then(function(content) {
              InitFunctions.loyaltyCartChange(content);
              document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  elementsToAnimate: elementsToAnimate
                }
              }));
              if (callback) {
                callback();
              }
            });
          }).catch(function () {
            if (callback) {
              callback();
            }
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          });
        };
      }
    }, {
      key: "initBibliography",
      value: function() {
        new Bibliography();
      }
    }, {
      key: "initMasonryGrids",
      value: function(element) {
        const masonryGrids = element.querySelectorAll('[data-masonry-grid="true"]');
        if (!masonryGrids.length) return;

        const gridMap = new Map(),
              watchCssGrids = [];
        const isCssEnabled = (grid) => {
          const pseudoStyle = window.getComputedStyle(grid, ':after');
          if (pseudoStyle && pseudoStyle.content.includes('masonry')) return true;
          return false;
        };
        const enableGrid = (grid) => {
          if (gridMap.get(grid) !== null) return;
          gridMap.set(grid, new MiniMasonry({
            container: '[data-masonry-grid="true"]',
            baseWidth: 400,
            gutter: 24,
            ultimateGutter: 16,
            minify: false,
            surroundingGutter: false
          }));
        };
        const disableGrid = (grid) => {
          if (gridMap.get(grid) === null) return;
          gridMap.get(grid).destroy();
          gridMap.set(grid, null);
        };
        masonryGrids.forEach((grid) => {
          gridMap.set(grid, null);
          grid.addEventListener('theme:masonry:change', () => {
            const instance = gridMap.get(grid);
            if (instance) instance.layout();
          });
          let enable = true;
          if (grid.getAttribute('data-masonry-watch-css') === 'true') {
            watchCssGrids.push(grid);
            if (!isCssEnabled(grid)) enable = false;
          }
          if (enable) enableGrid(grid);
        });
        if (!watchCssGrids.length) return;
        const onResize = () => {
          watchCssGrids.forEach((grid) => {
            const instance = gridMap.get(grid),
                  enable = isCssEnabled(grid);
            if (instance === null && enable) {
              enableGrid(grid);
            }
            else if (instance !== null && !enable) {
              disableGrid(grid);
            }
          });
        }
        let masonryResizeTimer = null;
        window.addEventListener('resize', () => {
          clearTimeout(masonryResizeTimer);
          masonryResizeTimer = setTimeout(onResize, 100);
        });
      }
    }, {
      key: "initSidebars",
      value: function initSidebars(container) {
        container.querySelectorAll('[data-sidebar]:not([data-sidebar="initialized"])').forEach(drawer => {
          new Drawer(drawer);
          drawer.setAttribute('data-sidebar', 'initialized');
        });
      }
    },{
      key: "initZoom",
      value: function initZoom(container) {
        const imageViewer = new ImageViewer("#zoom-dialog");

        const delegateElement = new domDelegate.Delegate(container);
        delegateElement.on('click', '[data-image-zoom="true"]', (e) => {
          const originalImageUrl = e.target.getAttribute("data-original-src");
          if (originalImageUrl) {
            imageViewer.show(originalImageUrl);
          }
        })
      }
    },{
      key: "initTimers",
      value: function(container) {
        container.querySelectorAll('[data-timer-date]:not([data-timer-initialized])').forEach(element => {
          new Timer(element);
        });
      }
    }, {
      key: "initIntercom",
      value: async function() {
        const APP_ID = "v4jaad07";
        const COOKIE_NAME = 'intercomUserJWT';
        const TOKEN_AUTH_URL = '/apps/intercom-token'

        const handleResetIntercom = () => {
          window.setCookie(COOKIE_NAME, '', '-1d');
          if (window.getCookie('intercomConversationStarted') === '1') {
            injectIntercom(true).then();
          }
        }

        document.addEventListener('customer:login', handleResetIntercom);
        document.addEventListener('customer:logout', handleResetIntercom);

        async function injectIntercom(force = false) {
          if (window.__intercomScriptInjected && !force) return;
          window.__intercomScriptInjected = true;

          (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

          let intercom_user_jwt = window.getCookie(COOKIE_NAME);
          let session_duration =  86400000; // 24 hours
          if(intercom_user_jwt) {
            session_duration = JSON.parse(intercom_user_jwt).duration;
            intercom_user_jwt = JSON.parse(intercom_user_jwt).token;
          } else {
            try {
              const name = ((window.theme.customerFirstName || '') + ' ' + (window.theme.customerLastName || '')).trim();
              const res = await fetch(`${TOKEN_AUTH_URL}?name=${name}`, {
                method: 'GET',
              })

              const json = await res.json();
              intercom_user_jwt = json.token;
              session_duration = json.duration;

              const cookie_duration = `${session_duration / 1000 / 60  / 24}d`
              window.setCookie(COOKIE_NAME, JSON.stringify({token: intercom_user_jwt, duration: cookie_duration}), cookie_duration);
            } catch (e) {
              console.log(e)
            }
          }

          window.Intercom("boot", {
            api_base: "https://api-iam.intercom.io",
            app_id: APP_ID,
            intercom_user_jwt,
            session_duration
          });
        }

        // Load Intercom if it has been used before
        if (window.getCookie('intercomConversationStarted') === '1') {
          injectIntercom().then()
        }

        function startIntercomChat(button) {
          if (button && !window.__intercomReady && window.getCookie('intercomConversationStarted') !== '1') button.classList.add('loading');

          // If already loaded or user has used Intercom before (persisted across pages), just show messenger without starting a new conversation
          if (window.__intercomReady || window.getCookie('intercomConversationStarted') === '1') {
            window.Intercom('show');
            return;
          }

          injectIntercom();

          window.Intercom('onShow', function () {
            window.__intercomReady = true;
            window.setCookie('intercomConversationStarted', '1', '7d');
            if (button) button.classList.remove('loading');
          });

          window.Intercom('showNewMessage');
        }

        document.querySelectorAll('[data-action="start-intercom-chat"]').forEach(button => {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            startIntercomChat(e.target);
          });
        });
      }
    },
      {
        key: "initCustomerLoginEvents",
        value: async function() {
          const COOKIE_NAME = 'userLoggedIn';
          const userIsLoggedIn = !!window.theme.customerId;
          const cookieUserIsLoggedIn = window.getCookie(COOKIE_NAME) === '1';

          if(userIsLoggedIn && !cookieUserIsLoggedIn) {
            document.dispatchEvent(new CustomEvent('customer:login'));
          } else if(!userIsLoggedIn && cookieUserIsLoggedIn) {
            document.dispatchEvent(new CustomEvent('customer:logout'));
          }

          window.setCookie(COOKIE_NAME, `${+userIsLoggedIn}`, '365d');
        }
      }]);

    return InitFunctions;
  }();

  (function () {
    // First, we register all plugins that are used for all pages
    new Collapsible();
    new Modal();
    new Responsive();
    new Metafields();
    new PageOverlay();
    new Localization();

    if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
      new LoadingBar();
    }

    var sections = new SectionContainer();
    sections.register('header', HeaderSection);
    sections.register('footer', FooterSection);
    sections.register('sidebar-menu', SidebarMenuSection);
    sections.register('cart', CartSection);
    sections.register('newsletter-popup', NewsletterPopupSection);

    // Sections used on index
    sections.register('slideshow', SlideshowSection);
    sections.register('featured-products', FeaturedProductsSection);

    // Sections used on product page
    sections.register('main-product', ProductSection);
    sections.register('product-recommendations', ProductRecommendationsSection);

    sections.register('featured-blog-posts', FeaturedBlogPostsSection);

    sections.register('collection', CollectionSection); // Sections used on collection page

    sections.register('article', ArticleSection); // Sections used on article page

    sections.register('faq-page', FaqPageSection); // Sections used on content pages

    sections.register('login', LoginSection); // Sections used on login page

    sections.register('addresses', AddressesSection); // Sections used on addresses page

    sections.register('gift-card', GiftCardSection); // Sections used on gift card page

    sections.register('instagram-posts', InstagramPostsSection);

    // Sections used on different pages
    sections.register('recently-viewed-products', RecentlyViewedProductsSection);
    sections.register('content-slider', ContentSliderSection);
    sections.register('video', VideoSection);
    sections.register('multi-column', MultiColumnSection);

    // Sections using global blocks
    sections.register('image-with-text', GlobalBlocksSection);
    sections.register('sales-event', GlobalBlocksSection);
    sections.register('video-with-text', GlobalBlocksSection);
    sections.register('content-blocks', GlobalBlocksSection);

    // After sections are initialized, do other global initializations
    new InitFunctions();
    new ThemeTracking();
    Accessibility.initTabbing();

    /**
     * ----------------------------------------------------------------------------
     * RTE
     * ----------------------------------------------------------------------------
     */
    (function () {
      Dom.nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(function (iframe) {
        // If the iframe is inside a code element or already in a wrapper, no wrapper is needed
        if (iframe.closest('code') || iframe.closest('.VideoWrapper')) return;
        // We scope the wrapping only for YouTube and Vimeo
        if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
          iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
          // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

          iframe.src = iframe.src;
        }
      });
    })();

    /**
     * ----------------------------------------------------------------------------
     * UTILS
     * ----------------------------------------------------------------------------
     */
    (function () {
      var documentDelegate = new domDelegate.Delegate(document.body),
          announcementBar = document.querySelector('.AnnouncementBar');
      documentDelegate.on('click', '[href*="#"], [data-href*="#"]', function (event, target) {
        var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');

        let selectorPath = null;
        if (selector.includes('#')) selectorPath = selector.split('#')[0];
        if (selectorPath && selectorPath.includes('?')) selectorPath = selectorPath.split('?')[0];
        if (selector === '#' || selector === '#main' || (selectorPath && (!selectorPath.includes(location.pathname) || location.pathname === window.Shopify.routes.root && selectorPath !== window.Shopify.routes.root))) {
          return;
        }

        if (selector.includes('#') && selector.charAt(0) !== '#') selector = `#${selector.split('#')[1]}`;

        var element = document.querySelector(selector),
            offset = parseInt(target.getAttribute('data-offset') || 0);

        if (!element) return;
        
        // if (announcementBar) {
        //   offset -= announcementBar.clientHeight;
        // }

        if (target.hasAttribute('data-focus-on-click')) {
          var prevScrollY = window.pageYOffset;
          element.focus({
            preventScroll: true
          }); // hack to fix scroll jump after focus

          if (window.pageYOffset !== prevScrollY) {
            window.scrollTo(window.pageXOffset, prevScrollY);
          }

          element.focus();
        }

        history.pushState({}, '', selector);

        const getOffsetTop = (elem) => {
          let offsetTop = 0;
          while(elem) {
            offsetTop += elem.offsetTop;
            elem = elem.offsetParent;
          }
          return offsetTop;
        };

        window.scrollTo({
          behavior: 'smooth',
          top: getOffsetTop(element) - offset
        });
        event.preventDefault();
      });
    })();

    (function () {
      var windowWidth = window.innerWidth,
          headerSection = document.getElementById('shopify-section-shop-header');
      window.addEventListener('resize', function () {
        var newWidth = -1;
        fastdom.measure(function () {
          newWidth = window.innerWidth;
        });
        fastdom.mutate(function () {
          if (newWidth === windowWidth) {
            return;
          }

          windowWidth = newWidth;
          document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');

          if (headerSection) {
            document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
          }
        });
      });
    })();

  })();

})));

// Set a window variable to allow other JS to check if this JS is ready
window.themeJSReady = true;
